import React from "react";
import { act } from "react-dom/test-utils";

const IconsGen = ({ icon_name, active }) => {
  const addFav = (e) => {
    e.target.classList.toggle("active");
  };
  switch (icon_name) {
    case "instagram":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35 8.75C27.8705 8.75 26.978 8.77975 24.178 8.9075C21.3833 9.03525 19.474 9.47975 17.8045 10.129C16.0545 10.787 14.4672 11.8195 13.1547 13.1565C11.8199 14.4675 10.7868 16.0536 10.1272 17.8045C9.4815 19.474 9.03525 21.385 8.9075 24.1798C8.7815 26.978 8.75 27.8687 8.75 35C8.75 42.1312 8.77975 43.022 8.9075 45.822C9.03525 48.6167 9.47975 50.526 10.129 52.1955C10.787 53.9455 11.8195 55.5327 13.1565 56.8452C14.4675 58.1801 16.0536 59.2132 17.8045 59.8727C19.474 60.5202 21.3833 60.9647 24.178 61.0925C26.978 61.2202 27.8705 61.25 35 61.25C42.1295 61.25 43.022 61.2202 45.822 61.0925C48.6167 60.9647 50.526 60.5202 52.1955 59.871C53.9455 59.213 55.5327 58.1805 56.8452 56.8435C58.1801 55.5325 59.2132 53.9464 59.8727 52.1955C60.5202 50.526 60.9647 48.6167 61.0925 45.822C61.2202 43.022 61.25 42.1295 61.25 35C61.25 27.8705 61.2202 26.978 61.0925 24.178C60.9647 21.3833 60.5202 19.474 59.871 17.8045C59.212 16.0529 58.1788 14.4661 56.8435 13.1547C55.5325 11.8199 53.9464 10.7868 52.1955 10.1272C50.526 9.4815 48.615 9.03525 45.8203 8.9075C43.022 8.7815 42.1312 8.75 35 8.75ZM35 13.4803C42.0088 13.4803 42.84 13.5065 45.6085 13.6325C48.167 13.7498 49.5565 14.175 50.4823 14.5373C51.7072 15.0115 52.5823 15.582 53.501 16.499C54.4198 17.4178 54.9885 18.2927 55.4628 19.5177C55.8232 20.4435 56.2502 21.833 56.3675 24.3915C56.4935 27.16 56.5198 27.9912 56.5198 35C56.5198 42.0088 56.4935 42.84 56.3675 45.6085C56.2502 48.167 55.825 49.5565 55.4628 50.4823C55.0426 51.6225 54.3723 52.654 53.501 53.501C52.6541 54.3725 51.6226 55.0428 50.4823 55.4628C49.5565 55.8232 48.167 56.2502 45.6085 56.3675C42.84 56.4935 42.0105 56.5198 35 56.5198C27.9895 56.5198 27.16 56.4935 24.3915 56.3675C21.833 56.2502 20.4435 55.825 19.5177 55.4628C18.3775 55.0426 17.346 54.3723 16.499 53.501C15.6278 52.6539 14.9575 51.6224 14.5373 50.4823C14.1767 49.5565 13.7498 48.167 13.6325 45.6085C13.5065 42.84 13.4803 42.0088 13.4803 35C13.4803 27.9912 13.5065 27.16 13.6325 24.3915C13.7498 21.833 14.175 20.4435 14.5373 19.5177C15.0115 18.2927 15.582 17.4178 16.499 16.499C17.3459 15.6276 18.3775 14.9572 19.5177 14.5373C20.4435 14.1767 21.833 13.7498 24.3915 13.6325C27.16 13.5065 27.9912 13.4803 35 13.4803Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.0003 43.7589C33.8501 43.7589 32.7111 43.5323 31.6485 43.0922C30.5858 42.652 29.6203 42.0068 28.8069 41.1935C27.9936 40.3802 27.3484 39.4146 26.9083 38.3519C26.4681 37.2893 26.2416 36.1503 26.2416 35.0001C26.2416 33.8499 26.4681 32.7109 26.9083 31.6483C27.3484 30.5856 27.9936 29.6201 28.8069 28.8067C29.6203 27.9934 30.5858 27.3483 31.6485 26.9081C32.7111 26.4679 33.8501 26.2414 35.0003 26.2414C37.3233 26.2414 39.5511 27.1642 41.1937 28.8067C42.8363 30.4493 43.7591 32.6772 43.7591 35.0001C43.7591 37.3231 42.8363 39.5509 41.1937 41.1935C39.5511 42.8361 37.3233 43.7589 35.0003 43.7589ZM35.0003 21.5076C31.4219 21.5076 27.99 22.9291 25.4597 25.4595C22.9293 27.9898 21.5078 31.4217 21.5078 35.0001C21.5078 38.5786 22.9293 42.0104 25.4597 44.5408C27.99 47.0711 31.4219 48.4926 35.0003 48.4926C38.5787 48.4926 42.0106 47.0711 44.5409 44.5408C47.0713 42.0104 48.4928 38.5786 48.4928 35.0001C48.4928 31.4217 47.0713 27.9898 44.5409 25.4595C42.0106 22.9291 38.5787 21.5076 35.0003 21.5076ZM52.418 21.2626C52.418 22.1085 52.082 22.9197 51.4839 23.5178C50.8858 24.116 50.0746 24.452 49.2287 24.452C48.3828 24.452 47.5716 24.116 46.9735 23.5178C46.3753 22.9197 46.0393 22.1085 46.0393 21.2626C46.0393 20.4167 46.3753 19.6055 46.9735 19.0074C47.5716 18.4093 48.3828 18.0732 49.2287 18.0732C50.0746 18.0732 50.8858 18.4093 51.4839 19.0074C52.082 19.6055 52.418 20.4167 52.418 21.2626Z"
            fill="white"
          />
        </svg>
      );
    case "facebook":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M64.1663 35.1766C64.1663 18.9697 51.1094 5.83301 34.9997 5.83301C18.89 5.83301 5.83301 18.9697 5.83301 35.1766C5.83301 49.8261 16.4963 61.9652 30.4419 64.1663V43.6602H23.0375V35.1747H30.4419V28.7113C30.4419 21.3575 34.7955 17.2936 41.4591 17.2936C44.648 17.2936 47.9886 17.8672 47.9886 17.8672V25.0888H44.3077C40.6852 25.0888 39.5575 27.3522 39.5575 29.6738V35.1766H47.6463L46.3533 43.6583H39.5575V64.1663C53.503 61.9652 64.1663 49.8261 64.1663 35.1766Z"
            fill="white"
          />
        </svg>
      );
    case "uploadExcelTaager":
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.7501 11.044C23.3179 9.31637 22.3209 7.78264 20.9174 6.68638C19.5139 5.59011 17.7844 4.99414 16.0036 4.9931C14.2227 4.99207 12.4925 5.58603 11.0878 6.68067C9.68304 7.77531 8.68427 9.30787 8.25006 11.035C6.20189 11.2272 4.30648 12.2011 2.95755 13.7542C1.60862 15.3074 0.909845 17.3205 1.00638 19.3754C1.10291 21.4303 1.98734 23.3691 3.47593 24.7889C4.96453 26.2088 6.94289 27.0006 9.00006 27H12.0001C12.2653 27 12.5196 26.8946 12.7072 26.7071C12.8947 26.5196 13.0001 26.2652 13.0001 26C13.0001 25.7348 12.8947 25.4804 12.7072 25.2929C12.5196 25.1054 12.2653 25 12.0001 25H9.00006C8.21213 25.0023 7.43146 24.8494 6.70263 24.55C5.97379 24.2506 5.31107 23.8105 4.75229 23.255C3.62379 22.1331 2.9872 20.6088 2.98256 19.0175C2.97792 17.4262 3.60561 15.8982 4.72754 14.7697C5.84948 13.6412 7.37376 13.0046 8.96506 13C9.22165 13.0193 9.47627 12.9426 9.67952 12.7848C9.88277 12.627 10.0202 12.3994 10.0651 12.146C10.2687 10.7181 10.9806 9.41153 12.0702 8.46634C13.1597 7.52115 14.5537 7.00077 15.9961 7.00077C17.4384 7.00077 18.8324 7.52115 19.9219 8.46634C21.0115 9.41153 21.7234 10.7181 21.9271 12.146C21.9794 12.3906 22.1149 12.6094 22.3106 12.7652C22.5063 12.9209 22.75 13.0039 23.0001 13C24.5914 13 26.1175 13.6321 27.2427 14.7574C28.3679 15.8826 29.0001 17.4087 29.0001 19C29.0001 20.5913 28.3679 22.1174 27.2427 23.2426C26.1175 24.3679 24.5914 25 23.0001 25H20.0001C19.7348 25 19.4805 25.1054 19.2929 25.2929C19.1054 25.4804 19.0001 25.7348 19.0001 26C19.0001 26.2652 19.1054 26.5196 19.2929 26.7071C19.4805 26.8946 19.7348 27 20.0001 27H23.0001C25.0422 26.9786 26.9988 26.1771 28.469 24.7596C29.9392 23.3421 30.8116 21.416 30.9075 19.3761C31.0034 17.3361 30.3155 15.3367 28.9847 13.7875C27.654 12.2384 25.7812 11.2568 23.7501 11.044Z"
            fill="white"
          />
          <path
            d="M20.293 19.707C20.4816 19.8892 20.7342 19.99 20.9964 19.9877C21.2586 19.9854 21.5095 19.8803 21.6949 19.6948C21.8803 19.5094 21.9854 19.2586 21.9877 18.9964C21.99 18.7342 21.8892 18.4816 21.707 18.293L16.707 13.293C16.5195 13.1056 16.2652 13.0002 16 13.0002C15.7349 13.0002 15.4806 13.1056 15.293 13.293L10.293 18.293C10.1109 18.4816 10.0101 18.7342 10.0124 18.9964C10.0146 19.2586 10.1198 19.5094 10.3052 19.6948C10.4906 19.8803 10.7414 19.9854 11.0036 19.9877C11.2658 19.99 11.5184 19.8892 11.707 19.707L15 16.414V29C15 29.2652 15.1054 29.5196 15.2929 29.7071C15.4805 29.8947 15.7348 30 16 30C16.2653 30 16.5196 29.8947 16.7071 29.7071C16.8947 29.5196 17 29.2652 17 29V16.414L20.293 19.707Z"
            fill="white"
          />
        </svg>
      );
    case "downloadExcelTaager":
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.638 1.22937C17.41 1.04137 17.108 0.963372 16.816 1.01737L0.816 4.01737C0.342 4.10537 0 4.51737 0 4.99937V26.9994C0 27.4794 0.342 27.8934 0.816 27.9814L16.816 30.9814C16.876 30.9934 16.94 30.9994 17 30.9994C17.23 30.9994 17.458 30.9194 17.638 30.7694C17.868 30.5794 18 30.2954 18 29.9994V1.99937C18 1.70137 17.868 1.41937 17.638 1.22937ZM16 28.7934L2 26.1694V5.82937L16 3.20537V28.7934Z"
            fill="white"
          />
          <path
            d="M31 4.99939H17C16.448 4.99939 16 5.44739 16 5.99939C16 6.55139 16.448 6.99939 17 6.99939H30V24.9994H17C16.448 24.9994 16 25.4474 16 25.9994C16 26.5514 16.448 26.9994 17 26.9994H31C31.552 26.9994 32 26.5514 32 25.9994V5.99939C32 5.44739 31.552 4.99939 31 4.99939Z"
            fill="white"
          />
          <path
            d="M21 8.99939H17C16.448 8.99939 16 9.44739 16 9.99939C16 10.5514 16.448 10.9994 17 10.9994H21C21.552 10.9994 22 10.5514 22 9.99939C22 9.44739 21.552 8.99939 21 8.99939Z"
            fill="white"
          />
          <path
            d="M21 12.9994H17C16.448 12.9994 16 13.4474 16 13.9994C16 14.5514 16.448 14.9994 17 14.9994H21C21.552 14.9994 22 14.5514 22 13.9994C22 13.4474 21.552 12.9994 21 12.9994Z"
            fill="white"
          />
          <path
            d="M21 16.9994H17C16.448 16.9994 16 17.4474 16 17.9994C16 18.5514 16.448 18.9994 17 18.9994H21C21.552 18.9994 22 18.5514 22 17.9994C22 17.4474 21.552 16.9994 21 16.9994Z"
            fill="white"
          />
          <path
            d="M21 20.9994H17C16.448 20.9994 16 21.4474 16 21.9994C16 22.5514 16.448 22.9994 17 22.9994H21C21.552 22.9994 22 22.5514 22 21.9994C22 21.4474 21.552 20.9994 21 20.9994Z"
            fill="white"
          />
          <path
            d="M27 8.99939H25C24.448 8.99939 24 9.44739 24 9.99939C24 10.5514 24.448 10.9994 25 10.9994H27C27.552 10.9994 28 10.5514 28 9.99939C28 9.44739 27.552 8.99939 27 8.99939Z"
            fill="white"
          />
          <path
            d="M27 12.9994H25C24.448 12.9994 24 13.4474 24 13.9994C24 14.5514 24.448 14.9994 25 14.9994H27C27.552 14.9994 28 14.5514 28 13.9994C28 13.4474 27.552 12.9994 27 12.9994Z"
            fill="white"
          />
          <path
            d="M27 16.9994H25C24.448 16.9994 24 17.4474 24 17.9994C24 18.5514 24.448 18.9994 25 18.9994H27C27.552 18.9994 28 18.5514 28 17.9994C28 17.4474 27.552 16.9994 27 16.9994Z"
            fill="white"
          />
          <path
            d="M27 20.9994H25C24.448 20.9994 24 21.4474 24 21.9994C24 22.5514 24.448 22.9994 25 22.9994H27C27.552 22.9994 28 22.5514 28 21.9994C28 21.4474 27.552 20.9994 27 20.9994Z"
            fill="white"
          />
          <path
            d="M13.7537 19.3414L6.75372 11.3414C6.38572 10.9234 5.75572 10.8834 5.34172 11.2474C4.92572 11.6114 4.88372 12.2434 5.24772 12.6574L12.2477 20.6574C12.4457 20.8834 12.7217 20.9994 12.9997 20.9994C13.2337 20.9994 13.4677 20.9174 13.6597 20.7514C14.0757 20.3874 14.1177 19.7574 13.7537 19.3414Z"
            fill="white"
          />
          <path
            d="M13.614 10.2114C13.178 9.86939 12.55 9.95139 12.21 10.3854L5.21003 19.3854C4.87203 19.8214 4.95003 20.4514 5.38603 20.7894C5.57003 20.9314 5.78603 20.9994 6.00003 20.9994C6.29603 20.9994 6.59203 20.8674 6.78803 20.6154L13.788 11.6154C14.128 11.1774 14.05 10.5494 13.614 10.2114Z"
            fill="white"
          />
        </svg>
      );
    case "downloadExcelTaager2":
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.638 1.22937C17.41 1.04137 17.108 0.963372 16.816 1.01737L0.816 4.01737C0.342 4.10537 0 4.51737 0 4.99937V26.9994C0 27.4794 0.342 27.8934 0.816 27.9814L16.816 30.9814C16.876 30.9934 16.94 30.9994 17 30.9994C17.23 30.9994 17.458 30.9194 17.638 30.7694C17.868 30.5794 18 30.2954 18 29.9994V1.99937C18 1.70137 17.868 1.41937 17.638 1.22937ZM16 28.7934L2 26.1694V5.82937L16 3.20537V28.7934Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M31 4.99939H17C16.448 4.99939 16 5.44739 16 5.99939C16 6.55139 16.448 6.99939 17 6.99939H30V24.9994H17C16.448 24.9994 16 25.4474 16 25.9994C16 26.5514 16.448 26.9994 17 26.9994H31C31.552 26.9994 32 26.5514 32 25.9994V5.99939C32 5.44739 31.552 4.99939 31 4.99939Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M21 8.99939H17C16.448 8.99939 16 9.44739 16 9.99939C16 10.5514 16.448 10.9994 17 10.9994H21C21.552 10.9994 22 10.5514 22 9.99939C22 9.44739 21.552 8.99939 21 8.99939Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M21 12.9994H17C16.448 12.9994 16 13.4474 16 13.9994C16 14.5514 16.448 14.9994 17 14.9994H21C21.552 14.9994 22 14.5514 22 13.9994C22 13.4474 21.552 12.9994 21 12.9994Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M21 16.9994H17C16.448 16.9994 16 17.4474 16 17.9994C16 18.5514 16.448 18.9994 17 18.9994H21C21.552 18.9994 22 18.5514 22 17.9994C22 17.4474 21.552 16.9994 21 16.9994Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M21 20.9994H17C16.448 20.9994 16 21.4474 16 21.9994C16 22.5514 16.448 22.9994 17 22.9994H21C21.552 22.9994 22 22.5514 22 21.9994C22 21.4474 21.552 20.9994 21 20.9994Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M27 8.99939H25C24.448 8.99939 24 9.44739 24 9.99939C24 10.5514 24.448 10.9994 25 10.9994H27C27.552 10.9994 28 10.5514 28 9.99939C28 9.44739 27.552 8.99939 27 8.99939Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M27 12.9994H25C24.448 12.9994 24 13.4474 24 13.9994C24 14.5514 24.448 14.9994 25 14.9994H27C27.552 14.9994 28 14.5514 28 13.9994C28 13.4474 27.552 12.9994 27 12.9994Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M27 16.9994H25C24.448 16.9994 24 17.4474 24 17.9994C24 18.5514 24.448 18.9994 25 18.9994H27C27.552 18.9994 28 18.5514 28 17.9994C28 17.4474 27.552 16.9994 27 16.9994Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M27 20.9994H25C24.448 20.9994 24 21.4474 24 21.9994C24 22.5514 24.448 22.9994 25 22.9994H27C27.552 22.9994 28 22.5514 28 21.9994C28 21.4474 27.552 20.9994 27 20.9994Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M13.7537 19.3414L6.75372 11.3414C6.38572 10.9234 5.75572 10.8834 5.34172 11.2474C4.92572 11.6114 4.88372 12.2434 5.24772 12.6574L12.2477 20.6574C12.4457 20.8834 12.7217 20.9994 12.9997 20.9994C13.2337 20.9994 13.4677 20.9174 13.6597 20.7514C14.0757 20.3874 14.1177 19.7574 13.7537 19.3414Z"
            fill="rgb(89, 198, 201)"
          />
          <path
            d="M13.614 10.2114C13.178 9.86939 12.55 9.95139 12.21 10.3854L5.21003 19.3854C4.87203 19.8214 4.95003 20.4514 5.38603 20.7894C5.57003 20.9314 5.78603 20.9994 6.00003 20.9994C6.29603 20.9994 6.59203 20.8674 6.78803 20.6154L13.788 11.6154C14.128 11.1774 14.05 10.5494 13.614 10.2114Z"
            fill="rgb(89, 198, 201)"
          />
        </svg>
      );
    case "Money313":
      return (
        <svg
          width="37"
          height="37"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.875 39.7998H33.5C35.125 39.7998 36.475 38.3498 36.475 36.5998C36.475 34.4248 35.7 33.9998 34.425 33.5498L31.9 32.6748V39.7998H31.875Z"
            fill="#59C6C9"
          />
          <path
            d="M29.9252 4.75004C16.1252 4.80004 4.95017 16.025 5.00017 29.825C5.05017 43.625 16.2752 54.8 30.0752 54.75C43.8752 54.7 55.0502 43.475 55.0002 29.675C54.9502 15.875 43.7252 4.72504 29.9252 4.75004ZM35.6502 30C37.6002 30.675 40.2252 32.125 40.2252 36.6C40.2252 40.45 37.2002 43.55 33.5002 43.55H31.8752V45C31.8752 46.025 31.0252 46.875 30.0002 46.875C28.9752 46.875 28.1252 46.025 28.1252 45V43.55H27.2252C23.1252 43.55 19.8002 40.1 19.8002 35.85C19.8002 34.825 20.6502 33.975 21.6752 33.975C22.7002 33.975 23.5502 34.825 23.5502 35.85C23.5502 38.025 25.2002 39.8 27.2252 39.8H28.1252V31.35L24.3502 30C22.4002 29.325 19.7752 27.875 19.7752 23.4C19.7752 19.55 22.8002 16.45 26.5002 16.45H28.1252V15C28.1252 13.975 28.9752 13.125 30.0002 13.125C31.0252 13.125 31.8752 13.975 31.8752 15V16.45H32.7752C36.8752 16.45 40.2002 19.9 40.2002 24.15C40.2002 25.175 39.3502 26.025 38.3252 26.025C37.3002 26.025 36.4502 25.175 36.4502 24.15C36.4502 21.975 34.8002 20.2 32.7752 20.2H31.8752V28.65L35.6502 30Z"
            fill="#59C6C9"
          />
          <path
            d="M23.5469 23.4252C23.5469 25.6002 24.3219 26.0252 25.5969 26.4752L28.1219 27.3502V20.2002H26.4969C24.8719 20.2002 23.5469 21.6502 23.5469 23.4252Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "settings":
      return (
        <svg
          fill="rgb(89, 198, 201)"
          height="30px"
          width="30px"
          version="1.1"
          id="Capa_1"
          viewBox="0 0 489.802 489.802"
        >
          <g>
            <path
              d="M20.701,281.901l32.1,0.2c4.8,24.7,14.3,48.7,28.7,70.5l-22.8,22.6c-8.2,8.1-8.2,21.2-0.2,29.4l24.6,24.9
            c8.1,8.2,21.2,8.2,29.4,0.2l22.8-22.6c21.6,14.6,45.5,24.5,70.2,29.5l-0.2,32.1c-0.1,11.5,9.2,20.8,20.7,20.9l35,0.2
            c11.5,0.1,20.8-9.2,20.9-20.7l0.2-32.1c24.7-4.8,48.7-14.3,70.5-28.7l22.6,22.8c8.1,8.2,21.2,8.2,29.4,0.2l24.9-24.6
            c8.2-8.1,8.2-21.2,0.2-29.4l-22.6-22.8c14.6-21.6,24.5-45.5,29.5-70.2l32.1,0.2c11.5,0.1,20.8-9.2,20.9-20.7l0.2-35
            c0.1-11.5-9.2-20.8-20.7-20.9l-32.1-0.2c-4.8-24.7-14.3-48.7-28.7-70.5l22.8-22.6c8.2-8.1,8.2-21.2,0.2-29.4l-24.6-24.9
            c-8.1-8.2-21.2-8.2-29.4-0.2l-22.8,22.6c-21.6-14.6-45.5-24.5-70.2-29.5l0.2-32.1c0.1-11.5-9.2-20.8-20.7-20.9l-35-0.2
            c-11.5-0.1-20.8,9.2-20.9,20.7l-0.3,32.1c-24.8,4.8-48.8,14.3-70.5,28.7l-22.6-22.8c-8.1-8.2-21.2-8.2-29.4-0.2l-24.8,24.6
            c-8.2,8.1-8.2,21.2-0.2,29.4l22.6,22.8c-14.6,21.6-24.5,45.5-29.5,70.2l-32.1-0.2c-11.5-0.1-20.8,9.2-20.9,20.7l-0.2,35
            C-0.099,272.401,9.201,281.801,20.701,281.901z M179.301,178.601c36.6-36.2,95.5-35.9,131.7,0.7s35.9,95.5-0.7,131.7
            s-95.5,35.9-131.7-0.7S142.701,214.801,179.301,178.601z"
            />
          </g>
        </svg>
      );
    case "linkOutside":
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="30px"
          height="30px"
          viewBox="0 0 512 512"
          enable-background="new 0 0 512 512"
        >
          <path
            fill="rgb(89, 198, 201)"
            d="M459.654,233.373l-90.531,90.5c-49.969,50-131.031,50-181,0c-7.875-7.844-14.031-16.688-19.438-25.813
	l42.063-42.063c2-2.016,4.469-3.172,6.828-4.531c2.906,9.938,7.984,19.344,15.797,27.156c24.953,24.969,65.563,24.938,90.5,0
	l90.5-90.5c24.969-24.969,24.969-65.563,0-90.516c-24.938-24.953-65.531-24.953-90.5,0l-32.188,32.219
	c-26.109-10.172-54.25-12.906-81.641-8.891l68.578-68.578c50-49.984,131.031-49.984,181.031,0
	C509.623,102.342,509.623,183.389,459.654,233.373z M220.326,382.186l-32.203,32.219c-24.953,24.938-65.563,24.938-90.516,0
	c-24.953-24.969-24.953-65.563,0-90.531l90.516-90.5c24.969-24.969,65.547-24.969,90.5,0c7.797,7.797,12.875,17.203,15.813,27.125
	c2.375-1.375,4.813-2.5,6.813-4.5l42.063-42.047c-5.375-9.156-11.563-17.969-19.438-25.828c-49.969-49.984-131.031-49.984-181.016,0
	l-90.5,90.5c-49.984,50-49.984,131.031,0,181.031c49.984,49.969,131.031,49.969,181.016,0l68.594-68.594
	C274.561,395.092,246.42,392.342,220.326,382.186z"
          />
        </svg>
      );
    case "shoppingCart":
      return (
        <svg
          width="33"
          height="33"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.625 56.25C43.0412 56.25 45 54.2912 45 51.875C45 49.4588 43.0412 47.5 40.625 47.5C38.2088 47.5 36.25 49.4588 36.25 51.875C36.25 54.2912 38.2088 56.25 40.625 56.25Z"
            fill="#59C6C9"
          />
          <path
            d="M20.625 56.25C23.0412 56.25 25 54.2912 25 51.875C25 49.4588 23.0412 47.5 20.625 47.5C18.2088 47.5 16.25 49.4588 16.25 51.875C16.25 54.2912 18.2088 56.25 20.625 56.25Z"
            fill="#59C6C9"
          />
          <path
            d="M12.1 9.85L11.6 15.975C11.5 17.15 12.425 18.125 13.6 18.125H51.875C52.925 18.125 53.8 17.325 53.875 16.275C54.2 11.85 50.825 8.25 46.4 8.25H15.675C15.425 7.15 14.925 6.1 14.15 5.225C12.9 3.9 11.15 3.125 9.35 3.125H5C3.975 3.125 3.125 3.975 3.125 5C3.125 6.025 3.975 6.875 5 6.875H9.35C10.125 6.875 10.85 7.2 11.375 7.75C11.9 8.325 12.15 9.075 12.1 9.85Z"
            fill="#59C6C9"
          />
          <path
            d="M51.2751 21.875H12.9251C11.8751 21.875 11.0251 22.675 10.9251 23.7L10.0251 34.575C9.67513 38.85 13.0251 42.5 17.3001 42.5H45.1001C48.8501 42.5 52.1501 39.425 52.4251 35.675L53.2501 24C53.3501 22.85 52.4501 21.875 51.2751 21.875Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "ordersPhone":
      return (
        <svg
          width="33"
          height="33"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.0031 13.2752L29.8781 5.6752C28.3781 4.8752 26.6031 4.8752 25.1031 5.6752L11.0031 13.2752C9.97813 13.8502 9.32812 14.9502 9.32812 16.1502C9.32812 17.3752 9.95313 18.4752 11.0031 19.0252L25.1281 26.6252C25.8781 27.0252 26.7031 27.2252 27.5031 27.2252C28.3031 27.2252 29.1531 27.0252 29.8781 26.6252L44.0031 19.0252C45.0281 18.4752 45.6781 17.3752 45.6781 16.1502C45.6781 14.9502 45.0281 13.8502 44.0031 13.2752Z"
            fill="#59C6C9"
          />
          <path
            d="M22.8 29.2755L9.675 22.7255C8.65 22.2005 7.5 22.2755 6.525 22.8505C5.575 23.4505 5 24.4755 5 25.6005V38.0005C5 40.1505 6.2 42.0755 8.125 43.0505L21.25 49.6005C21.7 49.8255 22.2 49.9505 22.7 49.9505C23.275 49.9505 23.875 49.7755 24.4 49.4755C25.35 48.8755 25.925 47.8505 25.925 46.7255V34.3255C25.9 32.1755 24.7 30.2505 22.8 29.2755Z"
            fill="#59C6C9"
          />
          <path
            d="M50.0016 25.6005V31.7505C48.8016 31.4005 47.5266 31.2505 46.2516 31.2505C42.8516 31.2505 39.5266 32.4255 36.9016 34.5255C33.3016 37.3505 31.2516 41.6255 31.2516 46.2505C31.2516 47.4755 31.4016 48.7005 31.7266 49.8755C31.3516 49.8255 30.9766 49.6755 30.6266 49.4505C29.6766 48.8755 29.1016 47.8505 29.1016 46.7255V34.3255C29.1016 32.1755 30.3016 30.2505 32.2016 29.2755L45.3266 22.7255C46.3516 22.2005 47.5016 22.2755 48.4766 22.8505C49.4266 23.4505 50.0016 24.4755 50.0016 25.6005Z"
            fill="#59C6C9"
          />
          <path
            d="M54.95 39.1748C52.9 36.6498 49.775 35.0498 46.25 35.0498C43.6 35.0498 41.15 35.9748 39.225 37.5248C36.625 39.5748 35 42.7498 35 46.2998C35 48.3998 35.6 50.3998 36.625 52.0998C37.3 53.2248 38.15 54.1998 39.15 54.9998H39.175C41.1 56.5998 43.575 57.5498 46.25 57.5498C49.1 57.5498 51.675 56.4998 53.65 54.7498C54.525 53.9998 55.275 53.0998 55.875 52.0998C56.9 50.3998 57.5 48.3998 57.5 46.2998C57.5 43.5998 56.55 41.0998 54.95 39.1748ZM51.9 44.8998L45.9 50.4498C45.55 50.7748 45.075 50.9498 44.625 50.9498C44.15 50.9498 43.675 50.7748 43.3 50.3998L40.525 47.6248C39.8 46.8998 39.8 45.6998 40.525 44.9748C41.25 44.2498 42.45 44.2498 43.175 44.9748L44.675 46.4748L49.35 42.1498C50.1 41.4498 51.3 41.4998 52 42.2498C52.725 43.0248 52.675 44.1998 51.9 44.8998Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "home":
      return (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M27.22 9.59327L19.54 4.21994C17.4467 2.75327 14.2333 2.83327 12.22 4.39327L5.53999 9.6066C4.20665 10.6466 3.15332 12.7799 3.15332 14.4599V23.6599C3.15332 27.0599 5.91332 29.8333 9.31332 29.8333H23.6867C27.0867 29.8333 29.8467 27.0733 29.8467 23.6733V14.6333C29.8467 12.8333 28.6867 10.6199 27.22 9.59327Z"
            fill="#F3A837"
          />
          <path
            d="M16.5 25.5C15.9533 25.5 15.5 25.0467 15.5 24.5V20.5C15.5 19.9533 15.9533 19.5 16.5 19.5C17.0467 19.5 17.5 19.9533 17.5 20.5V24.5C17.5 25.0467 17.0467 25.5 16.5 25.5Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "defaultLogo":
      return (
        <svg
          height="38px"
          width="38px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 503.467 503.467"
        >
          <g transform="translate(1 1)">
            <path
              style={{ fill: "#FF7474" }}
              d="M498.2,37.4v152.747c-5.973-0.853-11.947-4.267-17.067-7.68c-10.24-7.68-17.067-20.48-17.067-34.133
		V3.267C482.84,3.267,498.2,18.627,498.2,37.4z M208.067,3.267v145.067c0,23.893-18.773,42.667-42.667,42.667
		c-23.893,0-42.667-18.773-42.667-42.667V3.267H208.067z M378.733,3.267v145.067c0,23.893-18.773,42.667-42.667,42.667
		S293.4,172.227,293.4,148.333V3.267H378.733z M37.4,3.267v145.067c0,13.653-6.827,26.453-17.067,34.133
		c-5.12,3.413-11.093,6.827-17.067,7.68V37.4C3.267,18.627,18.627,3.267,37.4,3.267z"
            />
            <path
              style={{ fill: "#ECF4F7" }}
              d="M481.133,182.467V344.6h-460.8V182.467c10.24-7.68,17.067-20.48,17.067-34.133
		C37.4,172.227,56.173,191,80.067,191s42.667-18.773,42.667-42.667c0,23.893,18.773,42.667,42.667,42.667
		c23.893,0,42.667-18.773,42.667-42.667c0,23.893,18.773,42.667,42.667,42.667s42.667-18.773,42.667-42.667
		c0,23.893,18.773,42.667,42.667,42.667s42.667-18.773,42.667-42.667c0,23.893,18.773,42.667,42.667,42.667
		s42.667-18.773,42.667-42.667C464.067,161.987,470.893,174.787,481.133,182.467"
            />
            <path
              style={{ fill: "#50DD8E" }}
              d="M122.733,3.267v145.067c0,23.893-18.773,42.667-42.667,42.667S37.4,172.227,37.4,148.333V3.267
		H122.733z M293.4,3.267v145.067c0,23.893-18.773,42.667-42.667,42.667s-42.667-18.773-42.667-42.667V3.267H293.4z M464.067,3.267
		v145.067c0,23.893-18.773,42.667-42.667,42.667s-42.667-18.773-42.667-42.667V3.267H464.067z"
            />
            <polygon
              style={{ fill: "#FFD0A1" }}
              points="481.133,344.6 481.133,481.133 429.933,481.133 71.533,481.133 20.333,481.133 
		20.333,344.6 	"
            />
            <path
              style={{ fill: "#AE938D" }}
              d="M165.4,250.733l-12.8,93.013v0.853H93.72v-0.853l-13.653-93.013c0,0,8.533-17.067,42.667-17.067
		S165.4,250.733,165.4,250.733"
            />
            <path
              style={{ fill: "#50DD8E" }}
              d="M429.933,310.467c0-9.387-7.68-17.067-17.067-17.067s-17.067,7.68-17.067,17.067H429.933z
		 M361.667,310.467c0-9.387-7.68-17.067-17.067-17.067s-17.067,7.68-17.067,17.067H361.667z M293.4,310.467
		c0-9.387-7.68-17.067-17.067-17.067s-17.067,7.68-17.067,17.067H293.4z M395.8,259.267c0-9.387-7.68-17.067-17.067-17.067
		c-9.387,0-17.067,7.68-17.067,17.067H395.8z M327.533,259.267c0-9.387-7.68-17.067-17.067-17.067s-17.067,7.68-17.067,17.067
		H327.533z"
            />
          </g>
          <path
            style={{ fill: "#51565F" }}
            d="M430.933,503.467c-2.56,0-4.267-1.707-4.267-4.267v-17.067c0-2.56,1.707-4.267,4.267-4.267h46.933
	v-128h-422.4c-2.56,0-4.267-1.707-4.267-4.267c0-2.56,1.707-4.267,4.267-4.267h426.667c2.56,0,4.267,1.707,4.267,4.267v136.533
	c0,2.56-1.707,4.267-4.267,4.267H435.2v12.8C435.2,501.76,433.493,503.467,430.933,503.467z M72.533,503.467
	c-2.56,0-4.267-1.707-4.267-4.267v-12.8H21.333c-2.56,0-4.267-1.707-4.267-4.267V221.867c0-2.56,1.707-4.267,4.267-4.267
	s4.267,1.707,4.267,4.267v256h46.933c2.56,0,4.267,1.707,4.267,4.267V499.2C76.8,501.76,75.093,503.467,72.533,503.467z
	 M396.8,486.4H106.667c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267H396.8c2.56,0,4.267,1.707,4.267,4.267
	S399.36,486.4,396.8,486.4z M157.867,315.733L157.867,315.733c-2.56,0-4.267-2.56-4.267-5.12l8.533-58.027
	c-2.56-3.413-11.947-13.653-38.4-13.653s-35.84,10.24-38.4,13.653l8.533,58.027c0,2.56-1.707,4.267-3.413,5.12
	c-2.56,0-4.267-1.707-5.12-3.413L76.8,252.587c0-0.853,0-1.707,0-2.56c0-0.853,10.24-19.627,46.08-19.627s46.08,18.773,46.08,19.627
	c0,0.853,0.853,1.707,0,2.56l-8.533,59.733C162.133,314.027,159.573,315.733,157.867,315.733z M482.133,315.733
	c-2.56,0-4.267-1.707-4.267-4.267v-89.6c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267v89.6
	C486.4,314.027,484.693,315.733,482.133,315.733z M430.933,315.733c-2.56,0-4.267-1.707-4.267-4.267c0-6.827-5.973-12.8-12.8-12.8
	s-12.8,5.973-12.8,12.8c0,2.56-1.707,4.267-4.267,4.267s-4.267-1.707-4.267-4.267c0-11.947,9.387-21.333,21.333-21.333
	c11.947,0,21.333,9.387,21.333,21.333C435.2,314.027,433.493,315.733,430.933,315.733z M362.667,315.733
	c-2.56,0-4.267-1.707-4.267-4.267c0-6.827-5.973-12.8-12.8-12.8s-12.8,5.973-12.8,12.8c0,2.56-1.707,4.267-4.267,4.267
	s-4.267-1.707-4.267-4.267c0-11.947,9.387-21.333,21.333-21.333c11.947,0,21.333,9.387,21.333,21.333
	C366.933,314.027,365.227,315.733,362.667,315.733z M294.4,315.733c-2.56,0-4.267-1.707-4.267-4.267c0-6.827-5.973-12.8-12.8-12.8
	s-12.8,5.973-12.8,12.8c0,2.56-1.707,4.267-4.267,4.267S256,314.027,256,311.467c0-11.947,9.387-21.333,21.333-21.333
	s21.333,9.387,21.333,21.333C298.667,314.027,296.96,315.733,294.4,315.733z M123.733,315.733c-2.56,0-4.267-1.707-4.267-4.267
	v-34.133c0-2.56,1.707-4.267,4.267-4.267c2.56,0,4.267,1.707,4.267,4.267v34.133C128,314.027,126.293,315.733,123.733,315.733z
	 M396.8,264.533c-2.56,0-4.267-1.707-4.267-4.267c0-6.827-5.973-12.8-12.8-12.8c-6.827,0-12.8,5.973-12.8,12.8
	c0,2.56-1.707,4.267-4.267,4.267s-4.267-1.707-4.267-4.267c0-11.947,9.387-21.333,21.333-21.333
	c11.947,0,21.333,9.387,21.333,21.333C401.067,262.827,399.36,264.533,396.8,264.533z M328.533,264.533
	c-2.56,0-4.267-1.707-4.267-4.267c0-6.827-5.973-12.8-12.8-12.8s-12.8,5.973-12.8,12.8c0,2.56-1.707,4.267-4.267,4.267
	s-4.267-1.707-4.267-4.267c0-11.947,9.387-21.333,21.333-21.333c11.947,0,21.333,9.387,21.333,21.333
	C332.8,262.827,331.093,264.533,328.533,264.533z M422.4,196.267c-18.773,0-34.987-11.093-42.667-27.307
	c-7.68,16.213-23.893,27.307-42.667,27.307S302.08,185.173,294.4,168.96c-7.68,16.213-23.893,27.307-42.667,27.307
	s-34.987-11.093-42.667-27.307c-7.68,16.213-23.893,27.307-42.667,27.307c-18.773,0-34.987-11.093-42.667-27.307
	c-7.68,16.213-23.893,27.307-42.667,27.307S46.08,185.173,38.4,168.96C32.427,182.613,20.48,192,5.12,195.413
	c-0.853,0-2.56,0-3.413-0.853S0,192.853,0,191.147V38.4C0,17.067,17.067,0,38.4,0h426.667c21.333,0,38.4,17.067,38.4,38.4v152.747
	c0,0.853-0.853,2.56-1.707,3.413c-0.853,0.853-2.56,0.853-3.413,0.853c-15.36-3.413-27.307-12.8-33.28-26.453
	C457.387,185.173,441.173,196.267,422.4,196.267z M384,149.333c0,21.333,17.067,38.4,38.4,38.4s38.4-17.067,38.4-38.4V38.4
	c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267v110.933c0,16.213,10.24,30.72,25.6,35.84V38.4
	c0-16.213-13.653-29.867-29.867-29.867H38.4C22.187,8.533,8.533,22.187,8.533,38.4v146.773c15.36-5.12,25.6-19.627,25.6-35.84V38.4
	c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267v110.933c0,21.333,17.067,38.4,38.4,38.4s38.4-17.067,38.4-38.4V38.4
	c0-2.56,1.707-4.267,4.267-4.267c2.56,0,4.267,1.707,4.267,4.267v110.933c0,21.333,17.067,38.4,38.4,38.4s38.4-17.067,38.4-38.4
	V38.4c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267v110.933c0,21.333,17.067,38.4,38.4,38.4s38.4-17.067,38.4-38.4V38.4
	c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267v110.933c0,21.333,17.067,38.4,38.4,38.4s38.4-17.067,38.4-38.4V38.4
	c0-2.56,1.707-4.267,4.267-4.267c2.56,0,4.267,1.707,4.267,4.267V149.333z"
          />
        </svg>
      );
    case "gall":
      return (
        <svg
          fill="rgba(89, 198, 201, 1)"
          height="25px"
          width="25px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <g>
            <g>
              <path
                d="M494.933,38.4h-409.6c-9.412,0-17.067,7.654-17.067,17.067v17.067H51.2c-9.412,0-17.067,7.654-17.067,17.067v17.067
			H17.067C7.654,106.667,0,114.321,0,123.733v332.8c0,9.412,7.654,17.067,17.067,17.067h409.6c9.412,0,17.067-7.654,17.067-17.067
			v-17.067H460.8c9.412,0,17.067-7.654,17.067-17.067v-17.067h17.067c9.412,0,17.067-7.654,17.067-17.067v-332.8
			C512,46.054,504.346,38.4,494.933,38.4z M17.067,123.733h409.6l0.009,190.635l-44.783-51.183c-3.251-3.721-9.6-3.721-12.851,0
			l-54.067,61.79L167.799,194.159c-3.234-2.884-8.098-2.884-11.332,0L17.067,318.071V123.733z M426.684,431.01v25.523H17.067V340.89
			l145.067-128.947l147.934,131.49c1.69,1.51,3.942,2.193,6.204,2.142c2.278-0.145,4.395-1.186,5.888-2.901l53.308-60.911
			l51.209,58.53l0.008,90.573c0,0.017-0.017,0.043-0.017,0.068S426.684,430.985,426.684,431.01z M460.8,422.4h-17.067V123.733
			c0-9.412-7.654-17.067-17.067-17.067H51.2V89.6h409.6V422.4z M494.933,388.267h-17.067V89.6c0-9.412-7.654-17.067-17.067-17.067
			H85.333V55.467h409.6V388.267z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M307.2,174.933c-18.825,0-34.133,15.309-34.133,34.133S288.375,243.2,307.2,243.2s34.133-15.309,34.133-34.133
			S326.025,174.933,307.2,174.933z M307.2,226.133c-9.412,0-17.067-7.654-17.067-17.067c0-9.412,7.654-17.067,17.067-17.067
			s17.067,7.654,17.067,17.067C324.267,218.479,316.612,226.133,307.2,226.133z"
              />
            </g>
          </g>
        </svg>
      );
    case "trophy":
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 512 512"
          enable-background="new 0 0 512 512"
        >
          <path
            fill="#FFCA1F"
            opacity="1.000000"
            stroke="none"
            d=" M105.000000,0.999999   C155.354233,1.000000 205.708450,1.000000 256.538086,1.468620   C257.031799,22.976053 257.050140,44.014866 257.002808,65.251656   C256.937195,65.449631 256.847809,65.857071 256.421570,65.881897   C241.548370,66.144608 231.956970,73.461746 226.408813,86.440697   C223.990952,92.096840 221.820404,97.865845 219.740616,103.656532   C218.614487,106.791954 216.637192,107.996933 213.372086,108.067848   C207.401047,108.197540 201.434174,108.600029 195.470428,108.967926   C182.051147,109.795731 172.292877,116.399315 167.410553,128.779984   C162.284943,141.777603 164.188507,154.075180 174.622375,164.086670   C180.007706,169.253998 186.038528,173.745239 191.493927,178.845505   C192.736908,180.007568 193.604584,182.583664 193.275879,184.236664   C191.947281,190.917999 190.201706,197.525452 188.390747,204.099762   C185.448273,214.781876 190.117157,229.212570 198.850845,235.904587   C212.324371,246.228439 225.507446,246.554489 240.434067,237.062637   C245.889603,233.593445 251.481750,230.339050 257.075623,227.201508   C257.139679,227.416382 257.266357,227.846542 257.206299,228.321320   C257.104462,245.094177 257.042633,261.392212 257.024689,277.690308   C256.972870,324.757660 256.938690,371.824982 256.440460,418.923767   C216.041183,418.968018 176.099014,418.994385 136.156921,418.948090   C134.409988,418.946045 132.663818,418.278290 131.068298,417.583069   C135.659012,404.605103 143.442963,394.437927 154.472916,386.950043   C166.529282,378.765442 179.186615,371.426117 190.902237,362.795624   C197.217529,358.143372 203.770050,352.412567 207.244781,345.643433   C212.077881,336.228088 209.623688,325.529266 202.772751,317.700043   C194.622452,308.385956 184.960968,300.368744 175.707993,292.063995   C173.554733,290.131378 170.531754,288.716675 167.686386,288.113312   C163.546783,287.235535 159.199539,287.370575 154.950912,286.967590   C137.183685,285.282440 120.280922,280.248932 104.123764,272.919159   C77.428047,260.808533 55.184162,243.006058 37.214912,219.755768   C19.091105,196.305496 7.574061,170.100494 2.947651,140.832077   C2.837648,140.136154 1.672825,139.606964 0.999999,139.000000   C1.000000,106.312439 1.000000,73.624878 1.233810,40.804771   C6.924977,33.261204 14.610908,32.779263 23.017246,32.907719   C45.819679,33.256157 68.630936,33.027237 91.438698,33.027237   C93.201385,33.027237 94.964081,33.027237 96.993279,33.027237   C96.993279,26.953148 97.018555,21.483446 96.986191,16.014086   C96.953697,10.520874 99.256889,6.285601 103.655914,3.064214   C104.275536,2.610469 104.560257,1.699391 105.000000,0.999999  M124.129547,247.654114   C124.664345,247.674316 125.199150,247.694519 125.733948,247.714737   C125.400139,247.268173 125.066322,246.821594 124.268990,245.851715   C119.436058,238.017975 113.913376,230.519379 109.910980,222.282074   C101.046288,204.037735 97.040657,184.509064 97.006821,164.219498   C96.954323,132.735016 96.993202,101.250374 96.993340,69.765793   C96.993347,67.978104 96.993340,66.190414 96.993340,64.210594   C74.829529,64.210594 53.106766,64.210594 30.112219,64.210594   C31.063517,86.441513 31.896013,108.395248 32.979206,130.336594   C33.709503,145.129562 38.763985,158.836624 44.666893,172.185562   C53.824741,192.895309 67.446503,210.255920 85.006065,224.575104   C96.783211,234.178955 109.567924,241.969727 124.129547,247.654114  z"
          />
          <path
            fill="#FFAA3F"
            opacity="1.000000"
            stroke="none"
            d=" M257.068451,65.053680   C257.050140,44.014866 257.031799,22.976053 257.006714,1.468620   C307.354218,1.000000 357.708466,1.000000 408.204681,1.251022   C411.467102,4.544715 416.103485,6.463392 416.025330,12.348194   C416.020447,66.591049 416.024597,120.356583 416.017090,174.568329   C415.673187,178.432068 415.347992,181.850311 415.007477,185.267029   C413.822876,197.152969 410.596100,208.555710 405.240448,219.132645   C400.500397,228.493835 394.655182,237.295425 389.079590,246.536469   C388.703094,247.067169 388.544800,247.405441 388.386536,247.743729   C388.949066,247.522705 389.511627,247.301697 390.450409,247.037903   C417.809479,236.254944 439.555969,218.841812 456.260742,195.181671   C470.665039,174.779816 479.151276,151.911774 481.782227,127.212280   C483.268311,113.260895 482.715546,99.087746 482.977661,85.012558   C483.106537,78.092659 483.000000,71.168381 483.000000,64.109093   C460.600616,64.109093 438.825562,64.109093 417.037842,63.633942   C417.032715,53.068970 417.040222,42.979149 417.511169,32.937721   C442.713470,32.990749 467.454498,33.179596 492.189880,32.889664   C499.777740,32.800724 506.642212,33.341309 511.579224,39.958145   C511.755280,40.194088 512.513245,39.995865 513.000000,40.000000   C513.000000,72.687561 513.000000,105.375122 512.675354,138.192459   C511.912689,138.986191 511.171112,139.611603 511.081207,140.319748   C508.957336,157.045792 503.646729,172.839600 496.459320,187.952362   C483.636292,214.915039 464.963043,237.088455 440.822083,254.739471   C412.741425,275.271088 381.426514,286.396606 346.696198,288.050171   C344.811157,288.139923 342.481750,288.395966 341.170837,289.520630   C331.889496,297.483246 322.116119,305.041931 313.851166,313.979279   C301.940552,326.858826 300.049316,345.937439 316.241333,357.627380   C325.830048,364.550049 335.813049,370.946564 345.805420,377.285522   C361.912231,387.503357 376.439301,399.070923 383.048187,418.186493   C383.001190,418.619843 382.984528,418.793549 382.501221,418.971558   C340.375183,419.002686 298.715790,419.029541 257.016479,419.015564   C256.976624,418.974731 256.897614,418.892334 256.897583,418.892334   C256.938690,371.824982 256.972870,324.757660 257.024689,277.690308   C257.042633,261.392212 257.104462,245.094177 257.544891,228.379303   C258.990784,228.442062 260.100006,228.820450 261.075165,229.417801   C267.032776,233.067291 272.756744,237.155991 278.933716,240.379425   C301.647644,252.232635 328.000153,233.605072 325.924011,211.204544   C325.270447,204.153107 323.596191,197.165268 321.991547,190.240463   C319.763641,180.625900 319.753601,180.848740 327.408661,174.646149   C332.796478,170.280670 338.444550,165.902802 342.668549,160.506699   C350.501038,150.500809 351.228607,138.943878 346.084991,127.480568   C341.250641,116.706512 332.647034,110.305275 320.721405,108.998100   C315.448151,108.420090 310.127930,108.213623 304.822510,108.001068   C299.054810,107.770012 294.258087,106.734222 292.762817,99.800392   C291.863403,95.629471 289.575012,91.773865 288.094971,87.709511   C282.809784,73.195824 272.044373,66.259293 257.068451,65.053680  z"
          />

          <path
            fill="#344779"
            opacity="1.000000"
            stroke="none"
            d=" M56.468658,513.000000   C55.065147,511.564240 54.305363,509.968292 53.164265,508.721252   C48.889153,504.049408 47.492279,497.604462 49.923130,492.255493   C52.684776,486.178589 57.047195,482.611115 64.164307,482.947754   C69.454948,483.197968 74.768311,482.968140 81.003830,482.961914   C116.193825,482.981140 150.451553,482.974945 184.709244,483.005310   C208.820114,483.026703 232.930954,483.097839 257.027466,483.606018   C257.008759,493.710175 257.004364,503.355103 257.000000,513.000000   C190.312439,513.000000 123.624878,513.000000 56.468658,513.000000  z"
          />
          <path
            fill="#0C1638"
            opacity="1.000000"
            stroke="none"
            d=" M257.468658,513.000000   C257.004364,503.355103 257.008759,493.710175 257.051392,483.527130   C257.089661,482.988983 256.966644,482.879211 257.434448,482.930115   C316.247284,482.963745 374.592285,482.946533 432.937286,482.929321   C438.408081,482.952393 443.878876,482.989716 449.349670,482.994995   C456.423950,483.001831 461.565674,486.012360 463.741180,491.455811   C466.601990,498.613983 465.193054,504.897034 459.601471,509.975006   C458.757324,510.741608 457.950867,511.549713 457.063477,512.669312   C390.645782,513.000000 324.291534,513.000000 257.468658,513.000000  z"
          />

          <path
            fill="#FFAA3F"
            opacity="1.000000"
            stroke="none"
            d=" M257.065735,483.067871   C232.930954,483.097839 208.820114,483.026703 184.709244,483.005310   C150.451553,482.974945 116.193825,482.981140 81.470032,482.909424   C81.002632,466.579498 80.996498,450.311890 81.001801,434.044281   C81.004990,424.266937 87.235649,418.045044 97.128738,418.008514   C108.084312,417.968048 119.040138,417.993317 130.456573,417.955322   C132.663818,418.278290 134.409988,418.946045 136.156921,418.948090   C176.099014,418.994385 216.041183,418.968018 256.440491,418.923767   C256.897614,418.892334 256.976624,418.974731 256.997681,419.477600   C257.001373,440.946686 256.984009,461.912964 256.966644,482.879211   C256.966644,482.879211 257.089661,482.988983 257.065735,483.067871  z"
          />
          <path
            fill="#FF8A53"
            opacity="1.000000"
            stroke="none"
            d=" M257.002808,65.251656   C272.044373,66.259293 282.809784,73.195824 288.094971,87.709511   C289.575012,91.773865 291.863403,95.629471 292.762817,99.800392   C294.258087,106.734222 299.054810,107.770012 304.822510,108.001068   C310.127930,108.213623 315.448151,108.420090 320.721405,108.998100   C332.647034,110.305275 341.250641,116.706512 346.084991,127.480568   C351.228607,138.943878 350.501038,150.500809 342.668549,160.506699   C338.444550,165.902802 332.796478,170.280670 327.408661,174.646149   C319.753601,180.848740 319.763641,180.625900 321.991547,190.240463   C323.596191,197.165268 325.270447,204.153107 325.924011,211.204544   C328.000153,233.605072 301.647644,252.232635 278.933716,240.379425   C272.756744,237.155991 267.032776,233.067291 261.075165,229.417801   C260.100006,228.820450 258.990784,228.442062 257.604919,227.904510   C257.266357,227.846542 257.139679,227.416382 257.071960,226.734207   C257.002319,202.928650 257.018463,179.805267 256.994049,156.681900   C256.962067,126.406944 256.898041,96.132011 256.847809,65.857071   C256.847809,65.857071 256.937195,65.449631 257.002808,65.251656  z"
          />
          <path
            fill="#FFAA3F"
            opacity="1.000000"
            stroke="none"
            d=" M256.421570,65.881897   C256.898041,96.132011 256.962067,126.406944 256.994049,156.681900   C257.018463,179.805267 257.002319,202.928650 257.007874,226.519348   C251.481750,230.339050 245.889603,233.593445 240.434067,237.062637   C225.507446,246.554489 212.324371,246.228439 198.850845,235.904587   C190.117157,229.212570 185.448273,214.781876 188.390747,204.099762   C190.201706,197.525452 191.947281,190.917999 193.275879,184.236664   C193.604584,182.583664 192.736908,180.007568 191.493927,178.845505   C186.038528,173.745239 180.007706,169.253998 174.622375,164.086670   C164.188507,154.075180 162.284943,141.777603 167.410553,128.779984   C172.292877,116.399315 182.051147,109.795731 195.470428,108.967926   C201.434174,108.600029 207.401047,108.197540 213.372086,108.067848   C216.637192,107.996933 218.614487,106.791954 219.740616,103.656532   C221.820404,97.865845 223.990952,92.096840 226.408813,86.440697   C231.956970,73.461746 241.548370,66.144608 256.421570,65.881897  z"
          />

          <path
            fill="#FF8A53"
            opacity="1.000000"
            stroke="none"
            d=" M257.434448,482.930115   C256.984009,461.912964 257.001373,440.946686 257.037567,419.518433   C298.715790,419.029541 340.375183,419.002686 382.973358,418.981750   C396.312927,418.977325 408.713745,418.966980 421.114563,418.956635   C427.818176,420.138580 432.973938,426.023590 432.989868,432.714508   C433.029053,449.145081 432.997375,465.575775 432.965729,482.467865   C374.592285,482.946533 316.247284,482.963745 257.434448,482.930115  z"
          />

          <path
            fill="#FFB732"
            opacity="1.000000"
            stroke="none"
            d=" M417.037842,63.633942   C417.034729,98.804428 417.022308,133.499756 416.993622,168.195084   C416.992096,170.013535 416.852356,171.831894 416.402893,173.886200   C416.024597,120.356583 416.020447,66.591049 416.025330,12.348194   C416.356262,16.614311 416.715118,21.355671 416.982208,26.102190   C417.091888,28.051342 417.003693,30.011629 417.026611,32.428085   C417.040222,42.979149 417.032715,53.068970 417.037842,63.633942  z"
          />
          <path
            fill="#FF9749"
            opacity="1.000000"
            stroke="none"
            d=" M420.877167,418.585815   C408.713745,418.966980 396.312927,418.977325 383.440002,418.977478   C382.984528,418.793549 383.001190,418.619843 383.048187,418.186493   C395.598907,418.022919 408.119354,418.118988 420.877167,418.585815  z"
          />
        </svg>
      );
    case "onestar":
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 512 512"
          enable-background="new 0 0 512 512"
        >
          <path
            fill="#FFFFFF"
            opacity="1.000000"
            stroke="none"
            d="
M251.000000,513.000000 
	C167.708771,513.000000 84.417557,513.000000 1.063166,513.000000 
	C1.063166,342.333344 1.063166,171.666672 1.063166,1.000000 
	C35.430687,1.000000 69.746681,1.000000 104.383766,1.345050 
	C91.319008,4.375327 80.721786,19.187551 80.785110,32.719696 
	C81.200539,121.492546 80.998718,210.268265 81.006920,299.043060 
	C81.007103,301.038208 81.108009,303.033386 81.090263,305.490479 
	C81.012108,329.923584 80.901230,353.895325 81.036095,377.865692 
	C81.125038,393.674316 88.222527,406.124817 101.040817,414.905823 
	C116.404449,425.430359 132.270508,435.219177 147.860672,445.415771 
	C182.259857,467.914185 216.622467,490.468475 251.000000,513.000000 
z"
          />
          <path
            fill="#FFFFFF"
            opacity="1.000000"
            stroke="none"
            d="
M409.000000,0.999998 
	C443.649139,1.000000 478.298309,1.000000 512.973755,1.000000 
	C512.973755,171.562927 512.973755,342.125854 512.973755,513.000000 
	C429.979370,513.000000 346.958344,513.000000 263.563599,512.653931 
	C264.364410,511.765869 265.624817,511.356781 266.700745,510.661987 
	C283.829956,499.601349 300.952423,488.530029 318.042816,477.409546 
	C348.555359,457.555450 379.073914,437.710327 409.532898,417.774261 
	C425.297119,407.456268 433.152740,393.142700 433.109894,373.899933 
	C432.878845,270.103943 433.001434,166.307175 432.993744,62.510662 
	C432.993622,60.681942 432.890350,58.853230 432.908081,56.559357 
	C432.987579,46.972282 433.290253,37.838070 432.912201,28.732121 
	C432.576477,20.646536 428.864136,13.816428 422.445404,8.950174 
	C418.323608,5.825264 413.505829,3.618381 409.000000,0.999998 
z"
          />
          <path
            fill="#2E4961"
            opacity="1.000000"
            stroke="none"
            d="
M408.555847,0.999998 
	C413.505829,3.618381 418.323608,5.825264 422.445404,8.950174 
	C428.864136,13.816428 432.576477,20.646536 432.912201,28.732121 
	C433.290253,37.838070 432.987579,46.972282 432.519958,56.553185 
	C421.838715,58.584953 417.001923,64.235062 417.001465,74.667595 
	C416.996948,173.459595 416.872467,272.251923 417.146912,371.043182 
	C417.184296,384.498016 412.479553,393.727997 401.060333,401.188690 
	C357.949799,429.354736 315.305298,458.233337 272.406799,486.725403 
	C262.879639,493.053101 257.593750,501.578064 257.000000,513.000000 
	C255.285645,513.000000 253.571289,513.000000 251.428467,513.000000 
	C216.622467,490.468475 182.259857,467.914185 147.860672,445.415771 
	C132.270508,435.219177 116.404449,425.430359 101.040817,414.905823 
	C88.222527,406.124817 81.125038,393.674316 81.036095,377.865692 
	C80.901230,353.895325 81.012108,329.923584 81.476852,305.479614 
	C92.080360,303.374237 96.996368,297.611694 96.996925,287.291290 
	C97.001465,203.326523 96.998688,119.361763 97.000717,35.397003 
	C97.001015,22.918371 102.898994,17.001051 115.337761,17.000763 
	C204.800217,16.998688 294.262665,17.003086 383.725128,16.994402 
	C393.963501,16.993408 400.273560,11.117692 401.000000,1.000000 
	C403.370575,1.000000 405.741119,1.000000 408.555847,0.999998 
M264.660950,447.524628 
	C262.153442,444.506744 259.645966,441.488861 257.155121,438.491058 
	C253.294907,442.751617 249.894241,447.277008 245.714432,450.904724 
	C241.395554,454.653137 236.319641,457.529327 231.036697,461.156647 
	C239.661133,466.438812 248.335495,471.751556 257.731171,477.104156 
	C266.118713,471.733978 274.506256,466.363831 282.497711,461.247284 
	C276.313507,456.620361 270.638306,452.374268 264.660950,447.524628 
M358.136475,52.181938 
	C351.918732,39.004910 341.236084,33.021770 326.962189,33.012165 
	C280.826630,32.981121 234.687851,33.317711 188.556931,32.854168 
	C168.285873,32.650475 153.643738,46.246639 152.934921,64.731407 
	C152.735245,69.938072 149.910278,72.741577 144.675507,72.939987 
	C126.410545,73.632309 112.615532,88.138206 112.852692,108.611847 
	C113.342667,150.910995 112.990150,193.219772 113.007866,235.524597 
	C113.011978,245.347778 113.111076,255.170914 113.029198,265.923096 
	C113.019867,301.737061 113.049004,337.551147 112.969223,373.364960 
	C112.952988,380.656799 115.830002,386.090790 121.949341,390.061401 
	C151.216690,409.051819 180.427734,428.128998 209.700638,447.110840 
	C210.991089,447.947632 212.760223,448.729218 214.188156,448.556885 
	C221.781921,447.640411 228.614609,444.717133 234.488419,439.768158 
	C243.660217,432.040527 248.172455,422.028473 248.968567,410.157196 
	C249.373581,404.118195 253.106247,400.361908 257.902802,401.148804 
	C262.768158,401.946991 264.774841,405.265106 265.064423,409.980927 
	C265.673553,419.899261 268.673492,428.860779 276.161072,436.677734 
	C281.918610,440.200226 287.493774,444.082214 293.494202,447.125946 
	C297.911255,449.366547 302.290741,448.823395 306.907257,445.755798 
	C334.597168,427.356354 362.438782,409.180573 390.429108,391.241150 
	C397.953247,386.418854 401.121155,380.324768 401.103394,371.407623 
	C400.930237,284.429260 401.000305,197.450439 400.991669,110.471733 
	C400.991516,108.642845 400.878723,106.813965 400.923065,104.161461 
	C399.464874,86.338684 388.135132,74.782471 370.454376,73.083733 
	C363.698578,72.434647 361.741211,70.248444 360.833984,63.413593 
	C360.361542,59.854366 359.140686,56.394478 358.136475,52.181938 
M376.111481,56.280533 
	C376.375916,56.693905 376.546234,57.331024 376.918640,57.487698 
	C384.903564,60.846889 392.911133,64.152275 400.698853,67.378830 
	C400.698853,56.710438 400.698853,45.031891 400.698853,33.362740 
	C388.745453,33.362740 377.099365,33.362740 366.625580,33.362740 
	C369.712097,40.683746 372.833954,48.088665 376.111481,56.280533 
M140.308289,47.958164 
	C142.984268,43.085503 145.660248,38.212845 148.348083,33.318573 
	C136.687958,33.318573 124.994675,33.318573 113.409409,33.318573 
	C113.409409,45.282810 113.409409,56.921680 113.409409,68.132324 
	C118.678947,65.357269 123.528458,61.627571 128.975327,60.235867 
	C135.620056,58.538105 139.331528,55.414078 140.308289,47.958164 
z"
          />
          <path
            fill="#44637F"
            opacity="1.000000"
            stroke="none"
            d="
M400.531342,1.000000 
	C400.273560,11.117692 393.963501,16.993408 383.725128,16.994402 
	C294.262665,17.003086 204.800217,16.998688 115.337761,17.000763 
	C102.898994,17.001051 97.001015,22.918371 97.000717,35.397003 
	C96.998688,119.361763 97.001465,203.326523 96.996925,287.291290 
	C96.996368,297.611694 92.080360,303.374237 81.548523,305.017670 
	C81.108009,303.033386 81.007103,301.038208 81.006920,299.043060 
	C80.998718,210.268265 81.200539,121.492546 80.785110,32.719696 
	C80.721786,19.187551 91.319008,4.375327 104.852425,1.345050 
	C203.354233,1.000000 301.708466,1.000000 400.531342,1.000000 
z"
          />
          <path
            fill="#123247"
            opacity="1.000000"
            stroke="none"
            d="
M257.428467,513.000000 
	C257.593750,501.578064 262.879639,493.053101 272.406799,486.725403 
	C315.305298,458.233337 357.949799,429.354736 401.060333,401.188690 
	C412.479553,393.727997 417.184296,384.498016 417.146912,371.043182 
	C416.872467,272.251923 416.996948,173.459595 417.001465,74.667595 
	C417.001923,64.235062 421.838715,58.584953 432.447083,57.018341 
	C432.890350,58.853230 432.993622,60.681942 432.993744,62.510662 
	C433.001434,166.307175 432.878845,270.103943 433.109894,373.899933 
	C433.152740,393.142700 425.297119,407.456268 409.532898,417.774261 
	C379.073914,437.710327 348.555359,457.555450 318.042816,477.409546 
	C300.952423,488.530029 283.829956,499.601349 266.700745,510.661987 
	C265.624817,511.356781 264.364410,511.765869 263.094940,512.653931 
	C261.285645,513.000000 259.571289,513.000000 257.428467,513.000000 
z"
          />
          <path
            fill="#FFCB5B"
            opacity="1.000000"
            stroke="none"
            d="
M275.870575,436.066132 
	C268.673492,428.860779 265.673553,419.899261 265.064423,409.980927 
	C264.774841,405.265106 262.768158,401.946991 257.902802,401.148804 
	C253.106247,400.361908 249.373581,404.118195 248.968567,410.157196 
	C248.172455,422.028473 243.660217,432.040527 234.488419,439.768158 
	C228.614609,444.717133 221.781921,447.640411 214.188156,448.556885 
	C212.760223,448.729218 210.991089,447.947632 209.700638,447.110840 
	C180.427734,428.128998 151.216690,409.051819 121.949341,390.061401 
	C115.830002,386.090790 112.952988,380.656799 112.969223,373.364960 
	C113.049004,337.551147 113.019867,301.737061 113.553101,265.460510 
	C116.409203,264.998627 118.764954,264.784393 121.069572,265.036926 
	C131.482605,266.177673 137.368332,259.340393 137.164490,249.201614 
	C136.662323,224.223618 136.972977,199.228668 137.016296,174.240646 
	C137.029953,166.364716 140.932709,161.627716 147.662308,161.006149 
	C157.157990,160.129089 160.991516,156.011566 160.996429,146.616470 
	C161.006439,127.458939 160.996201,108.301392 161.353592,89.053276 
	C165.658707,88.239487 168.268524,86.011353 168.841736,81.986282 
	C169.390137,78.135574 167.374802,75.476021 164.515320,73.386551 
	C173.023743,61.055714 184.540817,56.753288 198.948349,56.861996 
	C247.197037,57.226028 295.450928,57.116962 343.700531,56.820366 
	C348.560852,56.790493 353.405792,54.259823 358.257874,52.889725 
	C359.140686,56.394478 360.361542,59.854366 360.833984,63.413593 
	C361.741211,70.248444 363.698578,72.434647 370.454376,73.083733 
	C388.135132,74.782471 399.464874,86.338684 400.417786,104.577621 
	C397.413422,104.995895 394.914398,104.994446 392.415344,105.000725 
	C381.289551,105.028664 377.001831,109.292084 377.000702,120.336967 
	C376.998352,143.161636 377.024384,165.986343 376.984985,188.810928 
	C376.973083,195.699661 372.788025,200.394974 366.351746,200.993942 
	C356.837494,201.879364 353.008026,205.983185 353.003571,215.370270 
	C352.992615,238.528137 353.025391,261.686035 352.984253,284.843842 
	C352.971985,291.752411 348.982666,296.194336 342.319519,296.996368 
	C332.686462,298.155914 329.023407,302.285065 329.005127,312.093750 
	C328.983093,323.922546 329.565979,335.787415 328.817352,347.568695 
	C328.234253,356.744873 326.865723,366.059601 324.350677,374.886597 
	C318.566193,395.188721 307.150208,412.138306 290.812805,425.570679 
	C286.124725,429.425140 280.867065,432.586792 275.870575,436.066132 
M223.005539,283.030548 
	C223.003250,283.863281 223.087509,284.706970 222.984131,285.526947 
	C222.466492,289.632416 223.119934,293.980194 227.208725,295.137604 
	C230.262589,296.002075 234.380768,294.994965 237.440338,293.567780 
	C244.348511,290.345398 251.307999,286.922180 257.468048,282.496887 
	C263.279785,278.321869 267.833466,279.259705 273.282745,282.703857 
	C280.150391,287.044464 287.322083,290.932190 294.523315,294.708862 
	C301.538269,298.387848 307.034851,294.783539 306.977234,286.760803 
	C306.963013,284.786499 306.740173,282.795837 306.418976,280.844696 
	C304.996948,272.206116 303.293427,263.606018 302.188293,254.928772 
	C301.919159,252.815750 302.934570,249.927750 304.381927,248.312225 
	C311.032013,240.889435 317.969238,233.717285 324.962128,226.611343 
	C327.959961,223.565048 330.848755,219.950195 328.210754,216.199982 
	C326.367279,213.579269 322.110901,212.655869 319.242218,210.291672 
	C322.894073,203.307007 320.799530,198.535980 313.257690,196.953735 
	C310.890656,196.457153 308.438843,196.364548 305.232086,195.898392 
	C297.863739,194.696686 290.454285,193.690704 283.155273,192.158661 
	C281.279541,191.764954 279.047302,190.070282 278.182373,188.363403 
	C273.675537,179.469650 269.467865,170.419525 265.346680,161.337341 
	C263.654205,157.607468 261.462891,154.432144 257.148865,154.308716 
	C252.541992,154.176926 250.199692,157.516083 248.439072,161.363739 
	C244.635101,169.677078 240.349915,177.795166 237.017105,186.289566 
	C235.092850,191.193970 231.858124,192.451340 227.272766,193.031326 
	C218.384460,194.155548 209.478149,195.351349 200.725937,197.208557 
	C198.066483,197.772873 194.532425,200.205017 193.852737,202.506393 
	C193.100281,205.054047 194.771210,208.622467 196.121277,211.387756 
	C197.166992,213.529694 199.343323,215.119659 201.007553,217.785751 
	C201.250900,219.559448 200.850769,221.918823 201.843948,223.010040 
	C207.512131,229.237625 213.512192,235.163147 219.332535,242.047928 
	C218.191956,250.039856 217.051392,258.031769 215.400055,266.575012 
	C215.183456,267.868774 214.995804,269.168182 214.745377,270.455353 
	C213.421234,277.261322 216.154633,281.136169 223.005539,283.030548 
M350.330627,88.443619 
	C355.794373,89.286011 359.419006,87.485703 360.573608,83.116371 
	C361.654297,79.026596 360.093781,75.893555 356.431213,73.930016 
	C352.874298,72.023109 348.550354,73.300346 346.353180,76.714211 
	C343.780975,80.710754 344.902649,84.638634 350.330627,88.443619 
M264.850037,378.156250 
	C264.422852,371.461731 260.011444,367.640411 254.675156,369.448334 
	C250.933609,370.716003 248.905090,373.481476 249.116928,377.404419 
	C249.328857,381.329163 251.648834,384.002014 255.502518,384.701721 
	C260.125061,385.541016 263.130676,383.237732 264.850037,378.156250 
z"
          />
          <path
            fill="#F7B84E"
            opacity="1.000000"
            stroke="none"
            d="
M276.015808,436.371948 
	C280.867065,432.586792 286.124725,429.425140 290.812805,425.570679 
	C307.150208,412.138306 318.566193,395.188721 324.350677,374.886597 
	C326.865723,366.059601 328.234253,356.744873 328.817352,347.568695 
	C329.565979,335.787415 328.983093,323.922546 329.005127,312.093750 
	C329.023407,302.285065 332.686462,298.155914 342.319519,296.996368 
	C348.982666,296.194336 352.971985,291.752411 352.984253,284.843842 
	C353.025391,261.686035 352.992615,238.528137 353.003571,215.370270 
	C353.008026,205.983185 356.837494,201.879364 366.351746,200.993942 
	C372.788025,200.394974 376.973083,195.699661 376.984985,188.810928 
	C377.024384,165.986343 376.998352,143.161636 377.000702,120.336967 
	C377.001831,109.292084 381.289551,105.028664 392.415344,105.000725 
	C394.914398,104.994446 397.413422,104.995895 400.365479,104.989433 
	C400.878723,106.813965 400.991516,108.642845 400.991669,110.471733 
	C401.000305,197.450439 400.930237,284.429260 401.103394,371.407623 
	C401.121155,380.324768 397.953247,386.418854 390.429108,391.241150 
	C362.438782,409.180573 334.597168,427.356354 306.907257,445.755798 
	C302.290741,448.823395 297.911255,449.366547 293.494202,447.125946 
	C287.493774,444.082214 281.918610,440.200226 276.015808,436.371948 
z"
          />
          <path
            fill="#FFDB6F"
            opacity="1.000000"
            stroke="none"
            d="
M358.197174,52.535831 
	C353.405792,54.259823 348.560852,56.790493 343.700531,56.820366 
	C295.450928,57.116962 247.197037,57.226028 198.948349,56.861996 
	C184.540817,56.753288 173.023743,61.055714 164.160736,73.294266 
	C157.714127,72.821556 154.116180,74.966965 153.198624,79.526093 
	C152.282150,84.079941 155.032974,87.473732 160.994308,89.143852 
	C160.996201,108.301392 161.006439,127.458939 160.996429,146.616470 
	C160.991516,156.011566 157.157990,160.129089 147.662308,161.006149 
	C140.932709,161.627716 137.029953,166.364716 137.016296,174.240646 
	C136.972977,199.228668 136.662323,224.223618 137.164490,249.201614 
	C137.368332,259.340393 131.482605,266.177673 121.069572,265.036926 
	C118.764954,264.784393 116.409203,264.998627 113.621735,264.996033 
	C113.111076,255.170914 113.011978,245.347778 113.007866,235.524597 
	C112.990150,193.219772 113.342667,150.910995 112.852692,108.611847 
	C112.615532,88.138206 126.410545,73.632309 144.675507,72.939987 
	C149.910278,72.741577 152.735245,69.938072 152.934921,64.731407 
	C153.643738,46.246639 168.285873,32.650475 188.556931,32.854168 
	C234.687851,33.317711 280.826630,32.981121 326.962189,33.012165 
	C341.236084,33.021770 351.918732,39.004910 358.197174,52.535831 
z"
          />
          <path
            fill="#FDCA5B"
            opacity="1.000000"
            stroke="none"
            d="
M376.033630,55.887058 
	C372.833954,48.088665 369.712097,40.683746 366.625580,33.362740 
	C377.099365,33.362740 388.745453,33.362740 400.698853,33.362740 
	C400.698853,45.031891 400.698853,56.710438 400.698853,67.378830 
	C392.911133,64.152275 384.903564,60.846889 376.918640,57.487698 
	C376.546234,57.331024 376.375916,56.693905 376.033630,55.887058 
z"
          />
          <path
            fill="#FDDA6F"
            opacity="1.000000"
            stroke="none"
            d="
M140.174438,48.324730 
	C139.331528,55.414078 135.620056,58.538105 128.975327,60.235867 
	C123.528458,61.627571 118.678947,65.357269 113.409409,68.132324 
	C113.409409,56.921680 113.409409,45.282810 113.409409,33.318573 
	C124.994675,33.318573 136.687958,33.318573 148.348083,33.318573 
	C145.660248,38.212845 142.984268,43.085503 140.174438,48.324730 
z"
          />
          <path
            fill="#FBC95B"
            opacity="1.000000"
            stroke="none"
            d="
M257.009857,477.064301 
	C248.335495,471.751556 239.661133,466.438812 231.036697,461.156647 
	C236.319641,457.529327 241.395554,454.653137 245.714432,450.904724 
	C249.894241,447.277008 253.294907,442.751617 257.155121,438.491058 
	C259.645966,441.488861 262.153442,444.506744 264.777710,448.178955 
	C260.707031,457.808167 256.721680,466.839447 257.009857,477.064301 
z"
          />
          <path
            fill="#F4B64F"
            opacity="1.000000"
            stroke="none"
            d="
M257.370514,477.084229 
	C256.721680,466.839447 260.707031,457.808167 264.928772,448.480774 
	C270.638306,452.374268 276.313507,456.620361 282.497711,461.247284 
	C274.506256,466.363831 266.118713,471.733978 257.370514,477.084229 
z"
          />
          <path
            fill="#FFFFFE"
            opacity="1.000000"
            stroke="none"
            d="
M215.910812,266.023712 
	C217.051392,258.031769 218.191956,250.039856 219.552017,241.290298 
	C219.406372,238.531784 219.725327,235.899323 218.560043,234.637222 
	C212.931412,228.540909 206.903412,222.813324 201.017059,216.954987 
	C199.343323,215.119659 197.166992,213.529694 196.121277,211.387756 
	C194.771210,208.622467 193.100281,205.054047 193.852737,202.506393 
	C194.532425,200.205017 198.066483,197.772873 200.725937,197.208557 
	C209.478149,195.351349 218.384460,194.155548 227.272766,193.031326 
	C231.858124,192.451340 235.092850,191.193970 237.017105,186.289566 
	C240.349915,177.795166 244.635101,169.677078 248.439072,161.363739 
	C250.199692,157.516083 252.541992,154.176926 257.148865,154.308716 
	C261.462891,154.432144 263.654205,157.607468 265.346680,161.337341 
	C269.467865,170.419525 273.675537,179.469650 278.182373,188.363403 
	C279.047302,190.070282 281.279541,191.764954 283.155273,192.158661 
	C290.454285,193.690704 297.863739,194.696686 305.589478,196.330383 
	C299.807465,203.484421 293.812317,210.346130 287.483185,216.884521 
	C282.366425,222.170425 281.312164,228.161209 282.476868,235.165131 
	C283.938202,243.953049 285.179474,252.803192 285.915497,261.676270 
	C286.340546,266.800995 283.270172,269.375854 278.107727,268.916595 
	C275.892334,268.719482 273.632294,267.763184 271.626160,266.707733 
	C265.164368,263.308167 258.806366,259.710815 252.417755,256.172791 
	C245.966537,252.600128 239.792465,253.377029 233.532257,256.908539 
	C227.776184,260.155670 221.793594,263.001221 215.910812,266.023712 
z"
          />
          <path
            fill="#DEDFE0"
            opacity="1.000000"
            stroke="none"
            d="
M215.655426,266.299377 
	C221.793594,263.001221 227.776184,260.155670 233.532257,256.908539 
	C239.792465,253.377029 245.966537,252.600128 252.417755,256.172791 
	C258.806366,259.710815 265.164368,263.308167 271.626160,266.707733 
	C273.632294,267.763184 275.892334,268.719482 278.107727,268.916595 
	C283.270172,269.375854 286.340546,266.800995 285.915497,261.676270 
	C285.179474,252.803192 283.938202,243.953049 282.476868,235.165131 
	C281.312164,228.161209 282.366425,222.170425 287.483185,216.884521 
	C293.812317,210.346130 299.807465,203.484421 305.986389,196.424713 
	C308.438843,196.364548 310.890656,196.457153 313.257690,196.953735 
	C320.799530,198.535980 322.894073,203.307007 318.798340,210.790436 
	C310.824036,219.063843 303.228516,226.777618 295.835144,234.680496 
	C294.760834,235.828873 293.989136,237.976669 294.206055,239.501434 
	C295.698669,249.993790 297.213135,260.500000 299.322235,270.879486 
	C300.188385,275.141968 299.362549,278.760895 295.951569,280.308228 
	C293.242920,281.536987 289.171021,281.342804 286.286011,280.247894 
	C281.358856,278.377869 276.456146,275.860809 272.309265,272.631714 
	C261.850952,264.487976 252.143936,264.738525 241.539139,272.629028 
	C236.044418,276.717377 229.233688,279.037018 223.017502,282.155701 
	C216.154633,281.136169 213.421234,277.261322 214.745377,270.455353 
	C214.995804,269.168182 215.183456,267.868774 215.655426,266.299377 
z"
          />
          <path
            fill="#F7B94F"
            opacity="1.000000"
            stroke="none"
            d="
M223.011520,282.593140 
	C229.233688,279.037018 236.044418,276.717377 241.539139,272.629028 
	C252.143936,264.738525 261.850952,264.487976 272.309265,272.631714 
	C276.456146,275.860809 281.358856,278.377869 286.286011,280.247894 
	C289.171021,281.342804 293.242920,281.536987 295.951569,280.308228 
	C299.362549,278.760895 300.188385,275.141968 299.322235,270.879486 
	C297.213135,260.500000 295.698669,249.993790 294.206055,239.501434 
	C293.989136,237.976669 294.760834,235.828873 295.835144,234.680496 
	C303.228516,226.777618 310.824036,219.063843 318.643372,211.131790 
	C322.110901,212.655869 326.367279,213.579269 328.210754,216.199982 
	C330.848755,219.950195 327.959961,223.565048 324.962128,226.611343 
	C317.969238,233.717285 311.032013,240.889435 304.381927,248.312225 
	C302.934570,249.927750 301.919159,252.815750 302.188293,254.928772 
	C303.293427,263.606018 304.996948,272.206116 306.418976,280.844696 
	C306.740173,282.795837 306.963013,284.786499 306.977234,286.760803 
	C307.034851,294.783539 301.538269,298.387848 294.523315,294.708862 
	C287.322083,290.932190 280.150391,287.044464 273.282745,282.703857 
	C267.833466,279.259705 263.279785,278.321869 257.468048,282.496887 
	C251.307999,286.922180 244.348511,290.345398 237.440338,293.567780 
	C234.380768,294.994965 230.262589,296.002075 227.208725,295.137604 
	C223.119934,293.980194 222.466492,289.632416 222.984131,285.526947 
	C223.087509,284.706970 223.003250,283.863281 223.011520,282.593140 
z"
          />
          <path
            fill="#364D5D"
            opacity="1.000000"
            stroke="none"
            d="
M161.353592,89.053276 
	C155.032974,87.473732 152.282150,84.079941 153.198624,79.526093 
	C154.116180,74.966965 157.714127,72.821556 163.819122,73.496941 
	C167.374802,75.476021 169.390137,78.135574 168.841736,81.986282 
	C168.268524,86.011353 165.658707,88.239487 161.353592,89.053276 
z"
          />
          <path
            fill="#354C5D"
            opacity="1.000000"
            stroke="none"
            d="
M349.973511,88.292450 
	C344.902649,84.638634 343.780975,80.710754 346.353180,76.714211 
	C348.550354,73.300346 352.874298,72.023109 356.431213,73.930016 
	C360.093781,75.893555 361.654297,79.026596 360.573608,83.116371 
	C359.419006,87.485703 355.794373,89.286011 349.973511,88.292450 
z"
          />
          <path
            fill="#354C5D"
            opacity="1.000000"
            stroke="none"
            d="
M264.766296,378.534302 
	C263.130676,383.237732 260.125061,385.541016 255.502518,384.701721 
	C251.648834,384.002014 249.328857,381.329163 249.116928,377.404419 
	C248.905090,373.481476 250.933609,370.716003 254.675156,369.448334 
	C260.011444,367.640411 264.422852,371.461731 264.766296,378.534302 
z"
          />
          <path
            fill="#F8BC56"
            opacity="1.000000"
            stroke="none"
            d="
M201.012299,217.370361 
	C206.903412,222.813324 212.931412,228.540909 218.560043,234.637222 
	C219.725327,235.899323 219.406372,238.531784 219.585480,240.862000 
	C213.512192,235.163147 207.512131,229.237625 201.843948,223.010040 
	C200.850769,221.918823 201.250900,219.559448 201.012299,217.370361 
z"
          />
        </svg>
      );
    case "twostar":
      return (
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="100%"
          viewBox="0 0 512 512"
          enable-background="new 0 0 512 512"
        >
          <path
            fill="#FFFFFF"
            opacity="1.000000"
            stroke="none"
            d="
   M173.000000,513.000000 
     C115.697266,513.000000 58.394531,513.000000 1.045898,513.000000 
     C1.045898,342.455017 1.045898,171.910034 1.045898,1.000000 
     C46.020237,1.000000 91.041458,1.000000 136.383850,1.345103 
     C123.223633,4.488129 113.381912,17.914202 113.143547,27.692242 
     C112.645454,48.125134 113.098068,68.581200 113.089523,89.480614 
     C113.236649,93.372665 113.145218,96.865059 113.726295,100.241722 
     C116.099731,114.033699 124.283981,124.045898 134.944672,132.470795 
     C154.523361,147.943375 174.039459,163.495422 193.539917,179.066605 
     C209.350861,191.691681 225.100632,204.393356 240.930450,217.522461 
     C240.679092,223.886841 242.012360,230.508621 239.790665,235.569946 
     C229.474808,259.070862 218.101425,282.105804 207.306366,305.400116 
     C205.757874,308.741547 203.475525,309.609741 200.236496,310.033112 
     C192.011230,311.108307 183.822098,312.458252 175.615768,313.680054 
     C163.704514,315.453400 151.784836,317.171356 139.881256,318.994537 
     C135.230865,319.706879 130.576019,320.471558 125.991478,321.512909 
     C119.174469,323.061401 114.574379,327.854889 113.240494,334.182251 
     C111.540321,342.247040 113.907417,349.785889 121.069839,355.433655 
     C128.765854,363.612854 136.254562,371.557007 143.894638,379.352783 
     C151.925064,387.546936 159.668488,396.104950 168.366882,403.532410 
     C174.004944,408.346771 173.946823,413.367035 172.815598,419.546265 
     C170.391144,432.789673 168.270981,446.088623 165.993271,459.359192 
     C164.100388,470.387512 162.312897,481.437347 160.184998,492.420715 
     C158.879425,499.159698 164.135056,508.680664 171.101013,511.364197 
     C171.822906,512.099060 172.411453,512.549561 173.000000,513.000000 
   z"
          />
          <path
            fill="#FFFFFF"
            opacity="1.000000"
            stroke="none"
            d="
   M377.000000,1.000000 
     C422.309143,1.000000 467.618286,1.000000 512.963745,1.000000 
     C512.963745,171.551407 512.963745,342.102814 512.963745,513.000000 
     C455.979584,513.000000 398.958435,513.000000 341.574341,512.649658 
     C350.283508,509.484497 354.915497,500.830231 353.189728,491.328613 
     C350.835968,478.369293 349.091980,465.300415 346.954132,452.300323 
     C345.162354,441.404816 343.327240,430.512115 341.226105,419.673431 
     C340.029480,413.500702 340.150787,408.729523 345.486938,403.602081 
     C362.726440,387.036957 379.158600,369.631531 395.902802,352.550842 
     C396.135651,352.313324 396.407257,352.109711 396.617249,351.854431 
     C401.201019,346.282623 402.934601,337.652832 399.054138,330.595154 
     C396.537445,324.685913 391.773560,322.057831 386.228790,321.070740 
     C373.765289,318.851868 361.248993,316.916718 348.729828,315.027222 
     C336.826813,313.230713 324.893097,311.637695 312.972412,309.958405 
     C309.537537,309.474518 307.478912,307.531464 306.009674,304.366730 
     C297.423706,285.872833 288.923706,267.332214 279.909607,249.046555 
     C274.886200,238.856354 271.432465,228.580750 273.343567,216.954865 
     C275.076416,215.736252 276.517395,214.682724 277.898163,213.555450 
     C289.032501,204.465500 300.108459,195.303391 311.294250,186.277298 
     C324.360596,175.733749 337.513855,165.297806 350.640503,154.829025 
     C361.468475,146.193481 372.389465,137.672501 383.127380,128.926559 
     C393.270142,120.665398 400.182404,109.901665 400.725800,96.933846 
     C401.616913,75.666481 400.882904,54.331028 400.907135,32.584133 
     C401.575684,24.206326 398.196259,17.849747 393.425568,11.813465 
     C389.078369,6.313012 383.075897,3.684701 377.000000,1.000000 
   z"
          />
          <path
            fill="#2D4961"
            opacity="1.000000"
            stroke="none"
            d="
   M376.555847,1.000000 
     C383.075897,3.684701 389.078369,6.313012 393.425568,11.813465 
     C398.196259,17.849747 401.575684,24.206326 400.518982,32.578247 
     C390.065521,34.543377 385.016815,40.269592 385.002930,50.167019 
     C384.982788,64.495636 385.068665,78.824806 384.968567,93.152763 
     C384.915588,100.736038 382.851807,107.669365 376.763062,112.699478 
     C366.158386,121.460373 355.471405,130.123154 344.744385,138.734192 
     C327.038971,152.947083 309.236023,167.038544 291.548370,181.273346 
     C280.138000,190.456253 272.844421,201.862152 273.023834,217.085800 
     C271.432465,228.580750 274.886200,238.856354 279.909607,249.046555 
     C288.923706,267.332214 297.423706,285.872833 306.009674,304.366730 
     C307.478912,307.531464 309.537537,309.474518 312.972412,309.958405 
     C324.893097,311.637695 336.826813,313.230713 348.729828,315.027222 
     C361.248993,316.916718 373.765289,318.851868 386.228790,321.070740 
     C391.773560,322.057831 396.537445,324.685913 398.656311,330.612915 
     C393.102966,331.574402 389.092102,334.188721 385.493500,337.914124 
     C371.497650,352.403107 357.326569,366.722687 343.315643,381.197235 
     C336.068146,388.684631 332.220551,397.396881 333.921295,408.146118 
     C337.461456,430.521149 340.703369,452.943787 344.325562,475.305115 
     C345.525421,482.712524 343.008545,488.507202 337.473083,492.810333 
     C332.115570,496.975189 325.489868,497.733795 319.550751,494.646912 
     C301.701630,485.369690 284.047699,475.706177 266.479034,465.904022 
     C255.824707,459.959595 245.065781,458.680023 234.183151,464.459625 
     C215.535385,474.363129 197.135483,484.732483 178.522568,494.702820 
     C170.415451,499.045563 168.755524,502.129852 170.967697,511.079803 
     C164.135056,508.680664 158.879425,499.159698 160.184998,492.420715 
     C162.312897,481.437347 164.100388,470.387512 165.993271,459.359192 
     C168.270981,446.088623 170.391144,432.789673 172.815598,419.546265 
     C173.946823,413.367035 174.004944,408.346771 168.366882,403.532410 
     C159.668488,396.104950 151.925064,387.546936 143.894638,379.352783 
     C136.254562,371.557007 128.765854,363.612854 121.087280,355.025604 
     C122.408554,344.260651 127.148216,338.833832 136.935715,337.231049 
     C154.882980,334.292084 172.841949,331.320190 190.889023,329.127136 
     C206.348221,327.248627 217.432175,320.511017 224.195923,305.961731 
     C232.120270,288.915833 241.286835,272.451599 249.597794,255.579010 
     C252.441071,249.806732 254.903564,243.713715 256.526764,237.502441 
     C259.546509,225.947250 252.429947,217.031052 240.877533,217.061050 
     C225.100632,204.393356 209.350861,191.691681 193.539917,179.066605 
     C174.039459,163.495422 154.523361,147.943375 134.944672,132.470795 
     C124.283981,124.045898 116.099731,114.033699 113.726295,100.241722 
     C113.145218,96.865059 113.236649,93.372665 113.476189,89.469223 
     C123.811562,87.422470 128.979767,81.545898 128.995621,71.810829 
     C129.015411,59.657131 128.996841,47.503384 129.001831,35.349655 
     C129.006882,23.032949 135.056992,17.001213 147.411957,17.000839 
     C215.506119,16.998775 283.600281,17.004011 351.694458,16.994703 
     C361.662750,16.993340 368.283630,10.842299 369.000000,1.000000 
     C371.370575,1.000000 373.741119,1.000000 376.555847,1.000000 
   M216.025757,33.018959 
     C205.700806,33.059277 195.375839,33.099594 184.112213,33.038223 
     C171.230515,33.038223 158.348801,33.038223 145.149170,33.038223 
     C145.149170,38.753372 145.149170,43.859123 145.045990,49.901340 
     C145.031693,63.052708 145.025879,76.204094 144.998917,89.355438 
     C144.988159,94.601334 146.472076,99.417839 150.546494,102.744217 
     C161.868469,111.987564 173.414581,120.956367 185.213058,130.619217 
     C195.764603,139.014969 206.316147,147.410721 217.281189,156.363480 
     C225.146027,162.586365 233.010880,168.809250 241.219299,175.615463 
     C246.474518,179.854721 251.729721,184.093979 257.113953,188.437332 
     C262.722931,183.740662 267.923828,179.385666 273.714874,174.733124 
     C281.520782,168.424286 289.326721,162.115448 297.738892,155.595047 
     C308.201904,147.074600 318.664917,138.554153 329.717072,129.733673 
     C340.743988,120.959778 352.077057,112.531769 362.614685,103.205070 
     C365.852814,100.339043 368.466095,95.095322 368.688660,90.801620 
     C369.409821,76.890312 368.888275,62.914593 368.961243,48.040371 
     C368.961243,43.133247 368.961243,38.226124 368.961243,33.144352 
     C355.116089,33.144352 342.021301,33.144352 328.002625,33.025551 
     C317.683746,33.063782 307.364838,33.102016 296.112427,33.034462 
     C288.390137,33.070457 280.667877,33.106453 272.022156,33.021328 
     C261.696747,33.060970 251.371353,33.100609 240.112427,33.034454 
     C232.391449,33.070072 224.670486,33.105690 216.025757,33.018959 
   M173.360535,362.458740 
     C184.387924,373.735199 195.485703,384.944794 206.350555,396.375732 
     C207.657852,397.751129 208.481659,400.437469 208.210999,402.327362 
     C205.932220,418.238770 203.346069,434.106171 200.323135,450.544189 
     C199.440826,456.242676 198.558533,461.941132 197.509689,468.715210 
     C200.193329,467.327271 201.928146,466.481750 203.615021,465.549500 
     C220.187592,456.391174 236.806747,447.314362 253.267792,437.959473 
     C256.166290,436.312256 258.156372,436.541199 260.884216,438.077332 
     C277.526825,447.449310 294.268402,456.645721 310.984924,465.886230 
     C312.469086,466.706635 314.010223,467.423950 315.904846,468.381104 
     C315.904846,466.222076 316.087738,464.874420 315.877441,463.591187 
     C312.715271,444.297607 309.597778,424.995636 306.229584,405.737640 
     C305.420959,401.114227 306.174225,397.782898 309.715057,394.280731 
     C323.324554,380.819885 336.554169,366.974792 349.913635,353.261505 
     C351.123413,352.019714 352.248535,350.695404 354.226044,348.511414 
     C347.019592,347.618317 341.008270,346.873352 334.202057,345.929565 
     C319.619141,343.647461 305.053558,341.242462 290.439301,339.182495 
     C287.357666,338.748138 285.906342,337.518921 284.648621,334.804504 
     C278.166656,320.815277 271.461914,306.929291 264.821228,292.289795 
     C262.346893,286.981323 259.872559,281.672852 257.038879,275.593445 
     C256.019012,277.674194 255.437958,278.819397 254.891434,279.980804 
     C246.282959,298.274506 237.732208,316.595856 228.984802,334.822845 
     C228.181122,336.497467 226.287750,338.490601 224.630005,338.778351 
     C213.210068,340.760712 201.714737,342.305756 190.250549,344.037109 
     C180.483978,345.512115 170.726639,347.048218 160.080948,348.693970 
     C164.819427,353.504272 168.936172,357.683411 173.360535,362.458740 
   z"
          />
          <path
            fill="#133348"
            opacity="1.000000"
            stroke="none"
            d="
   M171.101013,511.364197 
     C168.755524,502.129852 170.415451,499.045563 178.522568,494.702820 
     C197.135483,484.732483 215.535385,474.363129 234.183151,464.459625 
     C245.065781,458.680023 255.824707,459.959595 266.479034,465.904022 
     C284.047699,475.706177 301.701630,485.369690 319.550751,494.646912 
     C325.489868,497.733795 332.115570,496.975189 337.473083,492.810333 
     C343.008545,488.507202 345.525421,482.712524 344.325562,475.305115 
     C340.703369,452.943787 337.461456,430.521149 333.921295,408.146118 
     C332.220551,397.396881 336.068146,388.684631 343.315643,381.197235 
     C357.326569,366.722687 371.497650,352.403107 385.493500,337.914124 
     C389.092102,334.188721 393.102966,331.574402 398.705444,330.974060 
     C402.934601,337.652832 401.201019,346.282623 396.617249,351.854431 
     C396.407257,352.109711 396.135651,352.313324 395.902802,352.550842 
     C379.158600,369.631531 362.726440,387.036957 345.486938,403.602081 
     C340.150787,408.729523 340.029480,413.500702 341.226105,419.673431 
     C343.327240,430.512115 345.162354,441.404816 346.954132,452.300323 
     C349.091980,465.300415 350.835968,478.369293 353.189728,491.328613 
     C354.915497,500.830231 350.283508,509.484497 341.105652,512.649658 
     C337.307098,513.000000 333.614166,513.000000 329.361633,512.650574 
     C328.331665,512.148926 327.820923,512.069397 327.396667,511.834076 
     C304.770020,499.282166 282.168060,486.685425 259.484314,474.237701 
     C258.220856,473.544373 255.949554,473.451050 254.716110,474.122742 
     C231.093094,486.988251 207.555359,500.010284 184.000000,513.000000 
     C180.638718,513.000000 177.277420,513.000000 173.458069,513.000000 
     C172.411453,512.549561 171.822906,512.099060 171.101013,511.364197 
   z"
          />
          <path
            fill="#44637F"
            opacity="1.000000"
            stroke="none"
            d="
   M368.531342,1.000000 
     C368.283630,10.842299 361.662750,16.993340 351.694458,16.994703 
     C283.600281,17.004011 215.506119,16.998775 147.411957,17.000839 
     C135.056992,17.001213 129.006882,23.032949 129.001831,35.349655 
     C128.996841,47.503384 129.015411,59.657131 128.995621,71.810829 
     C128.979767,81.545898 123.811562,87.422470 113.546829,89.016357 
     C113.098068,68.581200 112.645454,48.125134 113.143547,27.692242 
     C113.381912,17.914202 123.223633,4.488129 136.852509,1.345103 
     C214.020889,1.000000 291.041779,1.000000 368.531342,1.000000 
   z"
          />
          <path
            fill="#FFFFFF"
            opacity="1.000000"
            stroke="none"
            d="
   M184.468658,513.000000 
     C207.555359,500.010284 231.093094,486.988251 254.716110,474.122742 
     C255.949554,473.451050 258.220856,473.544373 259.484314,474.237701 
     C282.168060,486.685425 304.770020,499.282166 327.396667,511.834076 
     C327.820923,512.069397 328.331665,512.148926 328.901001,512.650574 
     C280.979095,513.000000 232.958206,513.000000 184.468658,513.000000 
   z"
          />
          <path
            fill="#43627E"
            opacity="1.000000"
            stroke="none"
            d="
   M240.930450,217.522461 
     C252.429947,217.031052 259.546509,225.947250 256.526764,237.502441 
     C254.903564,243.713715 252.441071,249.806732 249.597794,255.579010 
     C241.286835,272.451599 232.120270,288.915833 224.195923,305.961731 
     C217.432175,320.511017 206.348221,327.248627 190.889023,329.127136 
     C172.841949,331.320190 154.882980,334.292084 136.935715,337.231049 
     C127.148216,338.833832 122.408554,344.260651 120.946533,354.725342 
     C113.907417,349.785889 111.540321,342.247040 113.240494,334.182251 
     C114.574379,327.854889 119.174469,323.061401 125.991478,321.512909 
     C130.576019,320.471558 135.230865,319.706879 139.881256,318.994537 
     C151.784836,317.171356 163.704514,315.453400 175.615768,313.680054 
     C183.822098,312.458252 192.011230,311.108307 200.236496,310.033112 
     C203.475525,309.609741 205.757874,308.741547 207.306366,305.400116 
     C218.101425,282.105804 229.474808,259.070862 239.790665,235.569946 
     C242.012360,230.508621 240.679092,223.886841 240.930450,217.522461 
   z"
          />
          <path
            fill="#133348"
            opacity="1.000000"
            stroke="none"
            d="
   M273.343567,216.954865 
     C272.844421,201.862152 280.138000,190.456253 291.548370,181.273346 
     C309.236023,167.038544 327.038971,152.947083 344.744385,138.734192 
     C355.471405,130.123154 366.158386,121.460373 376.763062,112.699478 
     C382.851807,107.669365 384.915588,100.736038 384.968567,93.152763 
     C385.068665,78.824806 384.982788,64.495636 385.002930,50.167019 
     C385.016815,40.269592 390.065521,34.543377 400.446106,33.018402 
     C400.882904,54.331028 401.616913,75.666481 400.725800,96.933846 
     C400.182404,109.901665 393.270142,120.665398 383.127380,128.926559 
     C372.389465,137.672501 361.468475,146.193481 350.640503,154.829025 
     C337.513855,165.297806 324.360596,175.733749 311.294250,186.277298 
     C300.108459,195.303391 289.032501,204.465500 277.898163,213.555450 
     C276.517395,214.682724 275.076416,215.736252 273.343567,216.954865 
   z"
          />
          <path
            fill="#FFCB5B"
            opacity="1.000000"
            stroke="none"
            d="
   M200.852371,449.986786 
     C203.346069,434.106171 205.932220,418.238770 208.210999,402.327362 
     C208.481659,400.437469 207.657852,397.751129 206.350555,396.375732 
     C195.485703,384.944794 184.387924,373.735199 173.483261,361.899780 
     C192.202454,358.536682 210.814255,355.827515 229.379349,352.829010 
     C232.264496,352.363007 236.390900,351.332275 237.463226,349.271912 
     C243.126450,338.390625 247.883255,327.042328 253.178207,315.962982 
     C256.877655,308.222107 260.936584,300.653076 264.834930,293.007263 
     C271.461914,306.929291 278.166656,320.815277 284.648621,334.804504 
     C285.906342,337.518921 287.357666,338.748138 290.439301,339.182495 
     C305.053558,341.242462 319.619141,343.647461 334.562378,346.364807 
     C334.252167,347.729553 333.684448,348.758606 332.895630,349.573669 
     C321.555664,361.290710 310.148193,372.942902 298.877228,384.725739 
     C297.652679,386.005920 296.259125,388.142731 296.491486,389.642395 
     C299.096375,406.453491 302.035706,423.212433 304.813477,439.997253 
     C305.659515,445.109344 306.285492,450.257782 307.150146,456.363220 
     C304.507141,455.112152 302.852722,454.440948 301.304443,453.579041 
     C284.468750,444.207001 267.686676,434.737091 250.761612,425.529877 
     C249.277802,424.722717 246.535706,424.932617 244.970200,425.773132 
     C230.190857,433.707611 215.540161,441.881744 200.852371,449.986786 
   z"
          />
          <path
            fill="#E2E5E7"
            opacity="1.000000"
            stroke="none"
            d="
   M273.124725,175.030685 
     C267.923828,179.385666 262.722931,183.740662 257.113953,188.437332 
     C251.729721,184.093979 246.474518,179.854721 241.097748,174.855469 
     C240.983917,169.774094 240.993851,165.452713 240.999039,161.131332 
     C241.043945,123.736176 241.088028,86.341026 241.591522,48.963051 
     C252.320602,48.968113 262.590485,48.955994 272.915161,49.413170 
     C273.021576,91.598541 273.073151,133.314606 273.124725,175.030685 
   z"
          />
          <path
            fill="#E1E5E7"
            opacity="1.000000"
            stroke="none"
            d="
   M216.867676,155.806473 
     C206.316147,147.410721 195.764603,139.014969 185.095215,129.858185 
     C184.922394,102.385452 184.867432,75.673744 184.910675,48.983269 
     C185.008896,49.004490 185.204910,49.048908 185.658905,49.032207 
     C196.364365,48.992493 206.615829,48.969479 216.921356,49.415688 
     C216.939514,85.192101 216.903595,120.499283 216.867676,155.806473 
   z"
          />
          <path
            fill="#E1E5E7"
            opacity="1.000000"
            stroke="none"
            d="
   M329.127899,130.033691 
     C318.664917,138.554153 308.201904,147.074600 297.400818,155.244904 
     C297.085236,119.578644 297.107727,84.262520 297.589539,48.963448 
     C308.290802,49.004158 318.532715,49.027809 328.875214,49.029686 
     C328.975800,49.007908 329.176544,48.962437 329.106567,49.428738 
     C329.067017,76.607925 329.097473,103.320808 329.127899,130.033691 
   z"
          />
          <path
            fill="#3689C9"
            opacity="1.000000"
            stroke="none"
            d="
   M217.074432,156.084976 
     C216.903595,120.499283 216.939514,85.192101 216.989471,49.445957 
     C217.003525,49.007004 217.141174,49.064266 217.599609,49.043575 
     C225.658478,49.036636 233.258896,49.050388 240.928299,49.036270 
     C240.997284,49.008396 241.132339,48.945869 241.132339,48.945869 
     C241.088028,86.341026 241.043945,123.736176 240.999039,161.131332 
     C240.993851,165.452713 240.983917,169.774094 240.925964,174.563797 
     C233.010880,168.809250 225.146027,162.586365 217.074432,156.084976 
   z"
          />
          <path
            fill="#3689C9"
            opacity="1.000000"
            stroke="none"
            d="
   M297.130219,48.946392 
     C297.107727,84.262520 297.085236,119.578644 297.097687,155.350693 
     C289.326721,162.115448 281.520782,168.424286 273.419800,174.881897 
     C273.073151,133.314606 273.021576,91.598541 272.983368,49.444042 
     C272.996735,49.005619 273.135376,49.062115 273.594238,49.041702 
     C281.653931,49.036037 289.254791,49.050785 296.924988,49.037392 
     C296.994354,49.009251 297.130219,48.946392 297.130219,48.946392 
   z"
          />
          <path
            fill="#F5B74F"
            opacity="1.000000"
            stroke="none"
            d="
   M200.587738,450.265503 
     C215.540161,441.881744 230.190857,433.707611 244.970200,425.773132 
     C246.535706,424.932617 249.277802,424.722717 250.761612,425.529877 
     C267.686676,434.737091 284.468750,444.207001 301.304443,453.579041 
     C302.852722,454.440948 304.507141,455.112152 307.150146,456.363220 
     C306.285492,450.257782 305.659515,445.109344 304.813477,439.997253 
     C302.035706,423.212433 299.096375,406.453491 296.491486,389.642395 
     C296.259125,388.142731 297.652679,386.005920 298.877228,384.725739 
     C310.148193,372.942902 321.555664,361.290710 332.895630,349.573669 
     C333.684448,348.758606 334.252167,347.729553 334.959839,346.464203 
     C341.008270,346.873352 347.019592,347.618317 354.226044,348.511414 
     C352.248535,350.695404 351.123413,352.019714 349.913635,353.261505 
     C336.554169,366.974792 323.324554,380.819885 309.715057,394.280731 
     C306.174225,397.782898 305.420959,401.114227 306.229584,405.737640 
     C309.597778,424.995636 312.715271,444.297607 315.877441,463.591187 
     C316.087738,464.874420 315.904846,466.222076 315.904846,468.381104 
     C314.010223,467.423950 312.469086,466.706635 310.984924,465.886230 
     C294.268402,456.645721 277.526825,447.449310 260.884216,438.077332 
     C258.156372,436.541199 256.166290,436.312256 253.267792,437.959473 
     C236.806747,447.314362 220.187592,456.391174 203.615021,465.549500 
     C201.928146,466.481750 200.193329,467.327271 197.509689,468.715210 
     C198.558533,461.941132 199.440826,456.242676 200.587738,450.265503 
   z"
          />
          <path
            fill="#3689C9"
            opacity="1.000000"
            stroke="none"
            d="
   M184.812469,48.962044 
     C184.867432,75.673744 184.922394,102.385452 184.924744,129.565399 
     C173.414581,120.956367 161.868469,111.987564 150.546494,102.744217 
     C146.472076,99.417839 144.988159,94.601334 144.998917,89.355438 
     C145.025879,76.204094 145.031693,63.052708 145.553192,49.445183 
     C158.977753,48.980034 171.895111,48.971039 184.812469,48.962044 
   z"
          />
          <path
            fill="#3689C9"
            opacity="1.000000"
            stroke="none"
            d="
   M329.422485,129.883682 
     C329.097473,103.320808 329.067017,76.607925 329.562622,49.441162 
     C343.007568,48.979420 355.926483,48.971550 368.845398,48.963684 
     C368.888275,62.914593 369.409821,76.890312 368.688660,90.801620 
     C368.466095,95.095322 365.852814,100.339043 362.614685,103.205070 
     C352.077057,112.531769 340.743988,120.959778 329.422485,129.883682 
   z"
          />
          <path
            fill="#FDD96F"
            opacity="1.000000"
            stroke="none"
            d="
   M264.828064,292.648529 
     C260.936584,300.653076 256.877655,308.222107 253.178207,315.962982 
     C247.883255,327.042328 243.126450,338.390625 237.463226,349.271912 
     C236.390900,351.332275 232.264496,352.363007 229.379349,352.829010 
     C210.814255,355.827515 192.202454,358.536682 173.329453,361.601685 
     C168.936172,357.683411 164.819427,353.504272 160.080948,348.693970 
     C170.726639,347.048218 180.483978,345.512115 190.250549,344.037109 
     C201.714737,342.305756 213.210068,340.760712 224.630005,338.778351 
     C226.287750,338.490601 228.181122,336.497467 228.984802,334.822845 
     C237.732208,316.595856 246.282959,298.274506 254.891434,279.980804 
     C255.437958,278.819397 256.019012,277.674194 257.038879,275.593445 
     C259.872559,281.672852 262.346893,286.981323 264.828064,292.648529 
   z"
          />
          <path
            fill="#4C9FD7"
            opacity="1.000000"
            stroke="none"
            d="
   M368.903320,48.502029 
     C355.926483,48.971550 343.007568,48.979420 329.632599,48.974861 
     C329.176544,48.962437 328.975800,49.007908 328.950378,48.564720 
     C328.925507,43.129143 328.926025,38.136745 328.926514,33.144352 
     C342.021301,33.144352 355.116089,33.144352 368.961243,33.144352 
     C368.961243,38.226124 368.961243,43.133247 368.903320,48.502029 
   z"
          />
          <path
            fill="#4C9FD7"
            opacity="1.000000"
            stroke="none"
            d="
   M184.910675,48.983269 
     C171.895111,48.971039 158.977753,48.980034 145.604797,48.976948 
     C145.149170,43.859123 145.149170,38.753372 145.149170,33.038223 
     C158.348801,33.038223 171.230515,33.038223 184.562592,33.545158 
     C185.076935,39.051029 185.140930,44.049969 185.204910,49.048908 
     C185.204910,49.048908 185.008896,49.004490 184.910675,48.983269 
   z"
          />
          <path
            fill="#F1F2F2"
            opacity="1.000000"
            stroke="none"
            d="
   M328.464569,33.084953 
     C328.926025,38.136745 328.925507,43.129143 328.849792,48.586498 
     C318.532715,49.027809 308.290802,49.004158 297.589539,48.963448 
     C297.130219,48.946392 296.994354,49.009251 296.979736,48.569054 
     C296.992065,43.132656 297.019012,38.136456 297.045959,33.140251 
     C307.364838,33.102016 317.683746,33.063782 328.464569,33.084953 
   z"
          />
          <path
            fill="#F1F2F2"
            opacity="1.000000"
            stroke="none"
            d="
   M272.928528,48.974747 
     C262.590485,48.955994 252.320602,48.968113 241.591522,48.963051 
     C241.132339,48.945869 240.997284,49.008396 240.981628,48.567898 
     C240.992630,43.131683 241.019302,38.135967 241.045959,33.140251 
     C251.371353,33.100609 261.696747,33.060970 272.502106,33.537804 
     C273.033173,39.056889 273.084259,44.059502 273.135376,49.062115 
     C273.135376,49.062115 272.996735,49.005619 272.928528,48.974747 
   z"
          />
          <path
            fill="#F1F2F2"
            opacity="1.000000"
            stroke="none"
            d="
   M185.658905,49.032207 
     C185.140930,44.049969 185.076935,39.051029 185.031921,33.596001 
     C195.375839,33.099594 205.700806,33.059277 216.506165,33.536079 
     C217.038101,39.056892 217.089645,44.060577 217.141174,49.064266 
     C217.141174,49.064266 217.003525,49.007004 216.935410,48.976730 
     C206.615829,48.969479 196.364365,48.992493 185.658905,49.032207 
   z"
          />
          <path
            fill="#4C9FD7"
            opacity="1.000000"
            stroke="none"
            d="
   M273.594238,49.041702 
     C273.084259,44.059502 273.033173,39.056889 272.963806,33.598366 
     C280.667877,33.106453 288.390137,33.070457 296.579193,33.087357 
     C297.019012,38.136456 296.992065,43.132656 296.910400,48.597198 
     C289.254791,49.050785 281.653931,49.036037 273.594238,49.041702 
   z"
          />
          <path
            fill="#4C9FD7"
            opacity="1.000000"
            stroke="none"
            d="
   M217.599609,49.043575 
     C217.089645,44.060577 217.038101,39.056892 216.968048,33.597256 
     C224.670486,33.105690 232.391449,33.070072 240.579193,33.087353 
     C241.019302,38.135967 240.992630,43.131683 240.912643,48.595772 
     C233.258896,49.050388 225.658478,49.036636 217.599609,49.043575 
   z"
          />
        </svg>
      );
    case "watchesCategory":
      return (
        <svg
          stroke="#6f6f6f"
          fill="#6f6f6f"
          stroke-width="0"
          viewBox="0 0 16 16"
          class="me-2 text-gray-900 transition-transform duration-300 group-hover:-translate-y-1/2 group-hover:text-primary"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M4 14.333v-1.86A5.985 5.985 0 012 8c0-1.777.772-3.374 2-4.472V1.667C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v1.86A5.985 5.985 0 0114 8a5.985 5.985 0 01-2 4.472v1.861c0 .92-.746 1.667-1.667 1.667H5.667C4.747 16 4 15.254 4 14.333zM13 8A5 5 0 103 8a5 5 0 0010 0z"
            clip-rule="evenodd"
          ></path>
          <rect width="1" height="2" x="13.5" y="7" rx=".5"></rect>
          <path
            fill-rule="evenodd"
            d="M8 4.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H6a.5.5 0 010-1h1.5V5a.5.5 0 01.5-.5z"
            clip-rule="evenodd"
          ></path>
        </svg>
      );
    case "homeCategory":
      return (
        <svg
          stroke="currentColor"
          fill="none"
          stroke-width="0"
          viewBox="0 0 24 24"
          class="me-2 text-gray-900 transition-transform duration-300 group-hover:-translate-y-1/2 group-hover:text-primary"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 4H18C18.5523 4 19 4.44772 19 5V8H5V5C5 4.44772 5.44771 4 6 4ZM19 19V10H5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19ZM3 5C3 3.34315 4.34315 2 6 2H18C19.6569 2 21 3.34315 21 5V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7H9C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5H7ZM14 7C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7ZM18 6C18 6.55228 17.5523 7 17 7C16.4477 7 16 6.55228 16 6C16 5.44772 16.4477 5 17 5C17.5523 5 18 5.44772 18 6ZM14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15ZM16 15C16 17.2091 14.2091 19 12 19C9.79086 19 8 17.2091 8 15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15Z"
            fill="currentColor"
          ></path>
        </svg>
      );
    case "successOrder":
      return (
        <svg
          width="275"
          height="275"
          viewBox="0 0 348 348"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_568_4123)">
            <path
              d="M340.422 184.623C303.973 161.904 257.126 163.675 222.447 189.08L211.672 197.083L226.904 225.087L238.947 216.877C262.979 197.651 296.863 195.391 323.318 211.795C334.088 218.474 348.001 210.938 348.001 198.261C348.001 192.708 345.133 187.562 340.422 184.623Z"
              fill="#938BD8"
            />
            <path
              d="M322.79 20.1419C322.579 19.9312 322.368 19.7273 322.164 19.5166C318.318 15.6709 312.504 14.7778 307.569 17.0486C299.955 20.5667 287.378 19.2046 272.453 34.1393C261.584 45.0014 259.278 54.7733 257.597 61.9019C256.255 67.5963 255.446 71.0274 250.223 76.244C245.014 81.4606 241.576 82.2687 235.888 83.6118C228.76 85.2919 218.987 87.5981 208.126 98.467C197.594 108.992 195.102 118.493 193.429 125.559C191.912 131.967 191.2 135.274 185.903 140.572C184.779 141.695 183.539 142.8 182.247 143.736L174 152.08L192.572 172.242L202.367 163.623C207.798 158.937 212.526 153.335 215.745 147.052C218.535 141.605 219.689 136.724 220.639 132.69C221.982 127.002 222.791 123.564 228.007 118.348C233.224 113.131 236.654 112.323 242.342 110.98C249.478 109.3 259.243 106.994 270.112 96.1323C280.981 85.2634 283.287 75.4983 284.967 68.3623C286.31 62.6747 287.118 59.2368 292.335 54.0202C297.552 48.8036 300.989 47.9955 306.677 46.6524C310.08 45.851 314.08 44.9015 318.516 42.9542C327.57 38.9828 329.778 27.1297 322.79 20.1419Z"
              fill="#7EE6FD"
            />
            <path
              d="M153.538 7.57852C150.545 2.78196 145.335 0 139.899 0C127.224 0 119.688 13.9132 126.366 24.6835C141.908 49.7484 140.77 81.7018 123.919 105.539L118.172 115.18L146.486 130.408L152.174 121.083C156.107 115.099 159.351 108.807 161.939 102.322C174.235 71.5031 171.376 36.1968 153.538 7.57852Z"
              fill="#15DFB5"
            />
            <path
              d="M222.447 189.08L211.672 197.083L226.904 225.087L238.947 216.877C244.592 212.362 250.74 208.813 257.173 206.204C252.219 196.576 246.698 187.283 240.647 178.376C234.336 181.284 228.233 184.841 222.447 189.08Z"
              fill="#786ACD"
            />
            <path
              d="M185.902 140.571C184.778 141.694 183.538 142.8 182.246 143.735L174 152.08L192.572 172.242L202.367 163.623C207.798 158.937 212.526 153.335 215.745 147.052C208.731 139.467 201.279 132.289 193.429 125.558C191.911 131.966 191.199 135.273 185.902 140.571Z"
              fill="#00D5FD"
            />
            <path
              d="M118.172 115.18L146.486 130.408L152.174 121.083C156.107 115.099 159.351 108.807 161.939 102.321C152.815 96.5727 143.311 91.3642 133.476 86.7322C131.252 93.3217 128.072 99.6639 123.919 105.539L118.172 115.18Z"
              fill="#00D297"
            />
            <path
              d="M342.706 297.726C347.767 298.458 349.792 304.686 346.129 308.258L334.628 319.471C333.172 320.891 332.504 322.93 332.849 324.934L335.563 340.766C336.427 345.814 331.134 349.659 326.606 347.276L312.384 339.803C310.591 338.854 308.44 338.854 306.64 339.803L292.425 347.276C287.89 349.659 282.597 345.813 283.461 340.766L286.175 324.934C286.519 322.93 285.859 320.892 284.403 319.471L272.902 308.258C269.232 304.686 271.257 298.458 276.319 297.726L292.214 295.413C294.225 295.118 295.968 293.86 296.868 292.032L303.976 277.634C306.24 273.043 312.784 273.043 315.048 277.634L322.163 292.032C323.057 293.86 324.8 295.118 326.81 295.413L342.706 297.726Z"
              fill="#FCE75F"
            />
            <path
              d="M71.6808 23.5376C76.7424 24.2689 78.7672 30.4976 75.0976 34.0687L63.5959 45.2822C62.1407 46.6952 61.4801 48.7411 61.8247 50.7448L64.538 66.5774C65.4025 71.6255 60.1091 75.4705 55.5743 73.0875L41.3586 65.6136C39.5588 64.6648 37.4076 64.6648 35.6146 65.6136L21.3928 73.0868C16.8654 75.4698 11.5713 71.6248 12.4359 66.5768L15.1498 50.7441C15.4945 48.7404 14.8263 46.6945 13.3711 45.2815L1.86943 34.0687C-1.7934 30.4976 0.231387 24.2683 5.29302 23.5376L21.1882 21.2246C23.1987 20.9296 24.9421 19.6708 25.8352 17.8432L32.9509 3.44467C35.2149 -1.14594 41.7596 -1.14594 44.0237 3.44467L51.1311 17.8425C52.031 19.6702 53.7744 20.9289 55.785 21.2239L71.6808 23.5376Z"
              fill="#FCE75F"
            />
            <path
              d="M25.7594 117.084C27.8342 110.11 23.8623 102.774 16.888 100.699C9.9136 98.624 2.57776 102.596 0.502924 109.57C-1.57192 116.545 2.39994 123.88 9.37431 125.955C16.3487 128.03 23.6845 124.058 25.7594 117.084Z"
              fill="#15DFB5"
            />
            <path
              d="M301.9 249.235C307.047 244.088 307.047 235.743 301.9 230.595C296.753 225.448 288.408 225.448 283.261 230.595C278.114 235.743 278.114 244.088 283.261 249.235C288.408 254.382 296.753 254.382 301.9 249.235Z"
              fill="#15DFB5"
            />
            <path
              d="M337.253 111.536C342.743 121.048 335.875 132.943 324.886 132.943H307.845C296.856 132.943 289.988 121.048 295.478 111.536L304.006 96.7725C309.497 87.2603 323.234 87.2603 328.725 96.7725L337.253 111.536Z"
              fill="#15DFB5"
            />
            <path
              d="M233.085 21.5128C240.854 29.2809 237.303 42.5477 226.687 45.395L210.222 49.8027C199.606 52.6499 189.898 42.9413 192.745 32.3252L197.153 15.8605C200 5.24446 213.266 1.69445 221.035 9.4626L233.085 21.5128Z"
              fill="#15DFB5"
            />
            <path
              d="M250.855 244.346C225.595 174.632 170.679 121.419 103.655 97.145C81.0062 88.9371 55.7789 101.679 49.4096 125.421C48.1372 130.131 38.2233 166.828 27.7051 205.762L31.4618 228.309L16.9552 245.553C8.90362 275.356 2.259 299.951 1.23743 303.731C-5.78035 329.919 18.195 353.75 44.2698 346.763C48.0495 345.742 72.6447 339.097 102.446 331.046L118.988 317.418L142.238 320.296C181.172 309.778 217.869 299.864 222.58 298.591C246.134 292.267 259.122 267.155 250.855 244.346Z"
              fill="#FCE75F"
            />
            <path
              d="M27.6924 324.785C30.6171 313.959 76.5015 144.118 79.4411 133.235C84.046 116.07 97.8301 104.271 113.767 101.069C110.426 99.6871 107.056 98.3759 103.656 97.145C81.0071 88.9371 55.7798 101.679 49.4105 125.421C48.1381 130.131 38.2242 166.828 27.706 205.762L31.4627 228.309L16.9561 245.553C8.9052 275.356 2.26058 299.951 1.23901 303.731C-4.3154 324.46 9.57877 343.784 28.6046 347.394C26.0986 340.519 25.5589 332.749 27.6924 324.785Z"
              fill="#FFCE59"
            />
            <path
              d="M27.7063 205.763L16.957 245.555C53.5895 258.028 89.8413 294.025 102.445 331.043L142.237 320.294C126.022 269.551 78.307 221.932 27.7063 205.763Z"
              fill="#FF9389"
            />
            <path
              d="M27.7063 205.763L16.957 245.555C26.5739 248.83 36.1365 253.72 45.2477 259.798C48.8439 246.488 52.676 232.302 56.4285 218.411C47.1012 213.166 37.4598 208.88 27.7063 205.763Z"
              fill="#FF675A"
            />
            <path
              d="M195.661 234.657C204.055 243.037 205.447 255.256 198.769 261.935C192.09 268.621 179.878 267.243 171.484 258.856C163.09 250.476 161.698 238.258 168.376 231.578C175.055 224.892 187.267 226.271 195.661 234.657Z"
              fill="#FDAFBF"
            />
            <path
              d="M132.958 185.262C142.154 176.053 149.69 181.852 157.916 190.071C166.141 198.289 171.948 205.819 162.746 215.022C153.55 224.232 139.426 225.033 131.201 216.807C122.975 208.589 123.763 194.465 132.958 185.262Z"
              fill="#415460"
            />
            <path
              d="M113.294 152.368C121.688 160.755 123.073 172.966 116.401 179.652C109.723 186.338 97.504 184.953 89.1167 176.573C80.7225 168.186 79.3305 155.975 86.0092 149.289C92.681 142.603 104.9 143.988 113.294 152.368Z"
              fill="#FDAFBF"
            />
            <path
              d="M126.722 171.109C124.661 169.052 124.658 165.714 126.716 163.652C128.645 161.72 128.643 158.576 126.712 156.644C124.768 154.7 121.632 154.727 119.708 156.652C117.649 158.71 114.311 158.711 112.251 156.652C110.193 154.592 110.192 151.254 112.251 149.195C115.178 146.268 119.069 144.655 123.207 144.652H123.218C127.355 144.652 131.245 146.263 134.17 149.187C140.21 155.227 140.214 165.059 134.18 171.103C132.124 173.162 128.785 173.168 126.722 171.109Z"
              fill="#415460"
            />
            <path
              d="M191.383 235.697C189.323 233.64 189.319 230.302 191.377 228.24C193.306 226.307 193.306 223.168 191.377 221.242C189.442 219.313 186.3 219.312 184.372 221.243C182.314 223.302 178.975 223.307 176.915 221.249C174.854 219.192 174.851 215.854 176.908 213.792C182.944 207.745 192.776 207.738 198.826 213.779C204.87 219.812 204.877 229.641 198.84 235.689C196.793 237.741 193.455 237.764 191.383 235.697Z"
              fill="#415460"
            />
          </g>
          <defs>
            <clipPath id="clip0_568_4123">
              <rect width="348" height="348" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "users":
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M43.8266 19.425C43.6516 19.4 43.4766 19.4 43.3016 19.425C39.4266 19.3 36.3516 16.125 36.3516 12.225C36.3516 8.25 39.5766 5 43.5766 5C47.5516 5 50.8016 8.225 50.8016 12.225C50.7766 16.125 47.7016 19.3 43.8266 19.425Z"
            fill="#59C6C9"
          />
          <path
            d="M51.975 36.75C49.175 38.625 45.25 39.325 41.625 38.85C42.575 36.8 43.075 34.525 43.1 32.125C43.1 29.625 42.55 27.25 41.5 25.175C45.2 24.675 49.125 25.375 51.95 27.25C55.9 29.85 55.9 34.125 51.975 36.75Z"
            fill="#59C6C9"
          />
          <path
            d="M16.0984 19.425C16.2734 19.4 16.4484 19.4 16.6234 19.425C20.4984 19.3 23.5734 16.125 23.5734 12.225C23.5734 8.225 20.3484 5 16.3484 5C12.3734 5 9.14844 8.225 9.14844 12.225C9.14844 16.125 12.2234 19.3 16.0984 19.425Z"
            fill="#59C6C9"
          />
          <path
            d="M16.3719 32.1245C16.3719 34.5495 16.8969 36.8495 17.8469 38.9245C14.3219 39.2995 10.6469 38.5495 7.94688 36.7745C3.99687 34.1495 3.99687 29.8745 7.94688 27.2495C10.6219 25.4495 14.3969 24.7245 17.9469 25.1245C16.9219 27.2245 16.3719 29.5995 16.3719 32.1245Z"
            fill="#59C6C9"
          />
          <path
            d="M30.3 39.675C30.1 39.65 29.875 39.65 29.65 39.675C25.05 39.525 21.375 35.75 21.375 31.1C21.4 26.35 25.225 22.5 30 22.5C34.75 22.5 38.6 26.35 38.6 31.1C38.575 35.75 34.925 39.525 30.3 39.675Z"
            fill="#59C6C9"
          />
          <path
            d="M22.175 44.8496C18.4 47.3746 18.4 51.5246 22.175 54.0246C26.475 56.8996 33.525 56.8996 37.825 54.0246C41.6 51.4996 41.6 47.3496 37.825 44.8496C33.55 41.9746 26.5 41.9746 22.175 44.8496Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "add_product":
      return (
        <svg
          width="147"
          height="146"
          viewBox="0 0 147 146"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M134.335 47.5108V84.5583L124.419 76.0416C119.674 71.9658 112.009 71.9658 107.264 76.0416L81.9571 97.7591C77.2121 101.835 69.5471 101.835 64.8021 97.7591L62.7338 96.0558C58.4146 92.2841 51.5405 91.9191 46.6738 95.2041L16.7438 115.279L16.0746 115.766C13.8238 110.899 12.668 105.12 12.668 98.4891V47.5108C12.668 25.3675 25.8688 12.1666 48.0121 12.1666H98.9905C121.134 12.1666 134.335 25.3675 134.335 47.5108Z"
            fill="#59C6C9"
          />
          <path
            d="M55.2518 63.145C63.2479 63.145 69.7301 56.6629 69.7301 48.6667C69.7301 40.6705 63.2479 34.1884 55.2518 34.1884C47.2556 34.1884 40.7734 40.6705 40.7734 48.6667C40.7734 56.6629 47.2556 63.145 55.2518 63.145Z"
            fill="#59C6C9"
          />
          <path
            d="M134.334 84.5583V98.4891C134.334 120.632 121.133 133.833 98.9901 133.833H48.0117C32.4992 133.833 21.3059 127.324 16.0742 115.766L16.7434 115.279L46.6734 95.2041C51.5401 91.9191 58.4142 92.2841 62.7334 96.0558L64.8017 97.7591C69.5467 101.835 77.2117 101.835 81.9567 97.7591L107.263 76.0416C112.008 71.9658 119.673 71.9658 124.418 76.0416L134.334 84.5583Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "profile_phone":
      return (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M16.5003 29.8467C23.8641 29.8467 29.8337 23.8771 29.8337 16.5133C29.8337 9.14953 23.8641 3.17999 16.5003 3.17999C9.13653 3.17999 3.16699 9.14953 3.16699 16.5133C3.16699 23.8771 9.13653 29.8467 16.5003 29.8467Z"
            fill="#59C6C9"
          />
          <path
            d="M16.5 9.75336C13.74 9.75336 11.5 11.9934 11.5 14.7534C11.5 17.46 13.62 19.66 16.4333 19.74C16.4733 19.74 16.5267 19.74 16.5533 19.74C16.58 19.74 16.62 19.74 16.6467 19.74C16.66 19.74 16.6733 19.74 16.6733 19.74C19.3667 19.6467 21.4867 17.46 21.5 14.7534C21.5 11.9934 19.26 9.75336 16.5 9.75336Z"
            fill="#59C6C9"
          />
          <path
            d="M25.54 26.3133C23.1666 28.5 19.9933 29.8467 16.5 29.8467C13.0066 29.8467 9.83329 28.5 7.45996 26.3133C7.77996 25.1 8.64663 23.9933 9.91329 23.14C13.5533 20.7133 19.4733 20.7133 23.0866 23.14C24.3666 23.9933 25.22 25.1 25.54 26.3133Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "home_products":
      return (
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M26.1537 7.94H25.6203L21.1137 3.43333C20.7537 3.07333 20.167 3.07333 19.7937 3.43333C19.4337 3.79333 19.4337 4.38 19.7937 4.75333L22.9803 7.94H10.0203L13.207 4.75333C13.567 4.39333 13.567 3.80666 13.207 3.43333C12.847 3.07333 12.2603 3.07333 11.887 3.43333L7.39366 7.94H6.86033C5.66033 7.94 3.16699 7.94 3.16699 11.3533C3.16699 12.6467 3.43366 13.5 3.99366 14.06C4.31366 14.3933 4.70033 14.5667 5.11366 14.66C5.50033 14.7533 5.91366 14.7667 6.31366 14.7667H26.687C27.1003 14.7667 27.487 14.74 27.8603 14.66C28.9803 14.3933 29.8337 13.5933 29.8337 11.3533C29.8337 7.94 27.3403 7.94 26.1537 7.94Z"
            fill="#F3A837"
          />
          <path
            d="M26.6999 14.7667H6.31328C5.92661 14.7667 5.49995 14.7533 5.11328 14.6467L6.79328 24.9C7.16661 27.1933 8.16661 29.8333 12.6066 29.8333H20.0866C24.5799 29.8333 25.3799 27.58 25.8599 25.06L27.8733 14.6467C27.4999 14.74 27.0999 14.7667 26.6999 14.7667ZM16.4999 25.1667C13.3799 25.1667 10.8333 22.62 10.8333 19.5C10.8333 18.9533 11.2866 18.5 11.8333 18.5C12.3799 18.5 12.8333 18.9533 12.8333 19.5C12.8333 21.5267 14.4733 23.1667 16.4999 23.1667C18.5266 23.1667 20.1666 21.5267 20.1666 19.5C20.1666 18.9533 20.6199 18.5 21.1666 18.5C21.7133 18.5 22.1666 18.9533 22.1666 19.5C22.1666 22.62 19.6199 25.1667 16.4999 25.1667Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "delete":
      return (
        <svg
          fill="#FF0000"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          width="26px"
          height="26px"
          viewBox="0 0 482.428 482.429"
        >
          <g>
            <g>
              <path
                d="M381.163,57.799h-75.094C302.323,25.316,274.686,0,241.214,0c-33.471,0-61.104,25.315-64.85,57.799h-75.098
			c-30.39,0-55.111,24.728-55.111,55.117v2.828c0,23.223,14.46,43.1,34.83,51.199v260.369c0,30.39,24.724,55.117,55.112,55.117
			h210.236c30.389,0,55.111-24.729,55.111-55.117V166.944c20.369-8.1,34.83-27.977,34.83-51.199v-2.828
			C436.274,82.527,411.551,57.799,381.163,57.799z M241.214,26.139c19.037,0,34.927,13.645,38.443,31.66h-76.879
			C206.293,39.783,222.184,26.139,241.214,26.139z M375.305,427.312c0,15.978-13,28.979-28.973,28.979H136.096
			c-15.973,0-28.973-13.002-28.973-28.979V170.861h268.182V427.312z M410.135,115.744c0,15.978-13,28.979-28.973,28.979H101.266
			c-15.973,0-28.973-13.001-28.973-28.979v-2.828c0-15.978,13-28.979,28.973-28.979h279.897c15.973,0,28.973,13.001,28.973,28.979
			V115.744z"
                fill="#FF0000"
              />
              <path
                d="M171.144,422.863c7.218,0,13.069-5.853,13.069-13.068V262.641c0-7.216-5.852-13.07-13.069-13.07
			c-7.217,0-13.069,5.854-13.069,13.07v147.154C158.074,417.012,163.926,422.863,171.144,422.863z"
                fill="#FF0000"
              />
              <path
                d="M241.214,422.863c7.218,0,13.07-5.853,13.07-13.068V262.641c0-7.216-5.854-13.07-13.07-13.07
			c-7.217,0-13.069,5.854-13.069,13.07v147.154C228.145,417.012,233.996,422.863,241.214,422.863z"
                fill="#FF0000"
              />
              <path
                d="M311.284,422.863c7.217,0,13.068-5.853,13.068-13.068V262.641c0-7.216-5.852-13.07-13.068-13.07
			c-7.219,0-13.07,5.854-13.07,13.07v147.154C298.213,417.012,304.067,422.863,311.284,422.863z"
                fill="#FF0000"
              />
            </g>
          </g>
        </svg>
      );
    case "notification":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 11.27V17.0975"
            stroke="#172B4D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            className="navico"
          />
          <path
            d="M21.0351 3.5C14.5951 3.5 9.38007 8.715 9.38007 15.155V18.83C9.38007 20.02 8.89006 21.805 8.27756 22.82L6.05507 26.53C4.69007 28.8225 5.63506 31.3775 8.15506 32.2175C16.5201 35 25.5676 35 33.9326 32.2175C36.2951 31.43 37.3101 28.665 36.0326 26.53L33.8101 22.82C33.1976 21.805 32.7076 20.0025 32.7076 18.83V15.155C32.6901 8.75 27.4401 3.5 21.0351 3.5Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            className="navico"
          />
          <path
            d="M26.8269 32.935C26.8269 36.1375 24.2019 38.7625 20.9994 38.7625C19.4069 38.7625 17.9369 38.0975 16.8869 37.0475C15.8369 35.9975 15.1719 34.5275 15.1719 32.935"
            stroke="#172B4D"
            strokeWidth="2"
            strokeMiterlimit="10"
            className="navico"
          />
        </svg>
      );
    case "chart":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.25 39.8125H15.75C6.2475 39.8125 2.1875 35.7525 2.1875 26.25V15.75C2.1875 6.2475 6.2475 2.1875 15.75 2.1875H26.25C35.7525 2.1875 39.8125 6.2475 39.8125 15.75V26.25C39.8125 35.7525 35.7525 39.8125 26.25 39.8125ZM15.75 4.8125C7.6825 4.8125 4.8125 7.6825 4.8125 15.75V26.25C4.8125 34.3175 7.6825 37.1875 15.75 37.1875H26.25C34.3175 37.1875 37.1875 34.3175 37.1875 26.25V15.75C37.1875 7.6825 34.3175 4.8125 26.25 4.8125H15.75Z"
            fill="#172B4D"
            className="navico"
          />
          <path
            d="M27.125 33.6875C24.465 33.6875 22.3125 31.535 22.3125 28.875V13.125C22.3125 10.465 24.465 8.3125 27.125 8.3125C29.785 8.3125 31.9375 10.465 31.9375 13.125V28.875C31.9375 31.535 29.785 33.6875 27.125 33.6875ZM27.125 10.9375C25.9175 10.9375 24.9375 11.9175 24.9375 13.125V28.875C24.9375 30.0825 25.9175 31.0625 27.125 31.0625C28.3325 31.0625 29.3125 30.0825 29.3125 28.875V13.125C29.3125 11.9175 28.3325 10.9375 27.125 10.9375Z"
            fill="#172B4D"
            className="navico"
          />
          <path
            d="M14.875 33.6875C12.215 33.6875 10.0625 31.535 10.0625 28.875V22.75C10.0625 20.09 12.215 17.9375 14.875 17.9375C17.535 17.9375 19.6875 20.09 19.6875 22.75V28.875C19.6875 31.535 17.535 33.6875 14.875 33.6875ZM14.875 20.5625C13.6675 20.5625 12.6875 21.5425 12.6875 22.75V28.875C12.6875 30.0825 13.6675 31.0625 14.875 31.0625C16.0825 31.0625 17.0625 30.0825 17.0625 28.875V22.75C17.0625 21.5425 16.0825 20.5625 14.875 20.5625Z"
            fill="#172B4D"
            className="navico"
          />
        </svg>
      );
    case "shop":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 43 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.39258 20.57V28.8017C5.39258 37.0333 8.61758 40.3333 16.6622 40.3333H26.3192C34.3638 40.3333 37.5888 37.0333 37.5888 28.8017V20.57"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="navico"
          />
          <path
            d="M21.4996 22C24.7783 22 27.1971 19.2683 26.8746 15.9133L25.6921 3.66667H17.325L16.1246 15.9133C15.8021 19.2683 18.2208 22 21.4996 22Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="navico"
          />
          <path
            d="M32.8057 22C36.4248 22 39.0765 18.9933 38.7182 15.3083L38.2165 10.2667C37.5715 5.50001 35.7798 3.66667 31.0857 3.66667H25.6211L26.8753 16.5183C27.1798 19.5433 29.8494 22 32.8057 22Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="navico"
          />
          <path
            d="M10.1051 22C13.0613 22 15.7309 19.5433 16.0176 16.5183L16.4118 12.4667L17.2718 3.66667H11.8072C7.11301 3.66667 5.32134 5.50001 4.67634 10.2667L4.19259 15.3083C3.83426 18.9933 6.48593 22 10.1051 22Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            className="navico"
            strokeLinejoin="round"
          />
          <path
            d="M21.5007 31.1667C18.5086 31.1667 17.0215 32.6883 17.0215 35.75V40.3333H25.9798V35.75C25.9798 32.6883 24.4927 31.1667 21.5007 31.1667Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="navico"
          />
        </svg>
      );
    case "bag":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.2438 25.0931C26.3774 24.4947 25.367 24.1834 24.2129 24.1596C23.0588 24.1357 21.9692 24.4182 20.9435 25.0069C19.8301 25.6461 19.0655 26.4709 18.6495 27.4802C18.3871 28.1127 18.3658 28.974 18.5854 30.0642L27.2438 25.0931ZM33.3729 25.4582L20.5462 32.8226C21.4997 33.6723 22.6059 34.1482 23.8639 34.2508C25.122 34.3535 26.375 34.0465 27.6231 33.3299C29.115 32.4734 30.0428 31.2966 30.4066 29.7987L34.8436 29.2024C34.8131 30.6893 34.4068 32.0095 33.6241 33.1633C32.8416 34.317 31.6459 35.356 30.037 36.2796C27.541 37.7128 24.9732 38.2147 22.3336 37.7849C19.6939 37.3556 17.5693 36.1395 15.9596 34.1371C14.3103 32.0852 13.7233 29.9324 14.1985 27.6782C14.6739 25.4244 16.0912 23.6198 18.4509 22.265C20.9567 20.8263 23.5394 20.3342 26.1989 20.7883C28.8583 21.2427 31.0824 22.5821 32.8709 24.807L33.3729 25.4582Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            className="navico"
          />
          <path
            d="M16.3792 8.63173C16.3792 5.09868 19.6988 2.15044 23.8788 2.09665C28.1334 2.04178 31.6151 4.9508 31.6151 8.53406V16.0324C31.6151 16.2671 31.3899 16.4573 31.1124 16.4573C30.8347 16.4573 30.6096 16.2671 30.6096 16.0324V11.4107H16.3792V8.63173ZM24.1385 18.0434C28.9271 18.0434 33.1248 20.1789 35.473 23.3841L43.5 18.7493L42.9772 11.4107H32.9118V8.64834C32.9118 4.51386 29.0269 1.0639 24.1355 1.0009C19.1567 0.936699 15.0824 4.34076 15.0824 8.53406V16.0324C15.0824 16.2671 14.8573 16.4573 14.5797 16.4573C14.3021 16.4573 14.077 16.2671 14.077 16.0324V11.4107L5.51596 11.3052L1.5 43L13.4943 36.0745C11.8131 34.1899 10.8159 31.8448 10.8159 29.3028C10.8159 23.0844 16.7806 18.0434 24.1385 18.0434Z"
            fill="white"
            stroke="black"
            strokeWidth="1.5"
            className="navico"
          />
        </svg>
      );
    case "heart":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 69 73"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M36.2825 63.2971C35.305 63.6621 33.695 63.6621 32.7175 63.2971C24.38 60.2859 5.75 47.7238 5.75 26.4321C5.75 17.0334 12.9088 9.4292 21.735 9.4292C26.9675 9.4292 31.5963 12.1059 34.5 16.2425C37.4037 12.1059 42.0613 9.4292 47.265 9.4292C56.0913 9.4292 63.25 17.0334 63.25 26.4321C63.25 47.7238 44.62 60.2859 36.2825 63.2971Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "heartCart":
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 69 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`heartCart ${active ? "active" : ""}`}
        >
          <path
            d="M36.2825 63.2971C35.305 63.6621 33.695 63.6621 32.7175 63.2971C24.38 60.2859 5.75 47.7238 5.75 26.4321C5.75 17.0334 12.9088 9.4292 21.735 9.4292C26.9675 9.4292 31.5963 12.1059 34.5 16.2425C37.4037 12.1059 42.0613 9.4292 47.265 9.4292C56.0913 9.4292 63.25 17.0334 63.25 26.4321C63.25 47.7238 44.62 60.2859 36.2825 63.2971Z"
            stroke="#172B4D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "user":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0007 16C19.6825 16 22.6673 13.0152 22.6673 9.33334C22.6673 5.65144 19.6825 2.66667 16.0007 2.66667C12.3188 2.66667 9.33398 5.65144 9.33398 9.33334C9.33398 13.0152 12.3188 16 16.0007 16Z"
            stroke="#172B4D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.4535 29.3333C27.4535 24.1733 22.3202 20 16.0002 20C9.6802 20 4.54688 24.1733 4.54688 29.3333"
            stroke="#172B4D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "category":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 31 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.8373 2.07447H21.4623C18.7373 2.07447 17.2998 3.26729 17.2998 5.52846V7.4992C17.2998 9.76037 18.7373 10.9532 21.4623 10.9532H23.8373C26.5623 10.9532 27.9998 9.76037 27.9998 7.4992V5.52846C27.9998 3.26729 26.5623 2.07447 23.8373 2.07447Z"
            fill="#59C6C9"
          />
          <path
            d="M9.55 13.9301H7.175C4.4375 13.9301 3 15.1229 3 17.384V19.3548C3 21.6263 4.4375 22.8191 7.1625 22.8191H9.5375C12.2625 22.8191 13.7 21.6263 13.7 19.3652V17.3944C13.7125 15.1229 12.275 13.9301 9.55 13.9301Z"
            fill="#59C6C9"
          />
          <path
            d="M8.3625 10.9739C11.3241 10.9739 13.725 8.98172 13.725 6.5242C13.725 4.06668 11.3241 2.07447 8.3625 2.07447C5.40087 2.07447 3 4.06668 3 6.5242C3 8.98172 5.40087 10.9739 8.3625 10.9739Z"
            fill="#59C6C9"
          />
          <path
            d="M22.6379 22.8191C25.5995 22.8191 28.0004 20.8269 28.0004 18.3694C28.0004 15.9119 25.5995 13.9197 22.6379 13.9197C19.6763 13.9197 17.2754 15.9119 17.2754 18.3694C17.2754 20.8269 19.6763 22.8191 22.6379 22.8191Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "star":
      return (
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0245 0.463526C10.1741 0.00287056 10.8259 0.00286996 10.9755 0.463525L12.9697 6.60081C13.0366 6.80682 13.2286 6.9463 13.4452 6.9463H19.8983C20.3827 6.9463 20.5841 7.56611 20.1922 7.85081L14.9715 11.6439C14.7963 11.7712 14.7229 11.9969 14.7899 12.2029L16.784 18.3402C16.9337 18.8008 16.4064 19.1839 16.0146 18.8992L10.7939 15.1061C10.6186 14.9788 10.3814 14.9788 10.2061 15.1061L4.98542 18.8992C4.59356 19.1839 4.06632 18.8008 4.216 18.3402L6.21012 12.2029C6.27706 11.9969 6.20373 11.7712 6.02849 11.6439L0.8078 7.85081C0.415943 7.56611 0.61733 6.9463 1.10169 6.9463H7.55482C7.77143 6.9463 7.96341 6.80682 8.03035 6.60081L10.0245 0.463526Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "nextArrow":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 58 58"
        >
          <g
            id="Group_110"
            data-name="Group 110"
            transform="translate(-1734 -1100)"
          >
            <circle
              id="Ellipse_2"
              data-name="Ellipse 2"
              cx="29"
              cy="29"
              r="29"
              transform="translate(1734 1100)"
              fill="rgba(89, 198, 201, 1)"
            />
            <path
              id="Icon_feather-chevron-down"
              data-name="Icon feather-chevron-down"
              d="M0,9.277,9.277,0l9.277,9.277"
              transform="translate(1768.492 1119.723) rotate(90)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            />
          </g>
        </svg>
      );
    case "prevArrow":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 58 58"
        >
          <g
            id="Group_111"
            data-name="Group 111"
            transform="translate(-140 -1100)"
          >
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="29"
              cy="29"
              r="29"
              transform="translate(140 1100)"
              fill="rgba(89, 198, 201, 1)"
            />
            <path
              id="Icon_feather-chevron-down"
              data-name="Icon feather-chevron-down"
              d="M9,13.5l9.277,9.277L27.554,13.5"
              transform="translate(186.284 1110.723) rotate(90)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            />
          </g>
        </svg>
      );
    case "closeRedBtn":
      return (
        <svg
          width="76"
          height="76"
          viewBox="0 0 76 76"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M38.0026 69.6667C55.4193 69.6667 69.6693 55.4167 69.6693 38C69.6693 20.5833 55.4193 6.33334 38.0026 6.33334C20.5859 6.33334 6.33594 20.5833 6.33594 38C6.33594 55.4167 20.5859 69.6667 38.0026 69.6667Z"
            stroke="#FF0B0B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.0391 46.9617L46.9624 29.0383"
            stroke="#FF0B0B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M46.9624 46.9617L29.0391 29.0383"
            stroke="#FF0B0B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "deleteCart":
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 49 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="24.5"
            cy="25"
            r="24.5"
            fill="#FF0000"
            fill-opacity="0.14"
          />
          <path
            d="M32.9557 15.3333H28.7266L27.5182 14.125H21.4766L20.2682 15.3333H16.0391V17.75H32.9557M17.2474 33.4583C17.2474 34.0993 17.502 34.714 17.9552 35.1672C18.4084 35.6204 19.0231 35.875 19.6641 35.875H29.3307C29.9717 35.875 30.5864 35.6204 31.0396 35.1672C31.4928 34.714 31.7474 34.0993 31.7474 33.4583V18.9583H17.2474V33.4583Z"
            fill="#FF0000"
          />
        </svg>
      );
    case "addCircle":
      return (
        <svg
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 30.75C24.0625 30.75 30.25 24.5625 30.25 17C30.25 9.4375 24.0625 3.25 16.5 3.25C8.9375 3.25 2.75 9.4375 2.75 17C2.75 24.5625 8.9375 30.75 16.5 30.75Z"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11 17H22"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.5 22.5V11.5"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "minusCircle":
      return (
        <svg
          width="33"
          height="34"
          viewBox="0 0 33 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.3906 30.75C23.9531 30.75 30.1406 24.5625 30.1406 17C30.1406 9.4375 23.9531 3.25 16.3906 3.25C8.82812 3.25 2.64062 9.4375 2.64062 17C2.64062 24.5625 8.82812 30.75 16.3906 30.75Z"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.8906 17H21.8906"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "closeCart":
      return (
        <svg
          width="35"
          height="35"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 44C35 44 44 35 44 24C44 13 35 4 24 4C13 4 4 13 4 24C4 35 13 44 24 44Z"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.3398 29.66L29.6598 18.34"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.6598 29.66L18.3398 18.34"
            stroke="#172B4D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "googleDrive":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_334_5949)">
            <path
              d="M2.31444 21.045L3.37287 23.0887C3.59281 23.519 3.90894 23.8571 4.28009 24.103C5.34322 22.5944 6.08309 21.4368 6.50009 20.6301C6.92319 19.8115 7.44322 18.5309 8.06019 16.7885C6.39744 16.5438 5.13744 16.4215 4.28019 16.4215C3.45734 16.4215 2.19734 16.5438 0.5 16.7885C0.5 17.2649 0.609969 17.7412 0.829906 18.1715L2.31444 21.045Z"
              fill="#0066DA"
            />
            <path
              d="M20.7194 24.103C21.0907 23.8571 21.4068 23.519 21.6267 23.0888L22.0665 22.2437L24.1697 18.1715C24.3856 17.7505 24.4993 17.2738 24.4995 16.7885C22.7923 16.5438 21.5347 16.4215 20.7264 16.4215C19.8577 16.4215 18.5999 16.5438 16.9531 16.7885C17.5628 18.5404 18.076 19.821 18.4927 20.6301C18.913 21.4464 19.6552 22.604 20.7194 24.103Z"
              fill="#EA4335"
            />
            <path
              d="M12.5008 8.18325C13.7308 6.52264 14.5785 5.24204 15.0438 4.34168C15.4185 3.61665 15.8309 2.45899 16.2809 0.868804C15.9097 0.622935 15.4836 0.5 15.0438 0.5H9.95783C9.51795 0.5 9.09195 0.638341 8.7207 0.868804C9.29314 2.69259 9.77895 3.99059 10.178 4.76267C10.619 5.61598 11.3932 6.75614 12.5008 8.18325Z"
              fill="#00832D"
            />
            <path
              d="M16.9391 16.7886H8.0593L4.2793 24.103C4.65036 24.3489 5.07645 24.4718 5.51633 24.4718H19.4821C19.922 24.4718 20.3481 24.3335 20.7192 24.1029L16.9392 16.7886H16.9391Z"
              fill="#2684FC"
            />
            <path
              d="M12.5001 8.18324L8.72009 0.868896C8.34884 1.11477 8.03272 1.45276 7.81278 1.88308L0.829906 15.4056C0.614012 15.8265 0.500285 16.3033 0.5 16.7885H8.06019L12.5001 8.18324Z"
              fill="#00AC47"
            />
            <path
              d="M20.6788 8.64425L17.1872 1.88296C16.9674 1.45263 16.6512 1.11464 16.28 0.868774L12.5 8.18322L16.9398 16.7885H24.4863C24.4863 16.3121 24.3763 15.8359 24.1564 15.4055L20.6788 8.64425Z"
              fill="#FFBA00"
            />
          </g>
          <defs>
            <clipPath id="clip0_334_5949">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "globedit":
      return (
        <svg
          width="83"
          height="83"
          viewBox="0 0 83 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M76.0827 41.5C76.0827 22.41 60.5894 6.91663 41.4994 6.91663C22.4093 6.91663 6.91602 22.41 6.91602 41.5C6.91602 60.59 22.4093 76.0833 41.4994 76.0833"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M27.6659 10.375H31.1242C24.3805 30.5717 24.3805 52.4283 31.1242 72.625H27.6659"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M51.875 10.375C55.2296 20.4733 56.9242 30.9867 56.9242 41.5"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.375 55.3333V51.875C20.4733 55.2296 30.9867 56.9242 41.5 56.9242"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.375 31.1248C30.5717 24.3811 52.4283 24.3811 72.625 31.1248"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M66.4355 54.4342L54.193 66.6769C53.7088 67.161 53.2592 68.0601 53.1555 68.7172L52.4984 73.3858C52.2563 75.0804 53.4322 76.2563 55.1267 76.0142L59.7955 75.3571C60.4525 75.2534 61.3863 74.8038 61.8359 74.3197L74.0784 62.0772C76.188 59.9676 77.1909 57.5121 74.0784 54.3996C71.0005 51.3217 68.5451 52.3247 66.4355 54.4342Z"
            stroke="#F3A837"
            stroke-width="4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M64.6719 56.1979C65.7094 59.9329 68.6144 62.8378 72.3494 63.8753"
            stroke="#F3A837"
            stroke-width="4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "globedit2":
      return (
        <svg
          width="83"
          height="83"
          viewBox="0 0 83 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55.1953 73.7316C54.5382 73.7316 53.8811 73.4895 53.3624 72.9708L48.1057 67.7141C47.1028 66.7112 47.1028 65.0512 48.1057 64.0483C49.1086 63.0454 50.7686 63.0454 51.7715 64.0483L55.1953 67.472L63.8757 58.7916C64.8786 57.7887 66.5386 57.7887 67.5415 58.7916C68.5445 59.7945 68.5445 61.4545 67.5415 62.4574L57.0282 72.9708C56.5095 73.4895 55.8524 73.7316 55.1953 73.7316Z"
            fill="#F3A837"
          />
          <path
            d="M42.0533 40.1858C41.9496 40.1858 41.8804 40.1858 41.7767 40.1858C41.6038 40.1512 41.3617 40.1512 41.1542 40.1858C31.125 39.8745 23.5513 31.9895 23.5513 22.2716C23.5167 17.4991 25.3842 13.0033 28.7733 9.61413C32.1625 6.22496 36.6583 4.32288 41.4654 4.32288C51.3563 4.32288 59.4142 12.3808 59.4142 22.2716C59.4142 31.9895 51.8404 39.84 42.1571 40.1858C42.1225 40.1858 42.0879 40.1858 42.0533 40.1858ZM41.4654 9.51038C38.0417 9.51038 34.86 10.8591 32.4392 13.2454C30.0529 15.6662 28.7388 18.8479 28.7388 22.237C28.7388 29.1537 34.1338 34.7562 41.0158 34.9637C41.2233 34.9291 41.6729 34.9291 42.1225 34.9637C48.9354 34.6525 54.2267 29.0845 54.2267 22.237C54.2267 15.2512 48.4858 9.51038 41.4654 9.51038Z"
            fill="#F3A837"
          />
          <path
            d="M41.4661 78.02C34.4111 78.02 27.7365 76.1871 22.6874 72.7979C17.8803 69.5816 15.252 65.1896 15.252 60.4516C15.252 55.7137 17.9149 51.3562 22.6874 48.1746C33.0278 41.2579 49.8353 41.2579 60.1757 48.1746C61.3515 48.97 61.6974 50.5954 60.902 51.7712C60.1065 52.9816 58.4811 53.2929 57.3053 52.4975C48.694 46.7566 34.169 46.7566 25.5578 52.4975C22.2378 54.7108 20.4395 57.5121 20.4395 60.4516C20.4395 63.3912 22.2378 66.2616 25.5578 68.475C29.7424 71.2762 35.3795 72.7979 41.4315 72.7979C42.8495 72.7979 44.0253 73.9737 44.0253 75.3916C44.0253 76.8096 42.884 78.02 41.4661 78.02Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "globedit3":
      return (
        <svg
          width="83"
          height="83"
          viewBox="0 0 83 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41.4994 76.0833C60.5202 76.0833 76.0827 60.5208 76.0827 41.5C76.0827 22.4791 60.5202 6.91663 41.4994 6.91663C22.4785 6.91663 6.91602 22.4791 6.91602 41.5C6.91602 60.5208 22.4785 76.0833 41.4994 76.0833Z"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M26.8027 41.5L36.5898 51.2871L56.1986 31.7129"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case "profile":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55 30C55 16.225 43.775 5 30 5C16.225 5 5 16.225 5 30C5 37.25 8.125 43.775 13.075 48.35C13.075 48.375 13.075 48.375 13.05 48.4C13.3 48.65 13.6 48.85 13.85 49.075C14 49.2 14.125 49.325 14.275 49.425C14.725 49.8 15.225 50.15 15.7 50.5C15.875 50.625 16.025 50.725 16.2 50.85C16.675 51.175 17.175 51.475 17.7 51.75C17.875 51.85 18.075 51.975 18.25 52.075C18.75 52.35 19.275 52.6 19.825 52.825C20.025 52.925 20.225 53.025 20.425 53.1C20.975 53.325 21.525 53.525 22.075 53.7C22.275 53.775 22.475 53.85 22.675 53.9C23.275 54.075 23.875 54.225 24.475 54.375C24.65 54.425 24.825 54.475 25.025 54.5C25.725 54.65 26.425 54.75 27.15 54.825C27.25 54.825 27.35 54.85 27.45 54.875C28.3 54.95 29.15 55 30 55C30.85 55 31.7 54.95 32.525 54.875C32.625 54.875 32.725 54.85 32.825 54.825C33.55 54.75 34.25 54.65 34.95 54.5C35.125 54.475 35.3 54.4 35.5 54.375C36.1 54.225 36.725 54.1 37.3 53.9C37.5 53.825 37.7 53.75 37.9 53.7C38.45 53.5 39.025 53.325 39.55 53.1C39.75 53.025 39.95 52.925 40.15 52.825C40.675 52.6 41.2 52.35 41.725 52.075C41.925 51.975 42.1 51.85 42.275 51.75C42.775 51.45 43.275 51.175 43.775 50.85C43.95 50.75 44.1 50.625 44.275 50.5C44.775 50.15 45.25 49.8 45.7 49.425C45.85 49.3 45.975 49.175 46.125 49.075C46.4 48.85 46.675 48.625 46.925 48.4C46.925 48.375 46.925 48.375 46.9 48.35C51.875 43.775 55 37.25 55 30ZM42.35 42.425C35.575 37.875 24.475 37.875 17.65 42.425C16.55 43.15 15.65 44 14.9 44.925C11.1 41.075 8.75 35.8 8.75 30C8.75 18.275 18.275 8.75 30 8.75C41.725 8.75 51.25 18.275 51.25 30C51.25 35.8 48.9 41.075 45.1 44.925C44.375 44 43.45 43.15 42.35 42.425Z"
            fill="#59C6C9"
          />
          <path
            d="M30 17.3248C24.825 17.3248 20.625 21.5248 20.625 26.6998C20.625 31.7748 24.6 35.8998 29.875 36.0498C29.95 36.0498 30.05 36.0498 30.1 36.0498C30.15 36.0498 30.225 36.0498 30.275 36.0498C30.3 36.0498 30.325 36.0498 30.325 36.0498C35.375 35.8748 39.35 31.7748 39.375 26.6998C39.375 21.5248 35.175 17.3248 30 17.3248Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "statistics":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54.1734 17.7532C52.5734 12.3282 48.0484 7.80318 42.6234 6.20318C38.4984 5.00318 35.6484 5.10318 33.6734 6.57818C31.2984 8.35318 31.0234 11.5532 31.0234 13.8282V20.0532C31.0234 26.2032 33.8234 29.3282 39.3234 29.3282H46.4984C48.7484 29.3282 51.9734 29.0532 53.7484 26.6782C55.2734 24.7282 55.3984 21.8782 54.1734 17.7532Z"
            fill="#59C6C9"
          />
          <path
            d="M47.2765 33.7782C46.6265 33.0282 45.6765 32.6032 44.7015 32.6032H35.7515C31.3515 32.6032 27.7765 29.0282 27.7765 24.6282V15.6782C27.7765 14.7032 27.3515 13.7532 26.6015 13.1032C25.8765 12.4532 24.8765 12.1532 23.9265 12.2782C18.0515 13.0282 12.6515 16.2532 9.12645 21.1032C5.57646 25.9782 4.27645 31.9282 5.40145 37.8782C7.02645 46.4782 13.9015 53.3532 22.5265 54.9782C23.9015 55.2532 25.2765 55.3782 26.6515 55.3782C31.1765 55.3782 35.5515 53.9782 39.2765 51.2532C44.1265 47.7282 47.3515 42.3282 48.1015 36.4532C48.2265 35.4782 47.9265 34.5032 47.2765 33.7782Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "wallet":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.125 9.875V19.375H33.375V9.875C33.375 9.2 32.775 8.875 32.375 8.875C32.25 8.875 32.125 8.9 32 8.95L12.175 16.425C10.85 16.925 10 18.175 10 19.6V21.275C7.725 22.975 6.25 25.7 6.25 28.775V19.6C6.25 16.625 8.075 13.975 10.85 12.925L30.7 5.425C31.25 5.225 31.825 5.125 32.375 5.125C34.875 5.125 37.125 7.15 37.125 9.875Z"
            fill="#59C6C9"
          />
          <path
            d="M53.7497 36.25V38.75C53.7497 39.425 53.2247 39.975 52.5247 40H48.8747C47.5497 40 46.3497 39.025 46.2497 37.725C46.1747 36.95 46.4747 36.225 46.9747 35.725C47.4247 35.25 48.0497 35 48.7247 35H52.4997C53.2247 35.025 53.7497 35.575 53.7497 36.25Z"
            fill="#59C6C9"
          />
          <path
            d="M48.7 32.375H51.25C52.625 32.375 53.75 31.25 53.75 29.875V28.775C53.75 23.6 49.525 19.375 44.35 19.375H15.65C13.525 19.375 11.575 20.075 10 21.275C7.725 22.975 6.25 25.7 6.25 28.775V45.6C6.25 50.775 10.475 55 15.65 55H44.35C49.525 55 53.75 50.775 53.75 45.6V45.125C53.75 43.75 52.625 42.625 51.25 42.625H49.075C46.675 42.625 44.375 41.15 43.75 38.825C43.225 36.925 43.85 35.1 45.1 33.875C46.025 32.925 47.3 32.375 48.7 32.375ZM35 31.875H17.5C16.475 31.875 15.625 31.025 15.625 30C15.625 28.975 16.475 28.125 17.5 28.125H35C36.025 28.125 36.875 28.975 36.875 30C36.875 31.025 36.025 31.875 35 31.875Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "orders":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.4992 5.90316C38.4742 4.87816 36.6992 5.57816 36.6992 7.00316V15.7282C36.6992 19.3782 39.7992 22.4032 43.5742 22.4032C45.9492 22.4282 49.2492 22.4282 52.0742 22.4282C53.4992 22.4282 54.2492 20.7532 53.2492 19.7532C49.6492 16.1282 43.1992 9.60316 39.4992 5.90316Z"
            fill="#59C6C9"
          />
          <path
            d="M51.25 25.8532H44.025C38.1 25.8532 33.275 21.0282 33.275 15.1032V7.87817C33.275 6.50317 32.15 5.37817 30.775 5.37817H20.175C12.475 5.37817 6.25 10.3782 6.25 19.3032V41.4532C6.25 50.3782 12.475 55.3782 20.175 55.3782H39.825C47.525 55.3782 53.75 50.3782 53.75 41.4532V28.3532C53.75 26.9782 52.625 25.8532 51.25 25.8532ZM28.75 44.7532H18.75C17.725 44.7532 16.875 43.9032 16.875 42.8782C16.875 41.8532 17.725 41.0032 18.75 41.0032H28.75C29.775 41.0032 30.625 41.8532 30.625 42.8782C30.625 43.9032 29.775 44.7532 28.75 44.7532ZM33.75 34.7532H18.75C17.725 34.7532 16.875 33.9032 16.875 32.8782C16.875 31.8532 17.725 31.0032 18.75 31.0032H33.75C34.775 31.0032 35.625 31.8532 35.625 32.8782C35.625 33.9032 34.775 34.7532 33.75 34.7532Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "products":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.1 14.3282H47.1L38.65 5.8782C37.975 5.2032 36.875 5.2032 36.175 5.8782C35.5 6.5532 35.5 7.6532 36.175 8.3532L42.15 14.3282H17.85L23.825 8.3532C24.5 7.6782 24.5 6.5782 23.825 5.8782C23.15 5.2032 22.05 5.2032 21.35 5.8782L12.925 14.3282H11.925C9.675 14.3282 5 14.3282 5 20.7282C5 23.1532 5.5 24.7532 6.55 25.8032C7.15 26.4282 7.875 26.7532 8.65 26.9282C9.375 27.1032 10.15 27.1282 10.9 27.1282H49.1C49.875 27.1282 50.6 27.0782 51.3 26.9282C53.4 26.4282 55 24.9282 55 20.7282C55 14.3282 50.325 14.3282 48.1 14.3282Z"
            fill="#59C6C9"
          />
          <path
            d="M47.6266 30.3782H12.1766C10.6266 30.3782 9.45161 31.7532 9.70161 33.2782L11.8016 46.1282C12.5016 50.4282 14.3766 55.3782 22.7016 55.3782H36.7266C45.1516 55.3782 46.6516 51.1532 47.5516 46.4282L50.0766 33.3532C50.3766 31.8032 49.2016 30.3782 47.6266 30.3782ZM30.0016 49.1282C24.1516 49.1282 19.3766 44.3532 19.3766 38.5032C19.3766 37.4782 20.2266 36.6282 21.2516 36.6282C22.2766 36.6282 23.1266 37.4782 23.1266 38.5032C23.1266 42.3032 26.2016 45.3782 30.0016 45.3782C33.8016 45.3782 36.8766 42.3032 36.8766 38.5032C36.8766 37.4782 37.7266 36.6282 38.7516 36.6282C39.7766 36.6282 40.6266 37.4782 40.6266 38.5032C40.6266 44.3532 35.8516 49.1282 30.0016 49.1282Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "favPanel":
      return (
        <svg
          width="45"
          height="45"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41.1 8.25C36.575 8.25 32.525 10.45 30 13.825C27.475 10.45 23.425 8.25 18.9 8.25C11.225 8.25 5 14.5 5 22.225C5 25.2 5.475 27.95 6.3 30.5C10.25 43 22.425 50.475 28.45 52.525C29.3 52.825 30.7 52.825 31.55 52.525C37.575 50.475 49.75 43 53.7 30.5C54.525 27.95 55 25.2 55 22.225C55 14.5 48.775 8.25 41.1 8.25Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "paymentReq":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 55 55"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M49.925 21.875H42.575C39.4 21.875 37.5 19.975 37.5 16.8V9.45C37.5 6.275 39.4 4.375 42.575 4.375H49.925C53.1 4.375 55 6.275 55 9.45V16.8C55 19.975 53.1 21.875 49.925 21.875ZM50.475 13.6C50.175 13.3 49.775 13.15 49.375 13.15C48.975 13.15 48.575 13.3 48.275 13.6L47.825 14.05V8.45C47.825 7.575 47.125 6.875 46.25 6.875C45.375 6.875 44.675 7.575 44.675 8.45V14.05L44.225 13.6C43.625 13 42.625 13 42.025 13.6C41.425 14.2 41.425 15.2 42.025 15.8L45.15 18.925C45.275 19.05 45.45 19.15 45.625 19.225C45.675 19.25 45.725 19.25 45.775 19.275C45.9 19.325 46.025 19.35 46.175 19.35C46.225 19.35 46.275 19.35 46.325 19.35C46.5 19.35 46.65 19.325 46.825 19.25C46.85 19.25 46.85 19.25 46.875 19.25C47.05 19.175 47.2 19.075 47.325 18.95C47.35 18.925 47.35 18.925 47.375 18.925L50.5 15.8C51.1 15.2 51.1 14.2 50.475 13.6Z"
            fill="#59C6C9"
          />
          <path
            d="M5 28.65V41.15C5 46.875 9.625 51.5 15.35 51.5H44.625C50.35 51.5 55 46.85 55 41.125V28.65C55 26.975 53.65 25.625 51.975 25.625H8.025C6.35 25.625 5 26.975 5 28.65ZM20 43.125H15C13.975 43.125 13.125 42.275 13.125 41.25C13.125 40.225 13.975 39.375 15 39.375H20C21.025 39.375 21.875 40.225 21.875 41.25C21.875 42.275 21.025 43.125 20 43.125ZM36.25 43.125H26.25C25.225 43.125 24.375 42.275 24.375 41.25C24.375 40.225 25.225 39.375 26.25 39.375H36.25C37.275 39.375 38.125 40.225 38.125 41.25C38.125 42.275 37.275 43.125 36.25 43.125Z"
            fill="#59C6C9"
          />
          <path
            d="M33.75 11.525V18.85C33.75 20.525 32.4 21.875 30.725 21.875H8.025C6.325 21.875 5 20.475 5 18.8C5.025 15.975 6.15 13.4 8.025 11.525C9.9 9.65 12.5 8.5 15.35 8.5H30.725C32.4 8.5 33.75 9.85 33.75 11.525Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "camera":
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.416 37.1667C32.213 37.1667 35.291 34.0886 35.291 30.2917C35.291 26.4947 32.213 23.4167 28.416 23.4167C24.6191 23.4167 21.541 26.4947 21.541 30.2917C21.541 34.0886 24.6191 37.1667 28.416 37.1667Z"
            stroke="white"
            stroke-width="3"
          />
          <path
            d="M5.5 31.1259C5.5 24.1019 5.5 20.5911 7.21646 18.0702C7.96162 16.974 8.91652 16.0362 10.026 15.3111C11.676 14.2271 13.7431 13.8398 16.9079 13.7023C18.4181 13.7023 19.7175 12.5794 20.0131 11.1242C20.239 10.0583 20.826 9.10301 21.6749 8.4199C22.5238 7.73679 23.5825 7.3677 24.6721 7.37502H32.1612C34.4254 7.37502 36.3756 8.94481 36.8202 11.1242C37.1158 12.5794 38.4152 13.7023 39.9254 13.7023C43.0879 13.8398 45.155 14.2294 46.8073 15.3111C47.9187 16.0398 48.8744 16.9771 49.6169 18.0702C51.3333 20.5911 51.3333 24.1019 51.3333 31.1259C51.3333 38.1475 51.3333 41.6583 49.6169 44.1815C48.8704 45.2766 47.9157 46.2141 46.8073 46.9406C44.2383 48.625 40.661 48.625 33.5087 48.625H23.3246C16.1723 48.625 12.595 48.625 10.026 46.9406C8.91811 46.2133 7.96421 45.275 7.21875 44.1792C6.72205 43.4369 6.35548 42.6154 6.13479 41.75M44.4583 23.4167H42.1667"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      );
    case "myShop":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M55.903 20.675L55.178 13.75C54.128 6.2 50.703 3.125 43.378 3.125H37.478H33.778H26.178H22.478H16.478C9.12803 3.125 5.72803 6.2 4.65303 13.825L3.97803 20.7C3.72803 23.375 4.45303 25.975 6.02803 28C7.92803 30.475 10.853 31.875 14.103 31.875C17.253 31.875 20.278 30.3 22.178 27.775C23.878 30.3 26.778 31.875 30.003 31.875C33.228 31.875 36.053 30.375 37.778 27.875C39.703 30.35 42.678 31.875 45.778 31.875C49.103 31.875 52.103 30.4 53.978 27.8C55.478 25.8 56.153 23.275 55.903 20.675Z"
            fill="#59C6C9"
          />
          <path
            d="M28.3719 41.65C25.1969 41.975 22.7969 44.675 22.7969 47.875V54.725C22.7969 55.4 23.3469 55.95 24.0219 55.95H35.9469C36.6219 55.95 37.1719 55.4 37.1719 54.725V48.75C37.1969 43.525 34.1219 41.05 28.3719 41.65Z"
            fill="#59C6C9"
          />
          <path
            d="M53.4281 35.9999V43.4499C53.4281 50.3499 47.8281 55.9499 40.9281 55.9499C40.2531 55.9499 39.7031 55.3999 39.7031 54.7249V48.75C39.7031 45.5499 38.7281 43.05 36.8281 41.35C35.1531 39.825 32.8781 39.075 30.0531 39.075C29.4281 39.075 28.8031 39.1 28.1281 39.175C23.6781 39.625 20.3031 43.3749 20.3031 47.8749V54.7249C20.3031 55.3999 19.7531 55.9499 19.0781 55.9499C12.1781 55.9499 6.57812 50.3499 6.57812 43.4499V36.05C6.57812 34.3 8.30312 33.125 9.92812 33.6999C10.6031 33.9249 11.2781 34.1 11.9781 34.2C12.2781 34.25 12.6031 34.3 12.9031 34.3C13.3031 34.35 13.7031 34.375 14.1031 34.375C17.0031 34.375 19.8531 33.3 22.1031 31.45C24.2531 33.3 27.0531 34.375 30.0031 34.375C32.9781 34.375 35.7281 33.35 37.8781 31.5C40.1281 33.325 42.9281 34.375 45.7781 34.375C46.2281 34.375 46.6781 34.35 47.1031 34.3C47.4031 34.275 47.6781 34.25 47.9531 34.2C48.7281 34.1 49.4281 33.875 50.1281 33.65C51.7531 33.1 53.4281 34.3 53.4281 35.9999Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "controlPanel":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 60 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M52.0778 20.525L35.7028 7.42505C32.5028 4.87505 27.5028 4.85005 24.3278 7.40005L7.95284 20.525C5.60284 22.4 4.17784 26.15 4.67784 29.1L7.82784 47.95C8.55284 52.175 12.4778 55.5 16.7528 55.5H43.2528C47.4778 55.5 51.4778 52.1 52.2028 47.925L55.3528 29.075C55.8028 26.15 54.3778 22.4 52.0778 20.525ZM31.8778 45.5C31.8778 46.525 31.0278 47.375 30.0028 47.375C28.9778 47.375 28.1278 46.525 28.1278 45.5V38C28.1278 36.975 28.9778 36.125 30.0028 36.125C31.0278 36.125 31.8778 36.975 31.8778 38V45.5Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "whatsapp":
      return (
        <svg
          width="33"
          height="33"
          viewBox="0 0 39 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_823_3927)">
            <path
              d="M0.832695 19.7606C0.831781 23.1214 1.69466 26.403 3.3354 29.2954L0.675781 39.1778L10.6135 36.5261C13.3621 38.0489 16.4417 38.8468 19.5713 38.847H19.5795C29.9107 38.847 38.3205 30.2915 38.3249 19.7757C38.3269 14.68 36.3788 9.88839 32.8392 6.28342C29.3003 2.67877 24.5936 0.692572 19.5787 0.690247C9.24634 0.690247 0.837113 9.24529 0.832848 19.7606"
              fill="url(#paint0_linear_823_3927)"
            />
            <path
              d="M0.163008 19.7544C0.161941 23.2361 1.05574 26.635 2.75498 29.631L0 39.8678L10.294 37.1209C13.1304 38.6947 16.3238 39.5245 19.5733 39.5257H19.5817C30.2835 39.5257 38.9954 30.6625 39 19.7702C39.0018 14.4915 36.9836 9.5276 33.3176 5.79349C29.6511 2.05984 24.7761 0.00217054 19.5817 0C8.87798 0 0.167273 8.86202 0.163008 19.7544ZM6.29332 29.115L5.90896 28.4941C4.2932 25.8795 3.44038 22.8581 3.4416 19.7557C3.4451 10.7022 10.6851 3.33643 19.5878 3.33643C23.8991 3.33829 27.9508 5.04868 30.9983 8.15194C34.0456 11.2555 35.7225 15.3811 35.7214 19.769C35.7174 28.8225 28.4773 36.1891 19.5817 36.1891H19.5753C16.6787 36.1876 13.838 35.396 11.3606 33.9L10.771 33.5442L4.66233 35.1741L6.29332 29.1149V29.115Z"
              fill="url(#paint1_linear_823_3927)"
            />
            <path
              d="M14.7285 11.4958C14.365 10.6737 13.9824 10.6571 13.6368 10.6427C13.3537 10.6302 13.0301 10.6312 12.7069 10.6312C12.3833 10.6312 11.8576 10.7551 11.4132 11.2489C10.9683 11.7431 9.71484 12.9375 9.71484 15.3668C9.71484 17.7963 11.4535 20.144 11.6959 20.4738C11.9386 20.803 15.0525 25.9478 19.9842 27.927C24.0828 29.5718 24.9169 29.2447 25.8065 29.1622C26.6961 29.08 28.6772 27.9681 29.0814 26.8151C29.4859 25.6622 29.4859 24.674 29.3646 24.4675C29.2433 24.2617 28.9198 24.1382 28.4345 23.8913C27.9492 23.6444 25.5638 22.4498 25.1191 22.285C24.6742 22.1203 24.3508 22.0382 24.0272 22.5326C23.7037 23.0262 22.7745 24.1382 22.4913 24.4675C22.2084 24.7975 21.9252 24.8386 21.4401 24.5916C20.9546 24.3439 19.392 23.8231 17.5382 22.1411C16.0958 20.8323 15.122 19.216 14.8389 18.7216C14.5559 18.2279 14.8086 17.9603 15.0519 17.7143C15.2699 17.493 15.5373 17.1377 15.7801 16.8495C16.022 16.5611 16.1028 16.3554 16.2646 16.0261C16.4265 15.6965 16.3455 15.4081 16.2243 15.1611C16.1028 14.9141 15.1599 12.4721 14.7285 11.4958Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_823_3927"
              x1="1883.13"
              y1="3849.45"
              x2="1883.13"
              y2="0.690247"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1FAF38" />
              <stop offset="1" stop-color="#60D669" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_823_3927"
              x1="1950"
              y1="3986.78"
              x2="1950"
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F9F9F9" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <clipPath id="clip0_823_3927">
              <rect width="39" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "excel":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 28 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.784 3.71673H16.2368V1.7027L2.1875 3.87114V22.8783L16.2368 25.2982V22.313H24.784C25.0428 22.3261 25.2963 22.2362 25.4891 22.0629C25.6818 21.8896 25.7981 21.647 25.8125 21.3882V4.64064C25.7979 4.38199 25.6815 4.13964 25.4888 3.96653C25.2961 3.79342 25.0427 3.70361 24.784 3.71673ZM24.919 21.5418H16.2081L16.1938 19.948H18.2922V18.0917H16.1777L16.1676 16.9948H18.2922V15.1386H16.1516L16.1414 14.0417H18.2922V12.1854H16.1347V11.0886H18.2922V9.23232H16.1347V8.13545H18.2922V6.2792H16.1347V4.5917H24.919V21.5418Z"
            fill="#20744A"
          />
          <path
            d="M19.4766 6.27664H23.1241V8.13289H19.4766V6.27664ZM19.4766 9.23061H23.1241V11.0869H19.4766V9.23061ZM19.4766 12.1846H23.1241V14.0408H19.4766V12.1846ZM19.4766 15.1385H23.1241V16.9948H19.4766V15.1385ZM19.4766 18.0925H23.1241V19.9488H19.4766V18.0925Z"
            fill="#20744A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.85838 9.00536L7.66906 8.90158L8.80728 12.031L10.1522 8.77248L11.9629 8.6687L9.76409 13.1119L11.9629 17.566L10.0484 17.437L8.75581 14.0417L7.46234 17.3079L5.70312 17.1526L7.74669 13.2182L5.85838 9.00536Z"
            fill="white"
          />
        </svg>
      );
    case "dollarSign":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="40" fill="#E1FEFF" />
          <path
            d="M57.75 65.1467H59.2667C60.7833 65.1467 62.0433 63.7933 62.0433 62.16C62.0433 60.13 61.32 59.7333 60.13 59.3133L57.7733 58.4967V65.1467H57.75Z"
            fill="#59C6C9"
          />
          <path
            d="M55.9276 32.4333C43.0476 32.48 32.6176 42.9567 32.6642 55.8367C32.7109 68.7167 43.1876 79.1467 56.0676 79.1C68.9475 79.0533 79.3775 68.5767 79.3309 55.6967C79.2842 42.8167 68.8076 32.41 55.9276 32.4333ZM61.2709 56C63.0909 56.63 65.5409 57.9833 65.5409 62.16C65.5409 65.7533 62.7176 68.6467 59.2642 68.6467H57.7476V70C57.7476 70.9567 56.9542 71.75 55.9976 71.75C55.0409 71.75 54.2476 70.9567 54.2476 70V68.6467H53.4076C49.5809 68.6467 46.4776 65.4267 46.4776 61.46C46.4776 60.5033 47.2709 59.71 48.2276 59.71C49.1842 59.71 49.9776 60.5033 49.9776 61.46C49.9776 63.49 51.5176 65.1467 53.4076 65.1467H54.2476V57.26L50.7242 56C48.9042 55.37 46.4542 54.0167 46.4542 49.84C46.4542 46.2467 49.2776 43.3533 52.7309 43.3533H54.2476V42C54.2476 41.0433 55.0409 40.25 55.9976 40.25C56.9542 40.25 57.7476 41.0433 57.7476 42V43.3533H58.5875C62.4142 43.3533 65.5176 46.5733 65.5176 50.54C65.5176 51.4967 64.7242 52.29 63.7675 52.29C62.8109 52.29 62.0175 51.4967 62.0175 50.54C62.0175 48.51 60.4776 46.8533 58.5875 46.8533H57.7476V54.74L61.2709 56Z"
            fill="#59C6C9"
          />
          <path
            d="M49.9766 49.8633C49.9766 51.8933 50.6999 52.29 51.8899 52.71L54.2466 53.5267V46.8533H52.7299C51.2132 46.8533 49.9766 48.2067 49.9766 49.8633Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "checkSign":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="40" fill="#E2FFE3" />
          <path
            d="M55.9974 32.6667C43.1407 32.6667 32.6641 43.1433 32.6641 56C32.6641 68.8567 43.1407 79.3333 55.9974 79.3333C68.8541 79.3333 79.3307 68.8567 79.3307 56C79.3307 43.1433 68.8541 32.6667 55.9974 32.6667ZM67.1507 50.6333L53.9207 63.8633C53.5941 64.19 53.1507 64.3767 52.6841 64.3767C52.2174 64.3767 51.7741 64.19 51.4474 63.8633L44.8441 57.26C44.1674 56.5833 44.1674 55.4633 44.8441 54.7867C45.5207 54.11 46.6407 54.11 47.3174 54.7867L52.6841 60.1533L64.6774 48.16C65.3541 47.4833 66.4741 47.4833 67.1507 48.16C67.8274 48.8367 67.8274 49.9333 67.1507 50.6333Z"
            fill="#34B53A"
          />
        </svg>
      );
    case "payReqIc":
      return (
        <svg
          width="65"
          height="65"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#F2F1FF" />
          <path
            d="M74.5967 48.4167H67.7367C64.7733 48.4167 63 46.6433 63 43.68V36.82C63 33.8567 64.7733 32.0833 67.7367 32.0833H74.5967C77.56 32.0833 79.3333 33.8567 79.3333 36.82V43.68C79.3333 46.6433 77.56 48.4167 74.5967 48.4167ZM75.11 40.6933C74.83 40.4133 74.4567 40.2733 74.0833 40.2733C73.71 40.2733 73.3367 40.4133 73.0567 40.6933L72.6367 41.1133V35.8867C72.6367 35.07 71.9833 34.4167 71.1667 34.4167C70.35 34.4167 69.6967 35.07 69.6967 35.8867V41.1133L69.2767 40.6933C68.7167 40.1333 67.7833 40.1333 67.2233 40.6933C66.6633 41.2533 66.6633 42.1867 67.2233 42.7467L70.14 45.6633C70.2567 45.78 70.42 45.8733 70.5833 45.9433C70.63 45.9667 70.6767 45.9667 70.7233 45.99C70.84 46.0367 70.9567 46.06 71.0967 46.06C71.1433 46.06 71.19 46.06 71.2367 46.06C71.4 46.06 71.54 46.0367 71.7033 45.9667C71.7267 45.9667 71.7267 45.9667 71.75 45.9667C71.9133 45.8967 72.0533 45.8033 72.17 45.6867C72.1933 45.6633 72.1933 45.6633 72.2167 45.6633L75.1333 42.7467C75.6933 42.1867 75.6933 41.2533 75.11 40.6933Z"
            fill="#4339F2"
          />
          <path
            d="M32.6641 54.74V66.4067C32.6641 71.75 36.9807 76.0667 42.3241 76.0667H69.6474C74.9907 76.0667 79.3307 71.7267 79.3307 66.3833V54.74C79.3307 53.1767 78.0707 51.9167 76.5074 51.9167H35.4874C33.9241 51.9167 32.6641 53.1767 32.6641 54.74ZM46.6641 68.25H41.9974C41.0407 68.25 40.2474 67.4567 40.2474 66.5C40.2474 65.5433 41.0407 64.75 41.9974 64.75H46.6641C47.6207 64.75 48.4141 65.5433 48.4141 66.5C48.4141 67.4567 47.6207 68.25 46.6641 68.25ZM61.8307 68.25H52.4974C51.5407 68.25 50.7474 67.4567 50.7474 66.5C50.7474 65.5433 51.5407 64.75 52.4974 64.75H61.8307C62.7874 64.75 63.5807 65.5433 63.5807 66.5C63.5807 67.4567 62.7874 68.25 61.8307 68.25Z"
            fill="#4339F2"
          />
          <path
            d="M59.4974 38.7567V45.5933C59.4974 47.1567 58.2374 48.4167 56.6741 48.4167H35.4874C33.9007 48.4167 32.6641 47.11 32.6641 45.5467C32.6874 42.91 33.7374 40.5067 35.4874 38.7567C37.2374 37.0067 39.6641 35.9333 42.3241 35.9333H56.6741C58.2374 35.9333 59.4974 37.1933 59.4974 38.7567Z"
            fill="#4339F2"
          />
        </svg>
      );
    case "statsIcon":
      return (
        <svg
          width="65"
          height="65"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="43" fill="#D9EFFF" />
          <path
            d="M65.7741 32.6667H46.2207C37.7274 32.6667 32.6641 37.73 32.6641 46.2234V65.7534C32.6641 74.27 37.7274 79.3334 46.2207 79.3334H65.7507C74.2441 79.3334 79.3074 74.27 79.3074 65.7767V46.2234C79.3307 37.73 74.2674 32.6667 65.7741 32.6667ZM49.2541 67.4334C49.2541 68.0867 48.7407 68.6 48.0874 68.6H41.5774C40.9241 68.6 40.4107 68.0867 40.4107 67.4334V56.6534C40.4107 55.1834 41.6007 53.9934 43.0707 53.9934H48.0874C48.7407 53.9934 49.2541 54.5067 49.2541 55.16V67.4334ZM60.4074 67.4334C60.4074 68.0867 59.8941 68.6 59.2407 68.6H52.7307C52.0774 68.6 51.5641 68.0867 51.5641 67.4334V46.06C51.5641 44.59 52.7541 43.4 54.2241 43.4H57.7707C59.2407 43.4 60.4307 44.59 60.4307 46.06V67.4334H60.4074ZM71.5841 67.4334C71.5841 68.0867 71.0707 68.6 70.4174 68.6H63.9074C63.2541 68.6 62.7407 68.0867 62.7407 67.4334V59.15C62.7407 58.4967 63.2541 57.9834 63.9074 57.9834H68.9241C70.3941 57.9834 71.5841 59.1734 71.5841 60.6434V67.4334Z"
            fill="#006F9E"
          />
        </svg>
      );
    case "cubeIcon":
      return (
        <svg
          width="65"
          height="65"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#FFF0D9" />
          <path
            d="M74.9016 44.1934C74.9016 45.4534 74.2249 46.5967 73.1516 47.18L69.0916 49.3734L65.6382 51.2167L58.4749 55.09C57.7049 55.51 56.8649 55.72 56.0016 55.72C55.1382 55.72 54.2982 55.51 53.5282 55.09L38.8516 47.18C37.7782 46.5967 37.1016 45.4534 37.1016 44.1934C37.1016 42.9334 37.7782 41.79 38.8516 41.2067L43.4482 38.7334L47.1116 36.75L53.5282 33.2967C55.0682 32.4567 56.9349 32.4567 58.4749 33.2967L73.1516 41.2067C74.2249 41.79 74.9016 42.9334 74.9016 44.1934Z"
            fill="#F3A837"
          />
          <path
            d="M51.0971 57.8434L37.4471 51.03C36.3971 50.4934 35.1838 50.5634 34.1804 51.17C33.1771 51.7767 32.5938 52.85 32.5938 54.0167V66.92C32.5938 69.16 33.8304 71.1667 35.8371 72.17L49.4871 78.9834C49.9538 79.2167 50.4671 79.3334 50.9804 79.3334C51.5871 79.3334 52.1938 79.17 52.7304 78.82C53.7338 78.2134 54.3171 77.14 54.3171 75.9734V63.07C54.3404 60.8534 53.1038 58.8467 51.0971 57.8434Z"
            fill="#F3A837"
          />
          <path
            d="M79.4029 54.0167V66.92C79.4029 69.1367 78.1663 71.1434 76.1596 72.1467L62.5096 78.9834C62.0429 79.2167 61.5296 79.3334 61.0162 79.3334C60.4096 79.3334 59.8029 79.17 59.2429 78.82C58.2629 78.2134 57.6562 77.14 57.6562 75.9734V63.0934C57.6562 60.8534 58.8929 58.8467 60.8996 57.8434L65.9163 55.3467L69.4163 53.5967L74.5496 51.03C75.5996 50.4934 76.8129 50.54 77.8163 51.17C78.7963 51.7767 79.4029 52.85 79.4029 54.0167Z"
            fill="#F3A837"
          />
          <path
            d="M69.0886 49.3733L65.6353 51.2167L43.4453 38.7333L47.1086 36.75L68.5286 48.8367C68.762 48.9767 68.9486 49.1633 69.0886 49.3733Z"
            fill="#F3A837"
          />
          <path
            d="M69.4141 53.5967V58.8933C69.4141 59.85 68.6207 60.6433 67.6641 60.6433C66.7074 60.6433 65.9141 59.85 65.9141 58.8933V55.3467L69.4141 53.5967Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "checkedCube":
      return (
        <svg
          width="65"
          height="65"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#F6EDFD" />
          <path
            d="M69.0665 40.39L55.8831 33.2967C54.4831 32.55 52.8265 32.55 51.4265 33.2967L38.2665 40.39C37.3098 40.9267 36.7031 41.9534 36.7031 43.0734C36.7031 44.2167 37.2865 45.2434 38.2665 45.7567L51.4498 52.85C52.1498 53.2234 52.9198 53.41 53.6665 53.41C54.4131 53.41 55.2065 53.2234 55.8831 52.85L69.0665 45.7567C70.0231 45.2434 70.6298 44.2167 70.6298 43.0734C70.6298 41.9534 70.0231 40.9267 69.0665 40.39Z"
            fill="#9B1CFF"
          />
          <path
            d="M49.2774 55.3234L37.0274 49.21C36.0707 48.72 34.9974 48.79 34.0874 49.3267C33.2007 49.8867 32.6641 50.8434 32.6641 51.8934V63.4667C32.6641 65.4734 33.7841 67.27 35.5807 68.18L47.8307 74.2934C48.2507 74.5034 48.7174 74.62 49.1841 74.62C49.7207 74.62 50.2807 74.4567 50.7707 74.1767C51.6574 73.6167 52.1941 72.66 52.1941 71.61V60.0367C52.1707 58.03 51.0507 56.2334 49.2774 55.3234Z"
            fill="#9B1CFF"
          />
          <path
            d="M74.6629 51.8934V57.6334C73.5429 57.3067 72.3529 57.1667 71.1629 57.1667C67.9896 57.1667 64.8863 58.2634 62.4363 60.2234C59.0762 62.86 57.1629 66.85 57.1629 71.1667C57.1629 72.31 57.3029 73.4534 57.6062 74.55C57.2562 74.5034 56.9062 74.3634 56.5796 74.1534C55.6929 73.6167 55.1562 72.66 55.1562 71.61V60.0367C55.1562 58.03 56.2762 56.2334 58.0496 55.3234L70.2996 49.21C71.2562 48.72 72.3296 48.79 73.2396 49.3267C74.1262 49.8867 74.6629 50.8434 74.6629 51.8934Z"
            fill="#9B1CFF"
          />
          <path
            d="M79.2841 64.5633C77.3707 62.2067 74.4541 60.7133 71.1641 60.7133C68.6907 60.7133 66.4041 61.5767 64.6074 63.0233C62.1807 64.9367 60.6641 67.9 60.6641 71.2133C60.6641 73.1733 61.2241 75.04 62.1807 76.6266C62.8107 77.6766 63.6041 78.5866 64.5374 79.3333H64.5607C66.3574 80.8266 68.6674 81.7133 71.1641 81.7133C73.8241 81.7133 76.2274 80.7333 78.0707 79.1C78.8874 78.4 79.5874 77.56 80.1474 76.6266C81.1041 75.04 81.6641 73.1733 81.6641 71.2133C81.6641 68.6933 80.7774 66.36 79.2841 64.5633ZM76.4374 69.9066L70.8374 75.0866C70.5107 75.39 70.0674 75.5533 69.6474 75.5533C69.2041 75.5533 68.7607 75.39 68.4107 75.04L65.8207 72.45C65.1441 71.7733 65.1441 70.6533 65.8207 69.9766C66.4974 69.3 67.6174 69.3 68.2941 69.9766L69.6941 71.3766L74.0574 67.34C74.7574 66.6867 75.8774 66.7333 76.5307 67.4333C77.2074 68.1566 77.1607 69.2533 76.4374 69.9066Z"
            fill="#9B1CFF"
          />
        </svg>
      );
    case "ordersShipped":
      return (
        <svg
          width="65"
          height="65"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#E2F5FB" />
          <path
            d="M78.1641 64.1666C78.8174 64.1666 79.3307 64.68 79.3307 65.3333V67.6666C79.3307 71.54 76.2041 74.6666 72.3307 74.6666C72.3307 70.8166 69.1807 67.6666 65.3307 67.6666C61.4807 67.6666 58.3307 70.8166 58.3307 74.6666H53.6641C53.6641 70.8166 50.5141 67.6666 46.6641 67.6666C42.8141 67.6666 39.6641 70.8166 39.6641 74.6666C35.7907 74.6666 32.6641 71.54 32.6641 67.6666V63C32.6641 61.7166 33.7141 60.6666 34.9974 60.6666H57.1641C60.3841 60.6666 62.9974 58.0533 62.9974 54.8333V42C62.9974 40.7166 64.0474 39.6666 65.3307 39.6666H67.2907C68.9707 39.6666 70.5107 40.5766 71.3507 42.0233L72.8441 44.6366C73.0541 45.01 72.7741 45.5 72.3307 45.5C69.1107 45.5 66.4974 48.1133 66.4974 51.3333V58.3333C66.4974 61.5533 69.1107 64.1666 72.3307 64.1666H78.1641Z"
            fill="#00C2FF"
          />
          <path
            d="M46.6667 79.3333C49.244 79.3333 51.3333 77.244 51.3333 74.6667C51.3333 72.0893 49.244 70 46.6667 70C44.0893 70 42 72.0893 42 74.6667C42 77.244 44.0893 79.3333 46.6667 79.3333Z"
            fill="#00C2FF"
          />
          <path
            d="M65.3307 79.3333C67.9081 79.3333 69.9974 77.244 69.9974 74.6667C69.9974 72.0893 67.9081 70 65.3307 70C62.7534 70 60.6641 72.0893 60.6641 74.6667C60.6641 77.244 62.7534 79.3333 65.3307 79.3333Z"
            fill="#00C2FF"
          />
          <path
            d="M79.3333 57.2367V60.6667H72.3333C71.05 60.6667 70 59.6167 70 58.3333V51.3333C70 50.05 71.05 49 72.3333 49H75.3433L78.7267 54.9267C79.1233 55.6267 79.3333 56.42 79.3333 57.2367Z"
            fill="#00C2FF"
          />
          <path
            d="M58.5252 32.6666H41.2819C37.1052 32.6666 33.6052 35.6533 32.8352 39.62H43.0319C43.9185 39.62 44.6185 40.3433 44.6185 41.23C44.6185 42.1166 43.9185 42.8166 43.0319 42.8166H32.6719V46.0366H38.7385C39.6252 46.0366 40.3485 46.76 40.3485 47.6466C40.3485 48.5333 39.6252 49.2333 38.7385 49.2333H32.6719V52.4533H34.4685C35.3552 52.4533 36.0785 53.1766 36.0785 54.0633C36.0785 54.95 35.3552 55.65 34.4685 55.65H32.6719V56.1866C32.6719 57.47 33.7219 58.52 35.0052 58.52H56.3552C58.7352 58.52 60.6719 56.5833 60.6719 54.2033V34.8133C60.6719 33.6233 59.7152 32.6666 58.5252 32.6666Z"
            fill="#00C2FF"
          />
          <path
            d="M32.8326 39.62H32.4826H30.1959C29.3093 39.62 28.5859 40.3433 28.5859 41.23C28.5859 42.1167 29.3093 42.8167 30.1959 42.8167H32.3193H32.6693V41.2767C32.6693 40.7167 32.7393 40.1567 32.8326 39.62Z"
            fill="#00C2FF"
          />
          <path
            d="M32.3193 46.0366H30.1959C29.3093 46.0366 28.5859 46.76 28.5859 47.6466C28.5859 48.5333 29.3093 49.2333 30.1959 49.2333H32.3193H32.6693V46.0366H32.3193Z"
            fill="#00C2FF"
          />
          <path
            d="M32.3193 52.4532H30.1959C29.3093 52.4532 28.5859 53.1766 28.5859 54.0632C28.5859 54.9499 29.3093 55.6499 30.1959 55.6499H32.3193H32.6693V52.4532H32.3193Z"
            fill="#00C2FF"
          />
        </svg>
      );
    case "ordersPending":
      return (
        <svg
          width="65"
          height="65"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#FFE9E7" />
          <path
            d="M64.8174 32.6666H47.1774C38.3574 32.6666 36.1641 35.0233 36.1641 44.4266V70.7C36.1641 76.9066 39.5707 78.3766 43.7007 73.9433L43.7241 73.92C45.6374 71.89 48.5541 72.0533 50.2107 74.27L52.5674 77.42C54.4574 79.9166 57.5141 79.9166 59.4041 77.42L61.7607 74.27C63.4407 72.03 66.3574 71.8666 68.2707 73.92C72.4241 78.3533 75.8074 76.8833 75.8074 70.6766V44.4266C75.8307 35.0233 73.6374 32.6666 64.8174 32.6666ZM46.1507 56C44.8674 56 43.8174 54.95 43.8174 53.6666C43.8174 52.3833 44.8674 51.3333 46.1507 51.3333C47.4341 51.3333 48.4841 52.3833 48.4841 53.6666C48.4841 54.95 47.4341 56 46.1507 56ZM46.1507 46.6666C44.8674 46.6666 43.8174 45.6166 43.8174 44.3333C43.8174 43.05 44.8674 42 46.1507 42C47.4341 42 48.4841 43.05 48.4841 44.3333C48.4841 45.6166 47.4341 46.6666 46.1507 46.6666ZM65.8674 55.4166H53.0341C52.0774 55.4166 51.2841 54.6233 51.2841 53.6666C51.2841 52.71 52.0774 51.9166 53.0341 51.9166H65.8674C66.8241 51.9166 67.6174 52.71 67.6174 53.6666C67.6174 54.6233 66.8241 55.4166 65.8674 55.4166ZM65.8674 46.0833H53.0341C52.0774 46.0833 51.2841 45.29 51.2841 44.3333C51.2841 43.3766 52.0774 42.5833 53.0341 42.5833H65.8674C66.8241 42.5833 67.6174 43.3766 67.6174 44.3333C67.6174 45.29 66.8241 46.0833 65.8674 46.0833Z"
            fill="#E12616"
          />
        </svg>
      );
    case "bluewaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 148 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 30.8095C8.08295 30.8572 8.76317 36.3595 13.1048 37.9195C17.4465 39.4796 19.259 19.3302 24.2118 18.6613C29.1646 17.9924 30.9107 44.4387 35.3187 43.0596C39.7268 41.6806 40.0576 29.7403 45.8703 27.7954C51.6831 25.8504 51.1871 45.4452 56.4219 45.995C61.6568 46.5447 61.5692 2 66.9735 2C72.3779 2 72.9243 32.277 78.6358 31.77C84.3474 31.263 84.461 14.4053 90.5932 14.4053C96.7253 14.4053 98.6525 29.3748 104.044 30.7619C109.435 32.149 108.081 47.9617 113.623 43.0596C119.164 38.1576 118.432 19.5138 123.619 18.6613C128.806 17.8088 130.52 29.7475 134.99 31.77C139.46 33.7925 141.601 43.119 146 43.119"
            stroke="#59C6C9"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "greenwaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 149 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 27.1207C9.13594 27.0975 9.16356 3.83385 13.5 2.12558C17.8364 0.417314 31.0972 16.6762 35.5 18.1862C39.9028 19.6963 40.7886 43.3288 46.5943 45.4585C52.4 47.5883 63.6022 25.8954 69 25.8954C74.3978 25.8954 74.2953 17.6311 80 18.1862C85.7047 18.7414 84.8752 2.12558 91 2.12558C97.1248 2.12558 98.6152 27.4142 104 25.8954C109.385 24.3765 107.965 39.8004 113.5 45.1681C119.035 50.5359 130.865 28.2547 135.33 26.0401C135.33 26.0401 142.106 45.1681 146.5 45.1681"
            stroke="#34B53A"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "terquazwaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 148 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 30.8095C8.08295 30.8572 8.76317 36.3595 13.1048 37.9195C17.4465 39.4796 19.259 19.3302 24.2118 18.6613C29.1646 17.9924 30.9107 44.4387 35.3187 43.0596C39.7268 41.6806 40.0576 29.7403 45.8703 27.7954C51.6831 25.8504 51.1871 45.4452 56.4219 45.995C61.6568 46.5447 61.5692 2 66.9735 2C72.3779 2 72.9243 32.277 78.6358 31.77C84.3474 31.263 84.461 14.4053 90.5932 14.4053C96.7253 14.4053 98.6525 29.3748 104.044 30.7619C109.435 32.149 108.081 47.9617 113.623 43.0596C119.164 38.1576 118.432 19.5138 123.619 18.6613C128.806 17.8088 130.52 29.7475 134.99 31.77C139.46 33.7925 141.601 43.119 146 43.119"
            stroke="#4339F2"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "darkblueswaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 148 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M146 37.928C139.532 37.8708 138.676 31.7837 133.974 30.0554C129.273 28.3271 127.304 1.27391 121.941 2.01495C116.577 2.75598 104.773 30.2724 98.4779 32.4271C92.1832 34.5818 81.4646 40.5155 75.6121 40.5155C69.7597 40.5155 56.7004 28.1133 50.0598 28.1133C43.4192 28.1133 41.331 5.27715 35.4926 3.74046C29.6543 2.20377 31.1056 40.0456 25.1045 45.4763C19.1035 50.9071 19.9152 12.2863 14.2985 13.2308C8.68188 14.1752 6.84076 40.2757 2 38.035"
            stroke="#006F9E"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "yellowwaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 149 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 27.1207C9.13594 27.0975 9.16356 3.83385 13.5 2.12558C17.8364 0.417314 31.0972 16.6762 35.5 18.1862C39.9028 19.6963 40.7886 43.3288 46.5943 45.4585C52.4 47.5883 63.6022 25.8954 69 25.8954C74.3978 25.8954 74.2953 17.6311 80 18.1862C85.7047 18.7414 84.8752 2.12558 91 2.12558C97.1248 2.12558 98.6152 27.4142 104 25.8954C109.385 24.3765 107.965 39.8004 113.5 45.1681C119.035 50.5359 130.865 28.2547 135.33 26.0401C135.33 26.0401 142.106 45.1681 146.5 45.1681"
            stroke="#F3A837"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "graphic5":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 149 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 30.8095C8.58295 30.8572 9.26317 36.3595 13.6048 37.9195C17.9465 39.4796 19.759 19.3302 24.7118 18.6613C29.6646 17.9924 31.4107 44.4387 35.8187 43.0596C40.2268 41.6806 40.5576 29.7403 46.3703 27.7954C52.1831 25.8504 51.6871 45.4452 56.9219 45.995C62.1568 46.5447 62.0692 2 67.4735 2C72.8779 2 73.4243 32.277 79.1358 31.77C84.8474 31.263 84.961 14.4053 91.0932 14.4053C97.2253 14.4053 99.1525 29.3748 104.544 30.7619C109.935 32.149 108.581 47.9617 114.123 43.0596C119.664 38.1576 118.932 19.5138 124.119 18.6613C129.306 17.8088 131.02 29.7475 135.49 31.77C139.96 33.7925 142.101 43.119 146.5 43.119"
            stroke="#9B1CFF"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "bluewaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 149 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 30.8095C8.58295 30.8572 9.26317 36.3595 13.6048 37.9195C17.9465 39.4796 19.759 19.3302 24.7118 18.6613C29.6646 17.9924 31.4107 44.4387 35.8187 43.0596C40.2268 41.6806 40.5576 29.7403 46.3703 27.7954C52.1831 25.8504 51.6871 45.4452 56.9219 45.995C62.1568 46.5447 62.0692 2 67.4735 2C72.8779 2 73.4243 32.277 79.1358 31.77C84.8474 31.263 84.961 14.4053 91.0932 14.4053C97.2253 14.4053 99.1525 29.3748 104.544 30.7619C109.935 32.149 108.581 47.9617 114.123 43.0596C119.664 38.1576 118.932 19.5138 124.119 18.6613C129.306 17.8088 131.02 29.7475 135.49 31.77C139.96 33.7925 142.101 43.119 146.5 43.119"
            stroke="#00C2FF"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "redwaves":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 149 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 30.8095C8.58295 30.8572 9.26317 36.3595 13.6048 37.9195C17.9465 39.4796 19.759 19.3302 24.7118 18.6613C29.6646 17.9924 31.4107 44.4387 35.8187 43.0596C40.2268 41.6806 40.5576 29.7403 46.3703 27.7954C52.1831 25.8504 51.6871 45.4452 56.9219 45.995C62.1568 46.5447 62.0692 2 67.4735 2C72.8779 2 73.4243 32.277 79.1358 31.77C84.8474 31.263 84.961 14.4053 91.0932 14.4053C97.2253 14.4053 99.1525 29.3748 104.544 30.7619C109.935 32.149 108.581 47.9617 114.123 43.0596C119.664 38.1576 118.932 19.5138 124.119 18.6613C129.306 17.8088 131.02 29.7475 135.49 31.77C139.96 33.7925 142.101 43.119 146.5 43.119"
            stroke="#E12616"
            stroke-width="4"
            stroke-linecap="round"
          />
        </svg>
      );
    case "bluecheck":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#E1FEFF" />
          <path
            d="M55.9974 32.6667C43.1407 32.6667 32.6641 43.1433 32.6641 56C32.6641 68.8567 43.1407 79.3333 55.9974 79.3333C68.8541 79.3333 79.3307 68.8567 79.3307 56C79.3307 43.1433 68.8541 32.6667 55.9974 32.6667ZM67.1507 50.6333L53.9207 63.8633C53.5941 64.19 53.1507 64.3767 52.6841 64.3767C52.2174 64.3767 51.7741 64.19 51.4474 63.8633L44.8441 57.26C44.1674 56.5833 44.1674 55.4633 44.8441 54.7867C45.5207 54.11 46.6407 54.11 47.3174 54.7867L52.6841 60.1533L64.6774 48.16C65.3541 47.4833 66.4741 47.4833 67.1507 48.16C67.8274 48.8367 67.8274 49.9333 67.1507 50.6333Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "bluetrans":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#E1FEFF" />
          <path
            d="M74.5967 48.4167H67.7367C64.7733 48.4167 63 46.6433 63 43.68V36.82C63 33.8567 64.7733 32.0833 67.7367 32.0833H74.5967C77.56 32.0833 79.3333 33.8567 79.3333 36.82V43.68C79.3333 46.6433 77.56 48.4167 74.5967 48.4167ZM75.11 40.6933C74.83 40.4133 74.4567 40.2733 74.0833 40.2733C73.71 40.2733 73.3367 40.4133 73.0567 40.6933L72.6367 41.1133V35.8867C72.6367 35.07 71.9833 34.4167 71.1667 34.4167C70.35 34.4167 69.6967 35.07 69.6967 35.8867V41.1133L69.2767 40.6933C68.7167 40.1333 67.7833 40.1333 67.2233 40.6933C66.6633 41.2533 66.6633 42.1867 67.2233 42.7467L70.14 45.6633C70.2567 45.78 70.42 45.8733 70.5833 45.9433C70.63 45.9667 70.6767 45.9667 70.7233 45.99C70.84 46.0367 70.9567 46.06 71.0967 46.06C71.1433 46.06 71.19 46.06 71.2367 46.06C71.4 46.06 71.54 46.0367 71.7033 45.9667C71.7267 45.9667 71.7267 45.9667 71.75 45.9667C71.9133 45.8967 72.0533 45.8033 72.17 45.6867C72.1933 45.6633 72.1933 45.6633 72.2167 45.6633L75.1333 42.7467C75.6933 42.1867 75.6933 41.2533 75.11 40.6933Z"
            fill="#59C6C9"
          />
          <path
            d="M32.6641 54.74V66.4067C32.6641 71.75 36.9807 76.0667 42.3241 76.0667H69.6474C74.9907 76.0667 79.3307 71.7267 79.3307 66.3833V54.74C79.3307 53.1767 78.0707 51.9167 76.5074 51.9167H35.4874C33.9241 51.9167 32.6641 53.1767 32.6641 54.74ZM46.6641 68.25H41.9974C41.0407 68.25 40.2474 67.4567 40.2474 66.5C40.2474 65.5433 41.0407 64.75 41.9974 64.75H46.6641C47.6207 64.75 48.4141 65.5433 48.4141 66.5C48.4141 67.4567 47.6207 68.25 46.6641 68.25ZM61.8307 68.25H52.4974C51.5407 68.25 50.7474 67.4567 50.7474 66.5C50.7474 65.5433 51.5407 64.75 52.4974 64.75H61.8307C62.7874 64.75 63.5807 65.5433 63.5807 66.5C63.5807 67.4567 62.7874 68.25 61.8307 68.25Z"
            fill="#59C6C9"
          />
          <path
            d="M59.4974 38.7567V45.5933C59.4974 47.1567 58.2374 48.4167 56.6741 48.4167H35.4874C33.9007 48.4167 32.6641 47.11 32.6641 45.5467C32.6874 42.91 33.7374 40.5067 35.4874 38.7567C37.2374 37.0067 39.6641 35.9333 42.3241 35.9333H56.6741C58.2374 35.9333 59.4974 37.1933 59.4974 38.7567Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "orangdash":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#FFD99F" />
          <path
            d="M65.7741 32.6667H46.2207C37.7274 32.6667 32.6641 37.73 32.6641 46.2234V65.7534C32.6641 74.27 37.7274 79.3334 46.2207 79.3334H65.7507C74.2441 79.3334 79.3074 74.27 79.3074 65.7767V46.2234C79.3307 37.73 74.2674 32.6667 65.7741 32.6667ZM49.2541 67.4334C49.2541 68.0867 48.7407 68.6 48.0874 68.6H41.5774C40.9241 68.6 40.4107 68.0867 40.4107 67.4334V56.6534C40.4107 55.1834 41.6007 53.9934 43.0707 53.9934H48.0874C48.7407 53.9934 49.2541 54.5067 49.2541 55.16V67.4334ZM60.4074 67.4334C60.4074 68.0867 59.8941 68.6 59.2407 68.6H52.7307C52.0774 68.6 51.5641 68.0867 51.5641 67.4334V46.06C51.5641 44.59 52.7541 43.4 54.2241 43.4H57.7707C59.2407 43.4 60.4307 44.59 60.4307 46.06V67.4334H60.4074ZM71.5841 67.4334C71.5841 68.0867 71.0707 68.6 70.4174 68.6H63.9074C63.2541 68.6 62.7407 68.0867 62.7407 67.4334V59.15C62.7407 58.4967 63.2541 57.9834 63.9074 57.9834H68.9241C70.3941 57.9834 71.5841 59.1734 71.5841 60.6434V67.4334Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "orangshipping":
      return (
        <svg
          width="60"
          height="60"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="44" fill="#FFD99F" />
          <path
            d="M78.1641 64.1667C78.8174 64.1667 79.3307 64.68 79.3307 65.3334V67.6667C79.3307 71.54 76.2041 74.6667 72.3307 74.6667C72.3307 70.8167 69.1807 67.6667 65.3307 67.6667C61.4807 67.6667 58.3307 70.8167 58.3307 74.6667H53.6641C53.6641 70.8167 50.5141 67.6667 46.6641 67.6667C42.8141 67.6667 39.6641 70.8167 39.6641 74.6667C35.7907 74.6667 32.6641 71.54 32.6641 67.6667V63C32.6641 61.7167 33.7141 60.6667 34.9974 60.6667H57.1641C60.3841 60.6667 62.9974 58.0534 62.9974 54.8334V42C62.9974 40.7167 64.0474 39.6667 65.3307 39.6667H67.2907C68.9707 39.6667 70.5107 40.5767 71.3507 42.0234L72.8441 44.6367C73.0541 45.01 72.7741 45.5 72.3307 45.5C69.1107 45.5 66.4974 48.1134 66.4974 51.3334V58.3334C66.4974 61.5534 69.1107 64.1667 72.3307 64.1667H78.1641Z"
            fill="#F3A837"
          />
          <path
            d="M46.6667 79.3333C49.244 79.3333 51.3333 77.244 51.3333 74.6667C51.3333 72.0893 49.244 70 46.6667 70C44.0893 70 42 72.0893 42 74.6667C42 77.244 44.0893 79.3333 46.6667 79.3333Z"
            fill="#F3A837"
          />
          <path
            d="M65.3307 79.3333C67.9081 79.3333 69.9974 77.244 69.9974 74.6667C69.9974 72.0893 67.9081 70 65.3307 70C62.7534 70 60.6641 72.0893 60.6641 74.6667C60.6641 77.244 62.7534 79.3333 65.3307 79.3333Z"
            fill="#F3A837"
          />
          <path
            d="M79.3333 57.2367V60.6667H72.3333C71.05 60.6667 70 59.6167 70 58.3333V51.3333C70 50.05 71.05 49 72.3333 49H75.3433L78.7267 54.9267C79.1233 55.6267 79.3333 56.42 79.3333 57.2367Z"
            fill="#F3A837"
          />
          <path
            d="M58.5252 32.6667H41.2819C37.1052 32.6667 33.6052 35.6534 32.8352 39.62H43.0319C43.9185 39.62 44.6185 40.3434 44.6185 41.23C44.6185 42.1167 43.9185 42.8167 43.0319 42.8167H32.6719V46.0367H38.7385C39.6252 46.0367 40.3485 46.76 40.3485 47.6467C40.3485 48.5334 39.6252 49.2334 38.7385 49.2334H32.6719V52.4534H34.4685C35.3552 52.4534 36.0785 53.1767 36.0785 54.0634C36.0785 54.95 35.3552 55.65 34.4685 55.65H32.6719V56.1867C32.6719 57.47 33.7219 58.52 35.0052 58.52H56.3552C58.7352 58.52 60.6719 56.5834 60.6719 54.2034V34.8134C60.6719 33.6234 59.7152 32.6667 58.5252 32.6667Z"
            fill="#F3A837"
          />
          <path
            d="M32.8326 39.62H32.4826H30.1959C29.3093 39.62 28.5859 40.3433 28.5859 41.23C28.5859 42.1167 29.3093 42.8167 30.1959 42.8167H32.3193H32.6693V41.2767C32.6693 40.7167 32.7393 40.1567 32.8326 39.62Z"
            fill="#F3A837"
          />
          <path
            d="M32.3193 46.0367H30.1959C29.3093 46.0367 28.5859 46.76 28.5859 47.6467C28.5859 48.5333 29.3093 49.2333 30.1959 49.2333H32.3193H32.6693V46.0367H32.3193Z"
            fill="#F3A837"
          />
          <path
            d="M32.3193 52.4534H30.1959C29.3093 52.4534 28.5859 53.1767 28.5859 54.0634C28.5859 54.95 29.3093 55.65 30.1959 55.65H32.3193H32.6693V52.4534H32.3193Z"
            fill="#F3A837"
          />
        </svg>
      );
    case "bluemoney":
      return (
        <svg
          width="70"
          height="70"
          viewBox="0 0 86 86"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="42.9037" cy="42.9037" r="35.9037" fill="#CEFBFD" />
          <path
            d="M43.2958 43.5375C41.395 43.5375 39.5721 44.2926 38.228 45.6367C36.884 46.9807 36.1289 48.8036 36.1289 50.7044C36.1289 52.6052 36.884 54.4281 38.228 55.7722C39.5721 57.1162 41.395 57.8713 43.2958 57.8713C45.1966 57.8713 47.0195 57.1162 48.3635 55.7722C49.7076 54.4281 50.4626 52.6052 50.4626 50.7044C50.4626 48.8036 49.7076 46.9807 48.3635 45.6367C47.0195 44.2926 45.1966 43.5375 43.2958 43.5375ZM40.2243 50.7044C40.2243 49.8898 40.5479 49.1085 41.1239 48.5325C41.6999 47.9565 42.4812 47.6329 43.2958 47.6329C44.1104 47.6329 44.8916 47.9565 45.4677 48.5325C46.0437 49.1085 46.3673 49.8898 46.3673 50.7044C46.3673 51.519 46.0437 52.3003 45.4677 52.8763C44.8916 53.4523 44.1104 53.7759 43.2958 53.7759C42.4812 53.7759 41.6999 53.4523 41.1239 52.8763C40.5479 52.3003 40.2243 51.519 40.2243 50.7044Z"
            fill="#59C6C9"
          />
          <path
            d="M54.609 28.4175L48.0995 19.291L24.1642 38.4122L22.8373 38.3979V38.4183H21.793V62.9905H64.7942V38.4183H62.8243L58.9051 26.9534L54.609 28.4175ZM58.4976 38.4183H37.9635L53.2576 33.205L56.3741 32.2077L58.4976 38.4183ZM50.5628 29.7976L34.7752 35.1789L47.2784 25.1903L50.5628 29.7976ZM25.8883 55.1458V46.2589C26.7522 45.9528 27.5369 45.4577 28.1852 44.8098C28.8335 44.1619 29.329 43.3774 29.6356 42.5137H56.9516C57.2581 43.3777 57.7535 44.1625 58.4018 44.8108C59.05 45.459 59.8348 45.9545 60.6988 46.2609V55.1479C59.8348 55.4543 59.05 55.9498 58.4018 56.598C57.7535 57.2463 57.2581 58.0311 56.9516 58.8951H29.6397C29.3329 58.0303 28.8369 57.245 28.1879 56.5963C27.5389 55.9477 26.7533 55.4521 25.8883 55.1458Z"
            fill="#59C6C9"
          />
        </svg>
      );
    case "orangemoney":
      return (
        <svg
          width="60"
          height="60"
          viewBox="0 0 86 86"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="42.9037" cy="42.9037" r="35.9037" fill="#FFD99F" />
          <path
            d="M43.2958 43.5375C41.395 43.5375 39.5721 44.2926 38.228 45.6366C36.884 46.9807 36.1289 48.8036 36.1289 50.7043C36.1289 52.6051 36.884 54.428 38.228 55.7721C39.5721 57.1161 41.395 57.8712 43.2958 57.8712C45.1966 57.8712 47.0195 57.1161 48.3635 55.7721C49.7076 54.428 50.4626 52.6051 50.4626 50.7043C50.4626 48.8036 49.7076 46.9807 48.3635 45.6366C47.0195 44.2926 45.1966 43.5375 43.2958 43.5375ZM40.2243 50.7043C40.2243 49.8897 40.5479 49.1085 41.1239 48.5325C41.6999 47.9564 42.4812 47.6328 43.2958 47.6328C44.1104 47.6328 44.8916 47.9564 45.4677 48.5325C46.0437 49.1085 46.3673 49.8897 46.3673 50.7043C46.3673 51.519 46.0437 52.3002 45.4677 52.8762C44.8916 53.4523 44.1104 53.7759 43.2958 53.7759C42.4812 53.7759 41.6999 53.4523 41.1239 52.8762C40.5479 52.3002 40.2243 51.519 40.2243 50.7043Z"
            fill="#F3A837"
          />
          <path
            d="M54.609 28.4175L48.0995 19.291L24.1642 38.4122L22.8373 38.3978V38.4183H21.793V62.9904H64.7942V38.4183H62.8243L58.9051 26.9534L54.609 28.4175ZM58.4976 38.4183H37.9635L53.2576 33.2049L56.3741 32.2077L58.4976 38.4183ZM50.5628 29.7976L34.7752 35.1789L47.2784 25.1903L50.5628 29.7976ZM25.8883 55.1458V46.2589C26.7522 45.9527 27.5369 45.4577 28.1852 44.8097C28.8335 44.1618 29.329 43.3774 29.6356 42.5137H56.9516C57.2581 43.3777 57.7535 44.1625 58.4018 44.8107C59.05 45.459 59.8348 45.9544 60.6988 46.2609V55.1478C59.8348 55.4543 59.05 55.9497 58.4018 56.598C57.7535 57.2463 57.2581 58.031 56.9516 58.8951H29.6397C29.3329 58.0303 28.8369 57.2449 28.1879 56.5963C27.5389 55.9476 26.7533 55.4521 25.8883 55.1458Z"
            fill="#F3A837"
          />
        </svg>
      );

    case "enter":
      return (
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
            fill="rgba(89, 198, 201, 1)"
          />
          <path
            d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
            fill="rgba(89, 198, 201, 1)"
          />
        </svg>
      );
    case "edit":
      return (
        <svg
          fill="#000000"
          height="28px"
          width="28px"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 348.882 348.882"
        >
          <g>
            <path
              d="M333.988,11.758l-0.42-0.383C325.538,4.04,315.129,0,304.258,0c-12.187,0-23.888,5.159-32.104,14.153L116.803,184.231
		c-1.416,1.55-2.49,3.379-3.154,5.37l-18.267,54.762c-2.112,6.331-1.052,13.333,2.835,18.729c3.918,5.438,10.23,8.685,16.886,8.685
		c0,0,0.001,0,0.001,0c2.879,0,5.693-0.592,8.362-1.76l52.89-23.138c1.923-0.841,3.648-2.076,5.063-3.626L336.771,73.176
		C352.937,55.479,351.69,27.929,333.988,11.758z M130.381,234.247l10.719-32.134l0.904-0.99l20.316,18.556l-0.904,0.99
		L130.381,234.247z M314.621,52.943L182.553,197.53l-20.316-18.556L294.305,34.386c2.583-2.828,6.118-4.386,9.954-4.386
		c3.365,0,6.588,1.252,9.082,3.53l0.419,0.383C319.244,38.922,319.63,47.459,314.621,52.943z"
              fill="rgba(89, 198, 201, 1)"
            />
            <path
              d="M303.85,138.388c-8.284,0-15,6.716-15,15v127.347c0,21.034-17.113,38.147-38.147,38.147H68.904
		c-21.035,0-38.147-17.113-38.147-38.147V100.413c0-21.034,17.113-38.147,38.147-38.147h131.587c8.284,0,15-6.716,15-15
		s-6.716-15-15-15H68.904c-37.577,0-68.147,30.571-68.147,68.147v180.321c0,37.576,30.571,68.147,68.147,68.147h181.798
		c37.576,0,68.147-30.571,68.147-68.147V153.388C318.85,145.104,312.134,138.388,303.85,138.388z"
              fill="rgba(89, 198, 201, 1)"
            />
          </g>
        </svg>
      );
    case "construction":
      return (
        <svg
          fill="rgb(89, 198, 201)"
          height="38px"
          width="38px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512.32 512.32"
        >
          <g transform="translate(1 1)">
            <g>
              <g>
                <path
                  d="M179.053,180.648c-1.707-6.827-8.533-11.947-16.213-11.947H101.4c-9.387,0-17.067,7.68-17.067,17.067v42.667
				c0,9.387,7.68,17.067,17.067,17.067h74.24c5.12,0,10.24-2.56,12.8-6.827c3.413-5.12,4.267-10.24,2.56-15.36L179.053,180.648z
				 M101.4,228.435v-42.667h61.44l12.8,42.667H101.4z"
                />
                <path
                  d="M118.467,424.701c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				S123.587,424.701,118.467,424.701z"
                />
                <path
                  d="M161.133,424.701c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				S166.253,424.701,161.133,424.701z"
                />
                <path
                  d="M203.8,424.701c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533c5.12,0,8.533-3.413,8.533-8.533
				S208.92,424.701,203.8,424.701z"
                />
                <path
                  d="M246.467,424.701c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				S251.587,424.701,246.467,424.701z"
                />
                <path
                  d="M289.133,424.701c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533
				S294.253,424.701,289.133,424.701z"
                />
                <path
                  d="M365.933,390.568h-11.545L383,309.501c3.413-5.973,2.56-13.653-0.853-19.627c-4.267-6.827-10.24-10.24-17.92-10.24
				h-80.774l167.814-174.556v89.953c-24.134,4.095-42.667,25.217-42.667,50.47c0,11.093,3.413,22.187,10.24,30.72
				c2.56,3.413,8.533,4.267,11.947,1.707s4.267-8.533,1.707-11.947c-4.267-5.973-6.827-12.8-6.827-20.48
				c0-18.773,15.36-34.133,34.133-34.133c18.773,0,34.133,15.36,34.133,34.133c0,7.68-2.56,14.507-6.827,20.48
				c-2.56,3.413-1.707,9.387,1.707,11.947c1.707,0.853,3.413,1.707,5.12,1.707c2.56,0,5.12-0.853,6.827-3.413
				c6.827-8.533,10.24-19.627,10.24-30.72c0-25.253-18.533-46.375-42.667-50.47V83.368c0-0.324-0.014-0.641-0.041-0.952
				c1.548-4.528,2.168-9.364,1.748-14.408c-0.853-10.24-5.973-19.627-13.653-25.6c-14.507-11.947-35.84-10.24-48.64,3.413
				L242.324,220.881l-17.19-76.926c-3.413-15.36-17.067-26.453-33.28-26.453h-22.187v-17.067c0-18.773-15.36-34.133-34.133-34.133
				c-18.773,0-34.133,15.36-34.133,34.133v17.067H75.8c-18.773,0-34.133,15.36-34.133,34.133v128v17.067v93.867
				C17.773,390.568-1,409.341-1,433.235s18.773,42.667,42.667,42.667h324.267c23.893,0,42.667-18.773,42.667-42.667
				S389.827,390.568,365.933,390.568z M331.597,458.835H76.003c5.25-7.09,8.33-15.924,8.33-25.6s-3.08-18.51-8.33-25.6h255.594
				c-5.25,7.09-8.33,15.924-8.33,25.6S326.347,451.745,331.597,458.835z M420.547,58.621c6.827-6.827,17.92-7.68,25.6-1.707
				c4.267,2.56,6.827,7.68,6.827,12.8s-1.707,10.24-5.12,13.653L260.12,279.635h-4.267l-6.112-25.56l-3.1-13.875L420.547,58.621z
				 M118.467,100.435c0-9.387,7.68-17.067,17.067-17.067s17.067,7.68,17.067,17.067v17.067h-34.133V100.435z M58.733,151.635
				c0-9.387,7.68-17.067,17.067-17.067h25.6h68.267H191c8.533,0,15.36,5.973,17.067,13.653l29.867,131.413h-179.2V151.635z
				 M58.733,364.968h187.733c5.12,0,8.533-3.413,8.533-8.533c0-5.12-3.413-8.533-8.533-8.533H58.733v-17.067h136.533
				c5.12,0,8.533-3.413,8.533-8.533s-3.413-8.533-8.533-8.533H58.733v-16.213h305.493c1.707,0,3.413,0.853,3.413,1.707
				c0,0,0.853,1.707,0,3.413l-30.72,86.187c-0.853,0.853-1.707,1.707-3.413,1.707H58.733V364.968z M16.067,433.235
				c0-14.507,11.093-25.6,25.6-25.6c14.507,0,25.6,11.093,25.6,25.6s-11.093,25.6-25.6,25.6
				C27.16,458.835,16.067,447.741,16.067,433.235z M365.933,458.835c-14.507,0-25.6-11.093-25.6-25.6s11.093-25.6,25.6-25.6
				s25.6,11.093,25.6,25.6S380.44,458.835,365.933,458.835z"
                />
                <path
                  d="M511,338.515l-8.533-34.133c0-2.56-1.707-5.12-4.267-5.973l-34.133-17.067c-3.413-1.707-7.68-0.853-10.24,1.707
				l-34.133,34.133c-2.56,1.707-3.413,5.12-2.56,7.68l8.533,34.133c0.853,2.56,3.413,5.12,6.827,5.973l42.667,8.533
				c0.853,0,0.853,0,1.707,0c2.56,0,4.267-0.853,5.973-1.707l25.6-25.6C511,344.488,511.853,341.075,511,338.515z M474.307,355.581
				l-33.28-6.827l-5.973-23.893l26.453-26.453l24.747,12.8l6.827,25.6L474.307,355.581z"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "warehouse":
      return (
        <svg
          width="30.5"
          height="30.5"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.4985 56.875C36.8235 56.875 36.1985 56.5 35.8735 55.925C35.5485 55.325 35.5485 54.625 35.8985 54.025L38.5235 49.65C39.0485 48.775 40.1985 48.475 41.0985 49C41.9985 49.525 42.2735 50.675 41.7485 51.575L41.0735 52.7C47.9735 51.075 53.1485 44.875 53.1485 37.475C53.1485 36.45 53.9985 35.6 55.0235 35.6C56.0485 35.6 56.8985 36.45 56.8985 37.475C56.8735 48.175 48.1735 56.875 37.4985 56.875Z"
            fill="#59C6C9"
          />
          <path
            d="M5 24.375C3.975 24.375 3.125 23.525 3.125 22.5C3.125 11.825 11.825 3.125 22.5 3.125C23.175 3.125 23.8 3.5 24.125 4.075C24.45 4.675 24.45 5.375 24.1 5.975L21.475 10.35C20.95 11.225 19.8 11.525 18.9 10.975C18.025 10.45 17.725 9.3 18.275 8.4L18.95 7.275C12.025 8.9 6.875 15.1 6.875 22.5C6.875 23.525 6.025 24.375 5 24.375Z"
            fill="#59C6C9"
          />
          <path
            d="M40.9984 20.525L31.5984 15.45C30.5984 14.925 29.4234 14.925 28.4234 15.45L18.9984 20.525C18.3234 20.9 17.8984 21.625 17.8984 22.425C17.8984 23.25 18.3234 23.975 18.9984 24.35L28.3984 29.425C28.8984 29.7 29.4484 29.825 29.9984 29.825C30.5484 29.825 31.0984 29.7 31.5984 29.425L40.9984 24.35C41.6734 23.975 42.0984 23.25 42.0984 22.425C42.0984 21.625 41.6734 20.9 40.9984 20.525Z"
            fill="#59C6C9"
          />
          <path
            d="M26.85 31.175L18.1 26.8C17.425 26.475 16.65 26.5 16 26.9C15.375 27.3 15 27.975 15 28.725V37C15 38.425 15.8 39.725 17.075 40.35L25.825 44.725C26.125 44.875 26.45 44.95 26.8 44.95C27.2 44.95 27.575 44.85 27.925 44.625C28.575 44.225 28.95 43.55 28.95 42.8V34.525C28.925 33.1 28.15 31.825 26.85 31.175Z"
            fill="#59C6C9"
          />
          <path
            d="M43.9719 26.9C43.3219 26.5 42.5469 26.475 41.8719 26.8L33.1219 31.175C31.8469 31.825 31.0469 33.1 31.0469 34.525V42.8C31.0469 43.55 31.4219 44.225 32.0719 44.625C32.4219 44.85 32.7969 44.95 33.1969 44.95C33.5219 44.95 33.8469 44.875 34.1719 44.725L42.9219 40.35C44.1969 39.7 44.9969 38.425 44.9969 37V28.725C44.9969 27.975 44.6219 27.3 43.9719 26.9Z"
            fill="#59C6C9"
          />
        </svg>
      );

    default:
      return <div style={{ width: "fit-content" }}></div>;
  }
};

export default IconsGen;
